import "./UwPolicy.scss";
import AllFiles from "../../../components/allFiles/AllFiles.jsx";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
  CustomButtonSmall,
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import newRequest from "../../../utils/newRequest.js";
import UwPolicyCond from "../uwPolicyCond/UwPolicyCond.jsx";
import UwPolicyRisk from "../uwPolicyRisk/UwPolicyRisk.jsx";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination
} from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import EmailIcon from '@mui/icons-material/Email';
import moment from "moment";
import numeral from "numeral";
import { useEffect, useRef, useState } from "react";
import { FaArrowRight, FaSave } from "react-icons/fa";
import { IoClose, IoDocumentTextSharp, IoReceipt, IoChatbubbles, IoCheckmarkDoneOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import CreatableSelect from "react-select/creatable";
import AsyncCreatableSelect from "react-select/async-creatable";
import "react-loading-skeleton/dist/skeleton.css";
import { motion } from "framer-motion";
import Confetti from "react-confetti";
import { ScaleLoader } from "react-spinners";
import { addDaysToMongoDate, addMonthsToMongoDate, calculateYearsMonths, fetchClientsBySearch, fetchUsersBySearch, formatAmountsToDecimals, formatStringToNumberV2, formatTypeName, getCssValue, getFutureDay, getKeyInArray, logData, removeSpacesAndTabs, validateMotorVehicleRegn } from "../../../utils/genericFunctions.js";
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import { HiDocumentText } from "react-icons/hi2";
import Badge from '@mui/material/Badge';
import UwPolicyExcess from "../uwPolicyExcess/UwPolicyExcess.jsx";
import ValidationMessages from "../../../components/validationMessages/ValidationMessages.jsx";
import { MdAdd, MdClose, MdDelete, MdEditDocument, MdAlternateEmail, MdForum, MdOutlineMenuOpen, MdOutlineNumbers, MdPhone, MdSms } from "react-icons/md";
import EmailComponent from "../../../components/emailComponent/EmailComponent.jsx";
import DOMPurify from 'dompurify';
import FileUploadComponent from "../../../components/fileUploadComponent/FileUploadComponent.jsx";
import AllDocsNote from "../../../components/allDocsNote/AllDocsNote.jsx";
import Correspondence from "../../../components/correspondence/Correspondence.jsx";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { TbCertificate } from "react-icons/tb";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import UwPolicyInstallments from "../uwPolicyInstallments/UwPolicyInstallments.jsx";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import UwPolicyRead from "../uwPolicyRead/UwPolicyRead.jsx";
import { useTranslation } from "react-i18next";
import { RiArrowRightDoubleFill, RiAttachment2, RiBuilding2Fill, RiSkipRightLine, RiTeamFill } from "react-icons/ri";
import { CiImageOn } from "react-icons/ci";
import { LuClipboardType, LuRefreshCcw } from "react-icons/lu";
import ConfirmDialogThree from "../../../components/confirmDialogThree/confirmDialogThree.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import UwPolicyCharges from "../uwPolicyCharges/UwPolicyCharges.jsx";
import UwPolicyCommissions from "../uwPolicyCommissions/UwPolicyCommissions.jsx";
import { BsTextParagraph } from "react-icons/bs";
import { GrSync } from "react-icons/gr";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";
import Collaborator from "../../../components/Collaborator/Collaborator.jsx";

const UploadDialog = ({ open, handleClose, uploadProgress }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t('progress')}</DialogTitle>
      <DialogContent>
        <LinearProgress variant="determinate" value={uploadProgress} />
        {uploadProgress && <p>{uploadProgress}% {t('complete')}</p>}
      </DialogContent>
    </Dialog>
  );
};

const UwPolicy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const [isLoading, setIsLoading] = useState(false);
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [figuresToShow, setFiguresToShow] = useState("org");
  const [isConfettiActive, setIsConfettiActive] = useState(false);
  const [enablePolicyNo, setEnablePolicyNo] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [profileLimitValues, setProfileLimitValues] = useState([]);
  const limitsToCheck = ["UW1005", "UW1008", "UW1010", "UW1021", "UW1012", "UW1019", "UW1020", "UW1021", "UW1022", "UW1024", "UW1025", "UW1027", "UW1028", "UW1029", "UW1030", "UW1031"];
  const [activeTab, setActiveTab] = useState(0);
  const [policyRiskKey, setPolicyRiskKey] = useState(0);
  const [relatedDocuments, setRelatedDocuments] = useState([]);

  const [isCollabOpen, setIsCollabOpen] = useState(false);
  const openCollab = () => setIsCollabOpen(true);
  const closeCollab = () => setIsCollabOpen(false);
  const pageShellRef = useRef(null);
  const [collabRightOffset, setCollabRightOffset] = useState(0);

  const actionsRef = useRef(null);
  const expiringInRef = useRef(null);
  const policyRiskRef = useRef(null);
  const policyExcessRef = useRef(null);
  const policyChargesRef = useRef(null);
  const policyCondRef = useRef(null);
  const productRef = useRef(null);
  const specialNoteRef = useRef(null);
  const termRef = useRef(null);
  const participantRef = useRef(null);
  const opportunityNameRef = useRef(null);
  const vehicleInputRef = useRef(null);
  const expressInsuredRef = useRef(null);
  const expressCarrierRef = useRef(null);

  const [renStatusDialogOpened, setRenStatusDialogOpened] = useState(false);
  const [renewalStatuses, setRenewalStatuses] = useState([]);
  const [selectedRenStatus, setSelectedRenStatus] = useState(null);

  //  USED TO MONITOR CHANGE IN ID AND Re-RENDERS
  const { docid } = useParams();
  const [quoteId, setQuoteId] = useState(null);

  useEffect(() => {
    if (docid) {
      setQuoteId(docid);
    }
  }, [docid]);

  let generatedDocNo = "";
  // number generation
  const [numGeneration, setNumGeneration] = useState({});
  // get quote data
  const [quoteData, setQuoteData] = useState({});
  // let quoteData = {};
  const location = useLocation();
  const parts = location.pathname.split("/");
  // let quoteId = parts[parts.length - 1];
  const activityTypeRef = useRef(null);
  const insuredRef = useRef(null);

  const [expressSmis, setExpressSmis] = useState([]);
  const [seletedExpressSmi, setSeletedExpressSmi] = useState(null);
  const [seletedExpressInsured, setSeletedExpressInsured] = useState(null);
  const [seletedExpressCarrier, setSeletedExpressCarrier] = useState(null);

  const [showProjectInfo, setShowProjectInfo] = useState("N");
  const [plSubagentEntCode, setPlSubagentEntCode] = useState(null);
  const [plType, setPlType] = useState("RiskNote");
  const [manualPolicyNo, setManualPolicyNo] = useState("");
  const [isManualPolicyNo, setIsManualPolicyNo] = useState(false);
  const [plNo, setPlNo] = useState("");
  const [plRiskNoteNo, setPlRiskNoteNo] = useState(null);
  const [plPrimaryDoc, setPlPrimaryDoc] = useState(null);
  const [plQuoteNo, setPlQuoteNo] = useState("");
  const [plChannel, setPlChannel] = useState(null);
  const [plCurRate, setPlCurRate] = useState(1);
  const [plCurRateMd, setPlCurRateMd] = useState("M");
  const [plFmDate, setPlFmDate] = useState(null);
  const [plToDate, setPlToDate] = useState(null);
  const [plGlDate, setPlGlDate] = useState(null);
  const [daysDifference, setDaysDifference] = useState(0);
  const [daysDifferenceEnd, setDaysDifferenceEnd] = useState(0);
  const [plStatus, setPlStatus] = useState("New");
  const [plRemarks, setPlRemarks] = useState("");
  const [plRegnNo, setPlRegnNo] = useState("");
  const [documentEnabled, setDocumentEnabled] = useState("Y");
  const [saveEnabled, setSaveEnabled] = useState("Y");
  const [nextAction, setNextAction] = useState("None");
  const [plEndIndex, setPlEndIndex] = useState(0);
  const [plEndNo, setPlEndNo] = useState("New");
  const [plEndCode, setPlEndCode] = useState("");
  const [plEndName, setPlEndName] = useState("");
  const [plInternalEndCode, setPlInternalEndCode] = useState("");
  const [businessType, setBusinessType] = useState("New Business");

  const [plBank, setPlBank] = useState(null);
  const [plBankBranch, setPlBankBranch] = useState(null);
  const [plBankAcName, setPlBankAcName] = useState(null);
  const [plBankAcNo, setPlBankAcNo] = useState(null);
  const [plBankSwiftcode, setPlBankSwiftcode] = useState(null);

  const [plTermCode, setPlTermCode] = useState(null);
  const [plTermPaymentFreq, setPlTermPaymentFreq] = useState(null);
  const [plPayDay, setPlPayDay] = useState(null);
  const [plTermYears, setPlTermYears] = useState(1);
  const [plInstConfirmed, setPlInstConfirmed] = useState("N");
  const [plPaymentMode, setPlPaymentMode] = useState(null);
  const [plConveyance, setPlConveyance] = useState(null);
  const [plOwner, setPlOwner] = useState(null);
  const [plOpName, setPlOpName] = useState("");
  const [plOpMethod, setPlOpMethod] = useState(null);
  const [plOpPriority, setPlOpPriority] = useState(null);
  const [plOpSource, setPlOpSource] = useState(null);
  const [plOpEmail, setPlOpEmail] = useState("");
  const [plOpPhoneNo, setPlOpPhoneNo] = useState("");
  const [plWinProbability, setPlWinProbability] = useState(0);
  const [plOpContacts, setPlOpContacts] = useState([]);
  const [plOpActivities, setPlOpActivities] = useState([]);
  const [plOpTeam, setPlOpTeam] = useState([]);
  const [plParticipants, setPlParticipants] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState(null);

  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);

  const [activityName, setActivityName] = useState("");
  const [activityType, setActivityType] = useState(null);
  const [activityDate, setActivityDate] = useState(null);
  const [activityVenue, setActivityVenue] = useState("");
  const [activityReminderDays, setActivityReminderDays] = useState(0);
  const [activityDone, setActivityDone] = useState("N");
  const [activityUsers, setActivityUsers] = useState([]);
  const [isAddTaskDialogOpen, setIsAddTaskDialogOpen] = useState(false);

  const [plLimits, setPlLimits] = useState([]);
  const [selectedLimit, setSelectedLimit] = useState(null);
  const [plBenefits, setPlBenefits] = useState([]);
  const [selectedBenefit, setSelectedBenefit] = useState(null);
  const [addLimitText, setAddLimitText] = useState("");
  const [addLimitAmount, setAddLimitAmount] = useState("");
  const [addBenefitText, setAddBenefitText] = useState("");
  const [addBenefitAmount, setAddBenefitAmount] = useState("");
  const limitTextRef = useRef(null);
  const limitAmountRef = useRef(null);
  const benefitTextRef = useRef(null);
  const benefitAmountRef = useRef(null);

  const [plJurisdiction, setPlJurisdiction] = useState(null);
  const [plTerritory, setPlTerritory] = useState(null);

  // Tender Information
  const [plTenderInfo, setPlTenderInfo] = useState({
    is_tender: "N",
    tender_no: "",
    bid_security_required: "N",
    tender_type: "Open",
    title: "",
    description: "",
    issuing_authority: "",
    issuing_country: "",
    publication_date: null,
    submission_deadline: null,
    opening_date: null,
    closing_date: null,
    estimated_value: 0,
    currency: "",
    submission_method: "",
    submission_url: "",
    tender_documents: [],
    eligibility_criteria: "",
    evaluation_criteria: "",
    contact_person: {
      name: "",
      email: "",
      phone: ""
    },
    status: "Draft",
    awarded_to: "",
    award_date: null
  });

  // tender information
  const [plProjectInfo, setPlProjectInfo] = useState({
    project_no: "",
    project_title: "",
    project_description: "",
    principal_client: "",
    project_fm: null,
    project_to: null,
    warranty_fm: null,
    warranty_to: null,
    maintenance_fm: null,
    maintenance_to: null,
    project_status: "New"
  });

  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailData, setEmailData] = useState(null);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);

  const actionsMenuRef = useRef(null);

  // vehicle registration validation
  const [vehicleDialogOpen, setVehicleDialogOpen] = useState(false);
  const [vehicleProceedButton, setVehicleProceedButton] = useState(false);
  const [vehicleCheckTitle, setVehicleCheckTitle] = useState("Check");
  const [vehicleDialogTitle, setVehicleDialogTitle] = useState("Confirm");
  const [vehicleResultView, setVehicleResultView] = useState("None");
  const [vehicleDialogRegnNo, setVehicleDialogRegnNo] = useState("");
  const [vehicleMatchingRisks, setVehicleMatchingRisks] = useState([]);

  const [vehiclePage, setVehiclePage] = useState(0);
  const [vehicleRowsPerPage, setVehicleRowsPerPage] = useState(5);

  const [validationMsgDialog, setValidationMsgDialog] = useState(false);
  const [validationMessagesResult, setValidationMessagesResult] = useState({});

  // endorsement
  const [endDialogOpen, setEndDialogOpen] = useState(false);
  const [productEnds, setProductEnds] = useState([]);
  const [selectedProductEnd, setSelectedProductEnd] = useState(null);
  const [endorsementDesc, setEndorsementDesc] = useState("");
  const [endorsementGlDate, setEndorsementGlDate] = useState(new Date());
  const [endorsementFmDate, setEndorsementFmDate] = useState(new Date());
  const [endorsementToDate, setEndorsementToDate] = useState(new Date());
  const [expiringInMenuOpen, setExpiringInMenuOpen] = useState(false);
  const [toggleEndorsementFmDate, setToggleEndorsementFmDate] = useState(false);
  const [toggleEndorsementToDate, setToggleEndorsementToDate] = useState(false);
  const [toggleEndorsementGlDate, setToggleEndorsementGlDate] = useState(false);

  const [endorsementFmTitle, setEndorsementFmTitle] = useState("ENDORSEMENT EFFECTIVE DATE");
  const [endorsementToTitle, setEndorsementToTitle] = useState("TO");

  const customNoOptionsMessage = (customMessage, newEntity, showCreate = "N") => {
    return (
      <span className="custom-message" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
        <span> {customMessage}</span>
        {showCreate === "Y" &&
          <CustomButtonSmall
            currentTheme={currentTheme}
            onClick={() => navigate("/entity/new")}
            width={"max-content"}
          >
            {newEntity}
          </CustomButtonSmall>}
      </span>
    );
  };
  const [banks, setBanks] = useState(null);
  const [bankBranches, setBankBranches] = useState(null);
  const [specialNote, setSpecialNote] = useState("");
  const [specialNotes, setSpecialNotes] = useState([]);
  const [basisOfClaim, setBasisOfClaim] = useState("");
  const [plClaimBasis, setPlClaimBasis] = useState([]);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [receiptOpen, setReceiptOpen] = useState(false);
  const [selectedReceiptPaidTo, setSelectedReceiptPaidTo] = useState({
    label: "Paid To Carrier",
    value: "ToCarrier",
  });
  const [receiptPaidToOptions, setReceiptPaidToOptions] = useState([
    // { label: "Paid To Us", value: "ToUs" },
    { label: "Paid To Carrier", value: "ToCarrier" },
    { label: "Paid To Sub Agent", value: "ToSubAgent" },
  ]);
  const [selectedReceiptMode, setSelectedReceiptMode] = useState({
    label: "Unspecified",
    value: "Unspecified",
  });
  const [receiptModeOptions, setReceiptModeOptions] = useState([]);
  const [tenderTypes, setTenderTypes] = useState([]);
  const [submissionMethods, setSubmissionMethods] = useState([]);
  const [quoteMethods, setQuoteMethods] = useState([]);
  const [quoteSources, setQuoteSources] = useState([]);
  const [conveyanceList, setConveyanceList] = useState([]);
  const [channels, setChannels] = useState([]);
  const [policyClaimsList, setPolicyClaimsList] = useState([]);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [installments, setInstallments] = useState([]);
  const [receiptDate, setReceiptDate] = useState(null);
  const [receiptNo, setReceiptNo] = useState("");
  const [receiptCurrency, setReceiptCurrency] = useState("");
  const [receiptAmountFc, setReceiptAmountFc] = useState(null);
  const [receiptAmountLc, setReceiptAmountLc] = useState(null);
  const [maxMatchFcAmount, setMaxMatchFcAmount] = useState(null);
  const [maxMatchLcAmount, setMaxMatchLcAmount] = useState(null);

  const saveRisksInParent = () => {
    try {
      if (policyRiskRef.current) {
        policyRiskRef.current.saveRisksAndSmisFromParent();
      }
      if (policyExcessRef.current) {
        policyExcessRef.current.saveExcessFromParent();
      }

      if (policyCondRef.current) {
        policyCondRef.current.saveConditionsFromParent();
      }

      if (policyChargesRef.current) {
        policyChargesRef.current.saveChargesFromParent();
      }
    } catch (error) {
      console.log(error)
    }
  };

  const handlePassEndorsement = async () => {
    try {

      // 000 New Business
      // 100 Additional Premium
      // 200 Refund
      // 300 General Endorsement
      // 400 Period Extension
      // 500 Period Reduction
      // 600 Renewal
      // 700 Cancellation
      // 800 Reinstatement
      // 900 Lapse

      if (!["300"].includes(selectedProductEnd?.pe_internal_code)) {
        // check if period is open
        // console.log(`endorsementGlDate ${endorsementGlDate}`);
        const res = await newRequest.post("/glCp/periodStatus", { cp_cy_type: "Underwriting", gl_date: endorsementGlDate });
        // console.log(`glCp/periodStatus  ${JSON.stringify(res.data, null, 2)}`);
        if (res.data?.cp_status === "Closed") {
          setIsConfirmDialogOpen(false);
          setConfirmDialogAction("None");
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(
            `${formatTypeName(plType)} date ${moment(endorsementGlDate).format(
              "DD-MMM-YYYY"
            )} is within Underwriting period ${res.data?.cp_code
            }. The period is <b>${res.data?.cp_status
            }</b>. Open the period to be able to Approve.`
          );
          setIsNotifyDialogOpen(true);
          return;
        }
      }


      // pass endorsement
      const end_res = await newRequest.post(
        "/uwPolicy/end",
        {
          source_policy_docid: quoteData?._id,
          endorsement_no: quoteData?.pl_risk_note_no,
          endorsement_code: selectedProductEnd?.pe_end_code,
          internal_end_code: selectedProductEnd?.pe_internal_code,
          new_status: "New",
          pe_policy_no: quoteData?.pl_no,
          pe_gl_date: endorsementGlDate,
          pe_fm_date: endorsementFmDate,
          pe_to_date: endorsementToDate,
          pe_remarks: endorsementDesc
        }
      );
      // console.log(`data load  ${JSON.stringify(end_res.data, null, 2)}`);
      // set quote data to blank so that when we set the data BsAirplaneEngines, UwPolicyRisk Component will re-render
      setQuoteData({});
      setEndDialogOpen(false);
      setQuoteId(end_res.data?._id);
      await fetchQuote();
      setPolicyRiskKey(prevKey => prevKey + 1);
      navigate(`/uw/${plType?.toLowerCase()}/${end_res.data?._id}`, { replace: true });
      // showToast(`Endorsement ${end_res.data?.pl_end_no} Passed!`, "success");
    } catch (error) {
      console.log(error);
    }
  };

  // Duplicate vehicle
  const [rowsPerPageVehicles, setRowsPerPageVehicles] = useState(3);
  const [currentVehiclesPage, setCurrentVehiclesPage] = useState(0);

  const handleVehiclesPageChange = (event, newPage) => {
    setCurrentVehiclesPage(newPage);
  };
  const slicedVehicles = vehicleMatchingRisks?.slice(
    currentVehiclesPage * rowsPerPageVehicles,
    currentVehiclesPage * rowsPerPageVehicles + rowsPerPageVehicles
  );
  const handleVehiclesRowsPerPage = (event) => {
    setRowsPerPageVehicles(parseInt(event.target.value, 3));
    setCurrentVehiclesPage(0);
  };

  // deal with dates
  const handleEndGlDateChange = (e) => {
    try {
      if (e.target.value) {
        const formattedGlDate = moment(e.target.value).format("YYYY-MM-DD");
        setEndorsementGlDate(formattedGlDate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBanks = async () => {
    try {
      const res = await newRequest.post("/glBank/findAll");
      const options = res.data?.map((bk) => ({
        branches: bk.bk_branches,
        value: bk.bk_code,
        label: bk.bk_name,
      }));
      // Flatten all branches into one array
      const branchOptions = res.data
        ?.flatMap((bk) => bk.bk_branches)
        ?.map((br) => ({
          value: br.branch_code,
          label: br.branch_name,
        }));

      // Set state
      setBanks(options);
      setBankBranches(branchOptions);
    } catch (error) {
      console.error("Error fetching policy claims list:", error);
    }
  };

  const fetchSpecialNotes = async (docId, noteType) => {
    try {
      const res = await newRequest.post("/allDocsNote/findAll", {
        note_docid: docId,
        note_type: noteType
      });
      setSpecialNotes(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  // deal with dates
  const handleEndFmDateChange = (e) => {
    try {
      if (e.target.value) {
        const formattedFmDate = moment(e.target.value).format("YYYY-MM-DD");
        setEndorsementFmDate(formattedFmDate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [jurisdictions, setJurisdictions] = useState([]);
  const fetchJurisdictions = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Jurisdictions", });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setJurisdictions(options);
    } catch (error) {
      console.error("Error fetching jurisdictions :", error);
    }
  };

  const handleEndToDateChange = (e) => {
    try {
      if (e.target.value) {
        const formattedToDate = moment(e.target.value).format("YYYY-MM-DD");
        setEndorsementToDate(formattedToDate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProductEnds = async () => {
    try {
      const res = await newRequest.post(
        "/uwProductEnd/findByStatus",
        {
          pe_org_code: quoteData?.pl_org_code,
          pe_pr_code: quoteData?.pl_product_code,
          doc_status: quoteData?.pl_status,
        },
      );

      const options = res.data
        ?.filter((end) => end?.pe_internal_code !== "000")
        .map((end) => ({
          pe_end_code: end?.pe_end_code,
          pe_name: end?.pe_name,
          pe_desc: end?.pe_desc,
          pe_internal_code: end?.pe_internal_code,
          pe_icon: end?.pe_icon,
          value: end?.pe_end_code,
          // label: end?.pe_name,
          label: (
            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
              <h1 className="endorsement-name">{end?.pe_name}</h1>
              <p className="endorsement-desc">{end?.pe_desc}</p>
            </div>
          )
        }));
      setProductEnds(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchReceiptMode = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Receipt Mode" });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setReceiptModeOptions(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  const fetchTenderTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Tender Types" });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setTenderTypes(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  const fetchSubmissionMethods = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Tender Submission Methods" });
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setSubmissionMethods(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  const fetchQuoteMethods = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Quote Methods" });
      const options = res.data?.map((stage) => ({
        value: stage?.sys_code,
        label: stage?.sys_name,
      }));
      setQuoteMethods(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchRenewalStatuses = async () => {
    try {
      const options = ["Renew", "Do NOT Renew"]?.map((val) => ({
        value: val,
        label: val,
      }));
      setRenewalStatuses(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchQuoteSources = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Quote Sources" });
      const options = res.data?.map((stage) => ({
        value: stage?.sys_code,
        label: stage?.sys_name,
      }));
      setQuoteSources(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const fetchConveyance = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Shipping Mode" });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setConveyanceList(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchChannels = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Channel Type" });
      // console.log(`fetchChannels  ${JSON.stringify(res.data, null, 2)}`);
      const options = res.data?.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));

      setChannels(options);

      // if new document, set default channel
      // console.log(`token_org_type ... ${currentUser?.token_org_type}`);
      // console.log(`quoteId ... ${quoteId}`);
      // console.log(`options  ${JSON.stringify(options, null, 2)}`);
      if (quoteId === "new") {
        if (currentUser?.token_org_type === "insurance") {
          setPlChannel({
            value: "1001",
            label: options.find(l => l.value === "1001")?.label,
          });
        } else if (currentUser?.token_org_type === "broker") {
          setPlChannel({
            value: "1001",
            label: options.find(l => l.value === "1001")?.label,
          });
        } else if (currentUser?.token_org_type === "agent") {
          setPlChannel({
            value: "1002",
            label: options.find(l => l.value === "1002")?.label,
          });
        }
      }

    } catch (error) {
      console.error("Error fetching channels :", error);
    }
  };


  const fetchPolicyClaimsList = async (policyNo) => {
    try {

      const res = await newRequest.post("/cmClaim/findByPolicy", {
        cm_policy_no: policyNo,
      });

      setPolicyClaimsList(res.data);
    } catch (error) {
      console.error("Error fetching policy claims list :", error);
    }
  };


  const fetchPolicyInstallments = async () => {
    try {
      const res = await newRequest.post("/uwPolicy/osInstallment", { policy_docid: quoteId });
      const options = res.data.map((ins) => ({
        ins_fc_amount: ins.ins_fc_amount,
        ins_lc_amount: ins.ins_lc_amount,
        os_fc_amount_xx: ins.os_fc_amount_xx,
        os_lc_amount_xx: ins.os_lc_amount_xx,
        value: ins.ins_no,
        label: ins.fmt_ins_date_xx,
      }));
      setInstallments(options);
      setSelectedInstallment(options[0]);
    } catch (err) {
      console.log(err);
    }
  };


  // receipt date
  const handleReceiptDateChange = (e) => {
    try {
      if (e.target.value) {
        const formattedFromDate = moment(e.target.value).format("YYYY-MM-DD");
        setReceiptDate(formattedFromDate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddReceipt = async () => {
    try {
      // check nulls before proceeding

      if (!selectedReceiptPaidTo) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select <b>PAID TO</b>`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!selectedReceiptMode?.value) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select <b>RECEIPT MODE</b>`);
        setIsNotifyDialogOpen(true);
        return;
      }


      if (!receiptNo) {
        if (selectedReceiptPaidTo?.value !== "ToUs") {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please enter <b>RECEIPT NUMBER</b>`);
          setIsNotifyDialogOpen(true);
          return;
        }
      }

      if (!receiptDate || isNaN(new Date(receiptDate).getTime())) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter <b>RECEIPT DATE</b>`);
        setIsNotifyDialogOpen(true);
        return;
      }


      if (!receiptAmountFc) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter <b>RECEIPT AMOUNT</b>`);
        setIsNotifyDialogOpen(true);
        return;
      }

      // check a document cannot be over matched
      if (receiptAmountFc > quoteData?.total_os_fc_amount) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(
          `Total Outstanding is <b>${plCurCode?.value} ${numeral(
            quoteData.total_os_fc_amount
          ).format(
            "0,0.00"
          )}</b>. You CANNOT receipt more than this amount`
        );
        setIsNotifyDialogOpen(true);
        return;
      }

      if (selectedReceiptPaidTo?.value === "ToUs") {
        // check if period is open
        const formattedGlDate = moment(receiptDate).format("YYYY-MM-DD");
        const res = await newRequest.post("/glCp/periodStatus", { cp_cy_type: "Financial", gl_date: formattedGlDate });
        if (res.data?.cp_status === "Closed") {
          setIsConfirmDialogOpen(false);
          setConfirmDialogAction("None");
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(
            `${formatTypeName(plType)} date <b>${moment(receiptDate).format(
              "DD-MMM-YYYY"
            )}</b> is within Financial period <b>${res.data?.cp_code
            }</b>. The period is <b>${res.data?.cp_status
            }</b>. Open the period to allow receipting.`
          );
          setIsNotifyDialogOpen(true);
          return;
        }

        // check installment
        if (!selectedInstallment) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please select <b>INSTALLMENT</b>`);
          setIsNotifyDialogOpen(true);
          return;
        }

        setObjectToAction({
          object_id: quoteData._id,
          action_text: `Please note that Receipts <b>PAID TO US</b> will also be added in Finance. Do you want to proceed?`,
        });
        setConfirmDialogAction("paidToUsReceipt");
        setIsConfirmDialogOpen(true);
      } else {
        createReceipt(null);
        // reset receipt fields
        setReceiptDate(null);
        setReceiptNo("");
        setReceiptCurrency(null);
        setReceiptAmountFc(null);
        setReceiptAmountLc(null);
        setReceiptOpen(false);
        refreshQuote();
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleDocumentLimitChange = (value, rowId, field) => {
    setPlLimits((prev) =>
      prev.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleDocumentBenefitChange = (value, rowId, field) => {
    setPlBenefits((prev) =>
      prev.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleBenefitBlur = (id, field) => {
    try {
      const updatedData = [...plBenefits];
      const index = updatedData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        const value = updatedData[index][field];
        if (field === "benefit_amount" && !isNaN(value) && value !== null && value !== "") {
          updatedData[index][field] = formatNumber(formatStringToNumberV2(value), 2);
        } else {
          updatedData[index][field] = value;
        }
        updatedData[index]["changed_xx"] = "Y";
        setPlBenefits(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };



  const createReceipt = async (passedReceiptNo) => {
    try {
      // create receipt
      await newRequest.post("/uwPolicy/addReceipt", {
        receipt_risk_note_no: plRiskNoteNo,
        receipt_policy_docid: quoteId,
        receipt_no: passedReceiptNo || receiptNo,
        receipt_mode: selectedReceiptMode.value,
        receipt_date: receiptDate,
        receipt_currency: receiptCurrency,
        receipt_installment_no: selectedInstallment?.value,
        receipt_fc_amount: parseFloat(formatStringToNumberV2(receiptAmountFc || 0, 2)),
        receipt_lc_amount: parseFloat(formatStringToNumberV2(receiptAmountLc || 0, 2)),
        receipt_paid_to: selectedReceiptPaidTo.value
      });

      await newRequest.post("/trace/add", {
        trc_action_on: "Document",
        trc_doc_type: quoteData?.pl_type,
        trc_doc_no: quoteData?.pl_risk_note_no,
        trc_aent_code: "",
        trc_ent_code: "",
        trc_action: `added receipt on ${quoteData?.pl_type}`,
        trc_remarks: `added receipt ${receiptNo} of ${receiptCurrency} ${receiptAmountFc}`,
        trc_tags: ["added receipt"],
        trc_doc_docid: quoteData._id
      });


      // if receipt is paid to useEffect, add in finance
      if (selectedReceiptPaidTo.value === "ToUs") {
        try {
          //prepare data
          const res = await newRequest.post(
            "/arReceiptHdr/add",
            {
              hd_no: passedReceiptNo || receiptNo,
              hd_narration: `Premium Receipt Issued by ${currentUser.usr_full_name} from Underwriting`,
              hd_ref_no: quoteData?.pl_risk_note_no,
              hd_ac_no: "01161", //get default account number
              hd_biz_unit: selectedBranch?.value,
              hd_gl_date: receiptDate,
              hd_cur_code: receiptCurrency,
              hd_cur_rate: plCurRate,
              hd_mode: selectedReceiptMode.value,
              hd_status: "Approved",
              hd_paying_for: "Premium",
              hd_aent_code: selectedInsured?.ent_aent_code,
              hd_ent_code: selectedInsured?.ent_code,
              hd_chq_no: "",
              hd_chq_bank: "",
              hd_chq_date: "",
              hd_fc_amount: receiptAmountFc,
              hd_lc_amount: receiptAmountLc,
            }
          );

          // console.log(`arReceiptHdr  ${JSON.stringify(res.data, null, 2)}`);

          // add receipt line
          await newRequest.post(
            "/arReceiptLn/add",
            {
              ln_org_code: currentUser.usr_org_code,
              ln_hd_no: passedReceiptNo || receiptNo,
              ln_hd_no_docid: res.data?._id,
              ln_hd_status: res.data?.hd_status,
              ln_doc_type: plType,
              ln_doc_no: quoteData?.pl_risk_note_no,
              ln_doc_docid: quoteData._id,
              ln_fc_amount: receiptAmountFc,
              ln_lc_amount: receiptAmountLc,
              ln_doc_ins_no: selectedInstallment?.value,
              ln_narration: "Matched",
              ln_insured_ent_code: selectedInsured?.ent_code,
              ln_carrier_ent_code: selectedCarrier?.ent_code,
            }
          );
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // confirm dialog
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
    action: "",
  });
  const [invokedAction, setInvokedAction] = useState("");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isThreeButtonDialogOpen, setIsThreeButtonDialogOpen] = useState(false);

  const [buttonOneTitle, setButtonOneTitle] = useState("");
  const [buttonTwoTitle, setButtonTwoTitle] = useState("");
  const [buttonThreeTitle, setButtonThreeTitle] = useState("");

  // attachments
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const fetchDocumentAttachments = async (docType, policyDocid) => {
    try {
      const res = await newRequest.post("/files/findDocFiles", {
        fl_org_code: currentUser.usr_org_code,
        fl_doc_type: docType,
        fl_parent_doc_id: policyDocid,
      });
      setAttachmentsData(res.data);
    } catch (err) {
      console.log(err);
    }
  };


  const updateTenderField = (field, value) => {
    setPlTenderInfo(prev => ({ ...prev, [field]: value }));
  };

  const updateProjectField = (field, value) => {
    setPlProjectInfo(prev => ({ ...prev, [field]: value }));
  };

  const fetchQuote = async (firstTime = false) => {
    try {
      if (!quoteId) {
        return;
      }

      if (firstTime) {
        setIsLoading(true);
      }
      // console.log(`quoteId  ${quoteId} and quoteData._id ${quoteData._id}`);
      if (quoteId === "new" && quoteData._id) {
        // quoteId = quoteData._id;
        setQuoteId(quoteData._id);
      }
      // console.log(`new quoteId  ${quoteId}`);

      const res = await newRequest.get(`/uwPolicy/findById/${quoteId}`);

      setQuoteData(res.data);

      // console.log(`setQuoteData  ${JSON.stringify(res.data, null, 2)}`);

      // only fetch if policy not approved
      if (res.data?.pl_status === "New") {
        await fetchProducts();
        await fetchCurrencies();
        await fetchBranches();
        await fetchQuoteStages();
        await fetchPaymentFreqs();
        await fetchPaymentModes();
        await fetchBanks();
        await fetchQuoteMethods();
        await fetchQuoteSources();
        await fetchPriorityLevels();
        await fetchAccountRoles();
        await fetchActivityTypes();
        await fetchTenderTypes();
        await fetchSubmissionMethods();
        await fetchConveyance();
        await fetchJurisdictions();
      }

      await fetchReceiptMode();

      //set Other values not associated with dropdown

      if (res.data?.pl_no) {
        setEnablePolicyNo(false)
        setPlNo(res.data?.pl_no);
        await fetchPolicyClaimsList(res.data?.pl_no);
      } else {
        setEnablePolicyNo(true)
      }

      setPlRiskNoteNo(res.data?.pl_risk_note_no);
      setPlPrimaryDoc(res.data?.pl_primary_doc);
      setPlQuoteNo(res.data?.pl_quote_no);
      setPlStatus(res.data?.pl_status);
      setPlCurRate(res.data?.pl_cur_rate);
      setPlCurRateMd(res.data?.pl_cur_rate_md);


      if (res.data?.pl_gl_date) {
        const formattedGlDate = moment(res.data?.pl_gl_date).format("YYYY-MM-DD");
        setPlGlDate(formattedGlDate);
      }

      if (res.data?.pl_fm_date) {
        const formattedFmDate = moment(res.data?.pl_fm_date).format("YYYY-MM-DD");
        setPlFmDate(formattedFmDate);
      }

      if (res.data?.pl_to_date) {
        const formattedToDate = moment(res.data?.pl_to_date).format("YYYY-MM-DD");
        setPlToDate(formattedToDate);
      }

      if (res.data?.pl_fm_date && res.data?.pl_to_date) {
        calculateDateDifference(res.data?.pl_fm_date, res.data?.pl_to_date);
      }

      if (res.data?.pl_claim_basis) {
        setPlClaimBasis(res.data?.pl_claim_basis);
      }

      if (res.data?.pl_assr_ent_code) {
        setSelectedInsured({
          ent_docid: res.data?.insured_details_xx._id,
          ent_email: res.data?.insured_details_xx.ent_email,
          ent_phone_no: res.data?.insured_details_xx.ent_phone_no,
          ent_photo_url: res.data?.insured_details_xx.ent_photo_url,
          ent_status: res.data?.insured_details_xx.ent_status,
          aent_name_xx: res.data?.insured_details_xx.aent_name_xx,
          ent_code: res.data?.pl_assr_ent_code,
          ent_aent_code: res.data?.pl_assr_aent_code,
          ent_name: res.data?.insured_details_xx.ent_name,
          value: res.data?.pl_assr_ent_code,
          label: res.data?.insured_details_xx.ent_name,
        });
      }

      if (res.data?.pl_ins_ent_code) {
        setSelectedCarrier({
          ent_email: res.data?.carrier_details_xx.ent_email,
          ent_phone_no: res.data?.carrier_details_xx.ent_phone_no,
          ent_photo_url: res.data?.carrier_details_xx.ent_photo_url,
          ent_status: res.data?.carrier_details_xx.ent_status,
          aent_name_xx: res.data?.carrier_details_xx.aent_name_xx,
          ent_code: res.data?.pl_ins_ent_code,
          ent_aent_code: res.data?.pl_ins_aent_code,
          ent_name: res.data?.carrier_details_xx.ent_name,
          value: res.data?.pl_ins_ent_code,
          label: res.data?.carrier_details_xx.ent_name,
        });
      }


      if (res.data?.pl_interest_ent_code) {
        setSelectedFinancier({
          ent_email: res.data?.financier_details_xx.ent_email,
          ent_phone_no: res.data?.financier_details_xx.ent_phone_no,
          ent_photo_url: res.data?.financier_details_xx.ent_photo_url,
          ent_status: res.data?.financier_details_xx.ent_status,
          aent_name_xx: res.data?.financier_details_xx.aent_name_xx,
          ent_code: res.data?.pl_interest_ent_code,
          ent_aent_code: res.data?.financier_details_xx.ent_aent_code,
          ent_name: res.data?.financier_details_xx.ent_name,
          value: res.data?.pl_interest_ent_code,
          label: res.data?.financier_details_xx.ent_name,
        });
      }

      if (res.data?.pl_product_code) {

        await fetchProductTerms(res.data?.pl_product_code);
        // UW1005 - User can create entity from underwriting
        // UW1008 - User allowed to change commission rate
        // UW1010 - User allowed to add receipt
        // UW1021 - User can override exchange rate
        // get profile limit values
        const limits = await newRequest.post("/adProfile/checkValues", { module_code: res.data?.pl_product_code, limit_codes: limitsToCheck });
        setProfileLimitValues(limits.data)
        setSelectedProduct({
          product_type_xx: res.data?.product_type_xx,
          pr_code: res.data?.pl_product_code,
          pr_name: res.data?.product_name_xx,
          pr_period_type: res.data?.product_period_type_xx,
          pr_cash_carry: res.data?.product_cash_carry_xx,
          pr_onetime: res.data?.product_onetime_xx,
          pr_motor: res.data?.product_motor_xx,
          value: res.data?.pl_product_code,
          label: res.data?.product_name_xx,
        });
      }

      setPlCurCode({
        value: res.data?.pl_cur_code,
        label: res.data?.currency_xx,
      });

      setPlJurisdiction({
        value: res.data?.pl_jurisdiction,
        label: res.data?.pl_jurisdiction,
      });

      setPlTerritory({
        value: res.data?.pl_territory,
        label: res.data?.pl_territory,
      });


      setPlChannel({
        value: res.data?.pl_channel,
        label: res.data?.pl_channel_xx,
      });

      if (res.data?.pl_biz_unit) {
        setSelectedBranch({
          unit_code: res.data?.pl_biz_unit,
          unit_name: res.data?.bizunit_name_xx,
          unit_type: res.data?.bizunit_type_xx,
          value: res.data?.pl_biz_unit,
          label: res.data?.bizunit_name_xx,
        });
      }

      if (res.data?.pl_quote_stage) {
        setPlQuoteStage({
          value: res.data?.pl_quote_stage,
          label: res.data?.quote_stage_xx,
        });
      }

      setPlRemarks(res.data?.pl_remarks);
      setPlRegnNo(res.data?.pl_regn_no);
      setDocumentEnabled(res.data?.document_enabled_xx);
      setSaveEnabled(res.data?.save_enabled_xx);
      setNextAction(res.data?.next_action_xx);

      setShowProjectInfo(res.data?.project_info_xx);

      setPlSubagentEntCode(res.data?.pl_subagent_ent_code);

      // set current term
      setPlTermCode({
        value: res.data?.pl_term_code,
        label: res.data?.pl_term_code_xx?.term_name,
        term_years: res.data?.pl_term_code_xx?.term_years,
      });

      setPlTermPaymentFreq({
        value: res.data?.pl_term_payment_freq,
        label: res.data?.life_term_payment_freq_xx,
      });

      setPlPaymentMode({
        value: res.data?.pl_payment_mode,
        label: res.data?.pl_payment_mode_xx,
      });

      setPlConveyance({
        value: res.data?.pl_conveyance,
        label: res.data?.pl_conveyance,
      });

      setPlBank({
        value: res.data?.pl_bank,
        label: res.data?.pl_bank_xx,
      });

      setPlBankBranch({
        value: res.data?.pl_bank_branch,
        label: res.data?.pl_bank_branch_xx,
      });

      setPlBankAcName(res.data?.pl_bank_ac_name);
      setPlBankAcNo(res.data?.pl_bank_ac_no);
      setPlBankSwiftcode(res.data?.pl_bank_swiftcode);
      setPlOwner(res.data?.pl_owner);
      setPlOpName(res.data?.pl_op_name);
      setPlOpMethod({
        value: res.data?.pl_op_method,
        label: res.data?.pl_op_method_xx
      });
      setPlOpPriority({
        value: res.data?.pl_op_priority,
        label: res.data?.pl_op_priority_xx
      });
      setPlOpSource({
        value: res.data?.pl_op_source,
        label: res.data?.pl_op_source_xx
      });

      setPlOpEmail(res.data?.pl_op_email);
      setPlOpPhoneNo(res.data?.pl_op_phone_no);
      setPlWinProbability(res.data?.pl_win_probability);
      setPlOpContacts(res.data?.pl_op_contacts);
      setPlOpActivities(res.data?.pl_op_activities);
      setPlOpTeam(res.data?.pl_op_team);
      setPlParticipants(res.data?.pl_participants);

      setPlTermYears(res.data?.pl_term_years);
      setPlPayDay(res.data?.pl_pay_day);
      setPlEndIndex(res.data?.pl_end_index);
      setPlEndNo(res.data?.pl_end_no);
      setPlInstConfirmed(res.data?.pl_inst_confirmed);

      setPlEndCode(res.data?.pl_end_code);
      setPlEndName(res.data?.end_name_xx);
      setPlInternalEndCode(res.data?.pl_internal_end_code);
      setBusinessType(res.data?.end_name_xx);
      setPlType(res.data?.pl_type);

      // tender info
      setPlTenderInfo(res.data?.pl_tender_info);
      // project info
      setPlProjectInfo(res.data?.pl_project_info);

      setPlLimits(res.data?.pl_limits || []);
      setPlBenefits(res.data?.pl_benefits || []);

      // fetch attachements
      await fetchDocumentAttachments(res.data?.pl_type, res.data?._id);
      fetchSpecialNotes(res.data?._id, "Special");

      // fetch related documents
      fetchRelatedDocuments(res.data?.pl_risk_note_no, res.data?.pl_primary_doc, res.data?.pl_type);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRelatedDocuments = async (currentRiskNoteNo, primaryDocument, plType) => {
    try {
      const res = await newRequest.post("/uwPolicy/relatedDocs", {
        current_risknote_no: currentRiskNoteNo,
        pl_type: plType,
        primary_doc: primaryDocument
      });
      setRelatedDocuments([]);
      // console.log(`fetchRelatedDocuments  ${JSON.stringify(res.data, null, 2)}`);
      setRelatedDocuments(res.data);
    } catch (err) {
      console.log(err);
    }
  };


  // fetch number generation code
  const fetchNumberGeneration = async (type) => {
    try {
      const res = await newRequest.post("/orgNumgen/find", { gen_type: type });
      setNumGeneration(res.data);
      // isDocumentNumberSetup = true;
    } catch (err) {
      console.log(err);
    }
  };

  const handleDocumentChange = (field, value) => {
    setQuoteData((prev) => {
      return { ...prev, [field]: value };
    });
  };

  const [selectedFinancier, setSelectedFinancier] = useState(null);
  const [selectedCarrier, setSelectedCarrier] = useState(null);
  const [selectedInsured, setSelectedInsured] = useState(null);
  const fetchEntityBySearch = async (inputValue, callback) => {
    try {
      const res = await newRequest.post("/allEntity/search", { search_input: inputValue, ent_status: "", ent_aent_code: "" });
      const options = res.data?.map((entity) => ({
        ent_email: entity?.ent_email,
        ent_phone_no: entity?.ent_phone_no,
        ent_photo_url: entity?.ent_photo_url,
        ent_status: entity?.ent_status,
        aent_name_xx: entity?.aent_name_xx,
        ent_code: entity.ent_code,
        ent_aent_code: entity.ent_aent_code,
        ent_name: entity.ent_name,
        value: entity.ent_code,
        label: (
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
            {entity.ent_name}
            {entity.ent_status !== "Active" && (
              <span style={{ color: "gray" }}> [{entity.ent_status}]</span>
            )}
          </div>
        ),
        isDisabled: entity.ent_status !== "Active"
      }));

      if (res.data?.length === 0) {
        // No results found
        const noOptionsError = { message: "No Results found." };
        throw noOptionsError;
      }

      callback(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
      callback([]);
    }
  };


  // life term payment frequency
  const [paymentFreqs, setPaymentFreqs] = useState([]);
  const fetchPaymentFreqs = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Payment Frequency" });


      const options = res.data?.map((freq) => ({
        value: freq.sys_code,
        label: freq.sys_name,
      }));
      setPaymentFreqs(options);
    } catch (error) {
      console.error("Error fetching payment frequency types:", error);
    }
  };

  // premium payment modes
  const [paymentModes, setPaymentModes] = useState([]);
  const fetchPaymentModes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Payment Mode" });
      const options = res.data?.map((freq) => ({
        value: freq.sys_code,
        label: freq.sys_name,
      }));
      setPaymentModes(options);
    } catch (error) {
      console.error("Error fetching payment modes :", error);
    }
  };

  const fetchProductTerms = async (prCode) => {
    try {
      const res = await newRequest.post("/uwProduct/find", { pr_code: prCode });
      // console.log(`orgUnit  ${JSON.stringify(res.data, null, 2)}`);

      const options = res.data?.product_terms_xx.map((term) => ({
        term_years: term.term_years,
        term_mc_code: term.term_mc_code,
        term_sc_code: term.term_sc_code,
        term_cc_code: term.term_cc_code,
        value: term.term_code,
        label: term.term_name,
      }));
      setProductLifeTerms(options);
    } catch (error) {
      console.error("Error fetching payment frequency types:", error);
    }
  };

  // products
  const [productlifeTerms, setProductLifeTerms] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const fetchProducts = async () => {
    try {
      const res = await newRequest.post("/uwProduct/findAll", { lean: "" });
      const options = res.data?.map((product) => ({
        project_info_xx: product?.pr_project_info || "N",
        product_type_xx: product?.pr_category,
        product_terms_xx: product?.product_terms_xx,
        pr_code: product?.pr_code,
        pr_name: product?.pr_name,
        pr_period_type: product?.pr_period_type,
        pr_cash_carry: product?.pr_cash_carry,
        pr_onetime: product?.pr_onetime,
        pr_motor: product?.pr_motor,
        pr_express_quote: product?.pr_express_quote,
        pr_express_note: product?.pr_express_note,
        pr_jurisdiction: product?.pr_jurisdiction,
        pr_territory: product?.pr_territory,
        value: product?.pr_code,
        label: product?.pr_name,
      }));
      setProducts(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  // Function to get limit_yn value by limit_code
  const getLimitValue = (limitCode) => {
    try {
      // console.log(`getLimitValue profileLimitValues ${JSON.stringify(profileLimitValues, null, 2)}`);
      const limit = profileLimitValues.find(l => l.limit_code === limitCode);
      return limit ? limit.limit_yn : null;
    } catch (error) {
      console.log(error)
    }
  };

  // currency
  const [plCurCode, setPlCurCode] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const fetchCurrencies = async () => {
    try {
      const res = await newRequest.get("/glCurrency/findAll");
      const options = res.data?.map((currency) => ({
        cur_code: currency?.cur_code,
        cur_name: currency?.cur_name,
        value: currency?.cur_code,
        label: currency?.cur_name,
      }));
      setCurrencies(options);
      //set default values
      if (quoteData) {
        setPlCurCode({
          value: quoteData?.pl_cur_code,
          label: quoteData?.currency_xx,
        });
      }

      if (quoteId === "new") {
        // set default currency
        setPlCurCode({
          value: currentUser?.currency_code_xx,
          label: currentUser?.currency_name_xx,
        });
      }
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  // biz unit
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branches, setBranches] = useState([]);
  const fetchBranches = async () => {
    try {
      const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });
      // console.log(`orgUnit  ${JSON.stringify(res.data, null, 2)}`);
      const options = res.data?.map((branch) => ({
        unit_type: branch?.unit_type,
        value: branch?.unit_code,
        label: branch?.unit_name,
      }));

      setBranches(options);
      //set default values
      if (quoteData) {
        setSelectedBranch({
          unit_code: quoteData?.pl_biz_unit,
          unit_name: quoteData?.bizunit_name_xx,
          unit_type: quoteData?.bizunit_type_xx,
          value: quoteData?.pl_biz_unit,
          label: quoteData?.bizunit_name_xx,
        });
      }
      if (quoteId === "new") {
        // set default branch
        setSelectedBranch({
          unit_code: currentUser?.biz_unit_code_xx,
          unit_name: currentUser?.biz_unit_name_xx,
          unit_type: currentUser?.biz_unit_type_xx,
          value: currentUser?.biz_unit_code_xx,
          label: currentUser?.biz_unit_name_xx,
        });
      }
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  // quote stage
  const [plQuoteStage, setPlQuoteStage] = useState(null);
  const [quoteStages, setQuoteStages] = useState([]);
  const fetchQuoteStages = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Quote Stages" });
      const options = res.data?.map((stage) => ({
        value: stage?.sys_code,
        label: stage?.sys_name,
      }));
      setQuoteStages(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const [activityTypes, setActivityTypes] = useState([]);
  const fetchActivityTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Activity Types" });
      const options = res.data?.map((stage) => ({
        value: stage?.sys_code,
        label: stage?.sys_name,
      }));
      setActivityTypes(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const [accountRoles, setAccountRoles] = useState([]);
  const fetchAccountRoles = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Account Role" });
      const options = res.data?.map((stage) => ({
        value: stage?.sys_code,
        label: stage?.sys_name,
      }));
      setAccountRoles(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const [priorityLevels, setPriorityLevels] = useState([]);
  const fetchPriorityLevels = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Priority Level" });
      // console.log(`found quoteStages  ${JSON.stringify(res.data, null, 2)}`);
      const options = res.data?.map((stage) => ({
        value: stage?.sys_code,
        label: stage?.sys_name,
      }));
      setPriorityLevels(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  // deal with dates
  const handleGlDateChange = async (e) => {
    try {
      if (e.target.value) {
        const formattedGlDate = moment(e.target.value).format("YYYY-MM-DD");
        setPlGlDate(formattedGlDate);
        if (plCurCode?.value !== currentUser?.currency_code_xx) {
          // pass endorsement
          const res = await newRequest.post(
            "/glCurrencyRate/find",
            {
              rate_cur_code_fm: plCurCode.cur_code,
              rate_cur_code_to: currentUser?.currency_code_xx,
              rate_date: formattedGlDate,
            }
          );
          // console.log(`end_res  ${JSON.stringify(end_res.data, null, 2)}`);
          if (!res.data || !res.data?.rate) {
            setPlCurCode({
              value: currentUser?.currency_code_xx,
              label: currentUser.currency_name_xx,
            });
            setPlCurRate(1);
            setPlCurRateMd("M");
            setNotifyDialogTitle("Note!");
            setNotifyDialogText(
              `Conversion Rate from <b>${plCurCode?.value} to ${currentUser?.currency_code_xx
              } for date ${moment(e.target.value).format(
                "DD-MMM-YYYY"
              )}</b> NOT found. Currency will reset to <b>${currentUser?.currency_code_xx
              }</b>`
            );
            setIsNotifyDialogOpen(true);
          } else {
            setPlCurRate(res.data?.rate);
            setPlCurRateMd(res.data?.rate_md);
          }
        } else {
          setPlCurRate(1);
          setPlCurRateMd("M");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFromDateChange = (e) => {
    try {
      if (e.target.value) {
        const formattedFromDate = moment(e.target.value).format("YYYY-MM-DD");
        const formattedDay = moment(e.target.value).format("DD");
        setPlFmDate(formattedFromDate);
        calculateDateDifference(plFmDate, plToDate);
        setPlPayDay(formattedDay);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleToDateChange = (e) => {
    try {
      if (e.target.value) {
        const formattedToDate = moment(e.target.value).format("YYYY-MM-DD");
        setPlToDate(formattedToDate);
        calculateDateDifference(plFmDate, plToDate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFromDateBlur = (yearsToAdd = 1) => {
    try {
      if (plFmDate && plToDate) {
        // console.log(`plFmDate: ${plFmDate}`);
        // Parse plFmDate to a Date object
        const fromDate = new Date(plFmDate);
        // Add one year to the date
        const nextYearDate = new Date(fromDate);
        nextYearDate.setFullYear(nextYearDate.getFullYear() + yearsToAdd);
        // Subtract one day from the next year's date
        nextYearDate.setDate(nextYearDate.getDate() - 1);
        // Format the new date to YYYY-MM-DD
        const formattedNextYearDate = nextYearDate.toISOString().split('T')[0];
        // console.log(`Next year date: ${formattedNextYearDate}`);
        setPlToDate(formattedNextYearDate);
        const toDate = new Date(formattedNextYearDate);
        calculateDateDifference(fromDate, toDate);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const handleToDateBlur = () => {
    try {
      if (plFmDate && plToDate) {
        const fromDate = new Date(plFmDate);
        const toDate = new Date(plToDate);
        calculateDateDifference(fromDate, toDate);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const calculateDateDifference = (plFmDate, plToDate) => {
    try {
      if (plFmDate && plToDate) {
        const fromDate = moment(plFmDate, "YYYY-MM-DD");
        const toDate = moment(plToDate, "YYYY-MM-DD");
        const differenceInDays = toDate.diff(fromDate, "days");
        setDaysDifference(differenceInDays + 1);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const calculateDateDifferenceEnd = (plFmDate, plToDate) => {
    try {
      if (plFmDate && plToDate) {
        const fromDate = moment(plFmDate, "YYYY-MM-DD");
        const toDate = moment(plToDate, "YYYY-MM-DD");
        const differenceInDays = toDate.diff(fromDate, "days");
        setDaysDifferenceEnd(differenceInDays + 1);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const refreshQuote = async (title = 'fetchingDocument') => {
    // refresh charges and commission
    try {
      setIsProcessingTitle(t(title));
      setIsProcessing(true);
      if (quoteId === "new" && quoteData._id !== "new") {
        // quoteId = quoteData._id;
        // console.log(`Refreshing Quote id ${quoteData._id}`)
        setQuoteId(quoteData._id);
      }


      const res = await newRequest.post("/uwPolicy/refresh", { policy_docid: quoteId });
      // console.log(`refresh  ${JSON.stringify(res.data, null, 2)}`);

      if (res.data?.result_status === "error") {
        setValidationMessagesResult(res.data);
        setIsConfirmDialogOpen(false);
        setValidationMsgDialog(true);
        return;
      }

      setNextAction(quoteData?.nextAction);
      //log the event here

      try {
        await newRequest.post(
          "/trace/add",
          {
            trc_action_on: "Document",
            trc_doc_type: quoteData?.pl_type,
            trc_doc_no: quoteData?.pl_risk_note_no,
            trc_aent_code: "",
            trc_ent_code: "",
            trc_action: "calculated premium",
            trc_remarks: "calculated premium",
            trc_tags: ["calculated premium"],
            trc_doc_docid: quoteData._id
          }
        );
      } catch (error) {
        console.log(error);
      }

      fetchQuote();
      setPolicyRiskKey(prevKey => prevKey + 1);
      setIsProcessing(false);
    } catch (err) {
      console.log(err);
    } finally {
      setIsProcessing(false)
    }
  };

  // generate document number
  const generateDocumentNo = async () => {
    try {
      const res = await newRequest.post("/orgNumgen/gen", { gen_type: plType, });
      generatedDocNo = res.data;
    } catch (err) {
      console.log(`errors on generation ${err}`);
    }
  };

  const generatePolicyNo = async () => {
    try {
      const res = await newRequest.post(
        "/numGen/genPolicyNumber",
        {
          pr_code: selectedProduct?.value,
          branch_code: selectedBranch?.value || "",
          term_code: plTermCode?.value || "",
          trans_date: plFmDate
        }
      );
      return res.data;
    } catch (err) {
      console.log(err);
    }
  };

  const saveRecord = async (e) => {
    //  e.preventDefault();
    try {

      if (!selectedProduct?.value) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Select Product!`);
        setIsNotifyDialogOpen(true);
        if (productRef.current) {
          productRef.current.focus();
        }
        return;
      }

      if (["term life", "whole life"].includes(selectedProduct?.product_type_xx) &&
        !plTermCode?.value) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Select term!`);
        setIsNotifyDialogOpen(true);
        if (termRef.current) {
          termRef.current.focus();
        }
        return;
      }

      if (!selectedInsured?.value && ["Policy", "RiskNote", "Renewal"].includes(plType)) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Select Insured!`);
        setIsNotifyDialogOpen(true);

        if (productRef.current) {
          productRef.current.focus();
        }

        return;
      }

      const formattedFmDate = new Date(moment(plFmDate).format("YYYY-MM-DD"));
      formattedFmDate.setHours(0, 0, 0, 0);

      const formattedToDate = new Date(
        moment(plToDate).format("YYYY-MM-DD")
      );
      formattedToDate.setHours(0, 0, 0, 0);
      const today = new Date();

      if (["RiskNote", "Policy", "Renewal"].includes(plType)) {
        if (formattedFmDate > formattedToDate) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(
            `Your dates are Invalid. From date <b>${moment(plFmDate).format(
              "DD-MMM-YYYY"
            )}</b> cannot be greater than expiry date <b>${moment(
              plToDate
            ).format("DD-MMM-YYYY")}</b>.<br><br>Please rectify!`
          );
          setIsNotifyDialogOpen(true);
          return;
        }

        // check if the term and dates are matching

        const monthYears = calculateYearsMonths(plFmDate, plToDate);

        if (["term life", "whole life"].includes(selectedProduct?.product_type_xx)) {
          if (monthYears.years !== plTermYears) {
            setNotifyDialogTitle("Note!");
            setNotifyDialogText(
              `Your dates are Invalid. From date <b>${moment(plFmDate).format(
                "DD-MMM-YYYY"
              )}</b> and expiry date <b>${moment(
                plToDate
              ).format("DD-MMM-YYYY")}</b> are more than specified term of ${plTermYears === 1 ? `${plTermYears} year` : `${plTermYears} years`}.<br><br>Please rectify!`
            );
            setIsNotifyDialogOpen(true);
            return;
          }
        } else {
          if (monthYears.years < 1) {
            setPlTermYears(1);
          } else {
            setPlTermYears(monthYears.years);
          }
        }
      }

      saveRisksInParent();

      // save new quote

      // Simulate delay for 5 seconds
      // await new Promise((resolve) => setTimeout(resolve, 5000));

      let uwPolicy = {};
      // setIsProcessing(true);
      if (quoteId === "new") {
        // console.log("generating document number...")
        if (!plRiskNoteNo) {
          // generate document number
          await generateDocumentNo();
        }

        let generatedPolicyNo = null;
        if (!plNo && plType === "Policy") {
          // generate policy number
          generatedPolicyNo = await generatePolicyNo();
        }

        //prepare data
        uwPolicy = {
          pl_risk_note_no: plRiskNoteNo || generatedDocNo,
          pl_primary_doc: plRiskNoteNo || generatedDocNo,
          pl_quote_no: plQuoteNo,
          pl_quote_version: 1,
          pl_quote_stage: plQuoteStage?.value,
          pl_no: plNo || generatedPolicyNo,
          pl_end_index: plEndIndex,
          pl_end_no: plEndNo,
          pl_end_code: plEndCode,
          pl_type: plType,
          pl_status: plStatus,
          pl_product_code: selectedProduct?.value,
          pl_biz_unit: selectedBranch?.value,
          pl_cur_code: plCurCode?.value,
          pl_cur_rate: plCurRate,
          pl_cur_rate_md: plCurRateMd,
          pl_gl_date: plGlDate,
          pl_fm_date: plFmDate,
          pl_to_date: plToDate,
          pl_onetime: "N",
          pl_assr_aent_code: selectedInsured?.ent_aent_code,
          pl_assr_ent_code: selectedInsured?.ent_code,
          pl_ins_aent_code: selectedCarrier?.ent_aent_code,
          pl_ins_ent_code: selectedCarrier?.ent_code,
          pl_remarks: plRemarks,
          pl_regn_no: plRegnNo?.toUpperCase(),
          pl_assr_entity_name: selectedInsured?.label?.props?.children[0],
          pl_int_entity_name: selectedCarrier?.label?.props?.children[0],
          pl_term_code: plTermCode?.value,
          pl_term_payment_freq: plTermPaymentFreq?.value || "monthly",
          pl_pay_day: plPayDay || getFutureDay(5),
          pl_term_years: plTermYears,
          pl_inst_confirmed: plInstConfirmed,
          pl_payment_mode: plPaymentMode?.value,
          pl_bank: plBank?.value,
          pl_bank_branch: plBankBranch?.value,
          pl_bank_ac_name: plBankAcName || selectedInsured?.label?.props?.children[0],
          pl_bank_ac_no: plBankAcNo,
          pl_bank_swiftcode: plBankSwiftcode,
          pl_channel: plChannel?.value,

          pl_op_name: plOpName,
          pl_op_method: plOpMethod?.value,
          pl_op_priority: plOpPriority?.value,
          pl_op_source: plOpSource?.value,
          pl_op_email: plOpEmail,
          pl_op_phone_no: plOpPhoneNo,
          pl_win_probability: plWinProbability,
          pl_op_contacts: plOpContacts,
          pl_op_activities: plOpActivities,
          pl_op_team: plOpTeam,
          pl_participants: plParticipants,
          pl_tender_info: plTenderInfo,
          pl_project_info: plProjectInfo,
          pl_conveyance: plConveyance?.value || "Default",

          pl_interest_yn: quoteData?.pl_interest_yn,
          pl_interest_ent_code: selectedFinancier?.ent_code ? selectedFinancier?.ent_code : "",

          pl_jurisdiction: plJurisdiction?.value,
          pl_territory: plTerritory?.value,

          pl_subagent_ent_code: currentUser?.usr_entity_code || "",

        };

        const res = await newRequest.post("/uwPolicy/add", uwPolicy);
        navigate(`/uw/policy/${res.data?._id}`, { replace: true });
        //quoteId = res.data?._id;
        setQuoteId(res.data?._id);
        setQuoteData(res.data);
        setPlQuoteNo(generatedDocNo);
        setNotifyDialogTitle("Success!");
        setNotifyDialogText(`${plType} successfully saved`);
        setIsProcessing(false);
        setIsNotifyDialogOpen(true);
      } else {

        // console.log(`selectedFinancier  ${JSON.stringify(selectedFinancier, null, 2)}`);

        await newRequest.put(
          `/uwPolicy/upd/${quoteId}`,
          {
            pl_no: plNo,
            pl_quote_stage: plQuoteStage?.value,
            pl_status: quoteData?.pl_status,
            pl_product_code: selectedProduct?.value,
            pl_biz_unit: selectedBranch?.value,
            pl_cur_code: plCurCode?.value,
            pl_cur_rate: plCurRate,
            pl_cur_rate_md: plCurRateMd,
            pl_gl_date: plGlDate,
            pl_fm_date: plFmDate,
            pl_to_date: plToDate,
            pl_assr_aent_code: selectedInsured?.ent_aent_code,
            pl_assr_ent_code: selectedInsured?.ent_code,
            pl_ins_aent_code: selectedCarrier?.ent_aent_code,
            pl_ins_ent_code: selectedCarrier?.ent_code,
            pl_remarks: plRemarks,
            pl_regn_no: plRegnNo?.toUpperCase(),
            pl_assr_entity_name: selectedInsured?.label?.props?.children[0],
            pl_int_entity_name: selectedCarrier?.label?.props?.children[0],
            pl_term_code: plTermCode?.value,
            pl_term_payment_freq: plTermPaymentFreq?.value || "monthly",
            pl_pay_day: plPayDay,
            pl_term_years: plTermYears,
            pl_inst_confirmed: plInstConfirmed,
            pl_payment_mode: plPaymentMode?.value,
            pl_bank: plBank?.value,
            pl_bank_branch: plBankBranch?.value,
            pl_bank_ac_name: plBankAcName || selectedInsured?.label?.props?.children[0],
            pl_bank_ac_no: plBankAcNo,
            pl_bank_swiftcode: plBankSwiftcode,
            pl_channel: plChannel?.value,
            pl_op_name: plOpName,
            pl_op_method: plOpMethod?.value,
            pl_op_priority: plOpPriority?.value,
            pl_op_source: plOpSource?.value,
            pl_op_email: plOpEmail,
            pl_op_phone_no: plOpPhoneNo,
            pl_win_probability: plWinProbability,
            pl_op_contacts: plOpContacts,
            pl_op_activities: plOpActivities,
            pl_op_team: plOpTeam,
            pl_participants: plParticipants,
            pl_tender_info: plTenderInfo,
            pl_project_info: plProjectInfo,
            pl_owner: plOwner,
            pl_conveyance: plConveyance?.value || "Default",
            pl_benefits: plBenefits,
            pl_interest_yn: quoteData?.pl_interest_yn,
            pl_interest_ent_code: selectedFinancier?.ent_code ? selectedFinancier?.ent_code : "",
            pl_jurisdiction: plJurisdiction?.value,
            pl_territory: plTerritory?.value,
          }
        );
        setNotifyDialogTitle("Success!");
        setNotifyDialogText(`${plRiskNoteNo} successfully updated`);
        setIsProcessing(false);
        setIsNotifyDialogOpen(true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleSelectedJurisdiction = async (selectedOption, field) => {
    try {
      if (selectedOption && selectedOption.__isNew__) {
        await newRequest.post("sysCode/add", {
          sys_type: "Jurisdictions",
          sys_code: selectedOption.value,
          sys_name: selectedOption.value,
          sys_grouping: ""
        });

        if (field === "pl_jurisdiction") {
          setPlJurisdiction({
            value: selectedOption.value,
            label: selectedOption.value,
          });
        } else {
          setPlTerritory({
            value: selectedOption.value,
            label: selectedOption.value,
          });
        }

        showToast(`${selectedOption.value} added to the ${field} list!`, "success");
      } else {
        if (field === "pl_jurisdiction") {
          setPlJurisdiction(selectedOption);
        } else {
          setPlTerritory(selectedOption);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };


  const formatNumber = (number, decimalPlaces) => {
    return Number(number).toLocaleString(undefined, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    });
  };

  const handleConfettiClick = () => {
    setIsConfettiActive(true);
    setTimeout(() => {
      setIsConfettiActive(false);
    }, 5000);
  };

  const handleChargeBlur = (index, key) => {
    // Format the number and update the state
    const updatedData = [...quoteData.policy_charges];
    let decimalPlaces = 0;
    if (key === "smi_si_fc") {
      decimalPlaces = 2;
    } else if (key === "smi_premium_fc") {
      decimalPlaces = 2;
    } else if (key === "smi_rate") {
      decimalPlaces = 4;
    } else if (key === "smi_rate_per") {
      decimalPlaces = 2;
    } else {
      decimalPlaces = 0;
    }

    if (key !== "smi_name_xx") {
      updatedData[index][key] = formatNumber(
        updatedData[index][key],
        decimalPlaces
      );
    }
    //setPolicyRiskCoverSmi(updatedData);
  };


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "policyAction") {
        // NOTES
        // 1. Do not check period for General Endorsement type 300 because there's no financial impact
        if (["Approved"].includes(objectToAction?.new_doc_status)
          && !["300"].includes(quoteData?.pl_internal_end_code)
        ) {
          // check if period is open
          const formattedGlDate = moment(plGlDate).format("YYYY-MM-DD");
          // console.log(`formattedGlDate is ${formattedGlDate}`)
          const res = await newRequest.post(
            "/glCp/periodStatus",
            {
              cp_org_code: currentUser.usr_org_code,
              cp_cy_type: "Underwriting",
              gl_date: formattedGlDate,
            }
          );
          // console.log(`glCp/periodStatus  ${JSON.stringify(res.data, null, 2)}`);
          if (res.data?.cp_status === "Closed") {
            setIsConfirmDialogOpen(false);
            setConfirmDialogAction("None");
            setNotifyDialogTitle("Note!");
            setNotifyDialogText(
              `${formatTypeName(plType)} date <b>${moment(plGlDate).format(
                "DD-MMM-YYYY"
              )}</b> is within Underwriting period <b>${res.data?.cp_code
              }</b>. The period is <b>${res.data?.cp_status
              }</b>. Open the period to allow approval.`
            );
            setIsNotifyDialogOpen(true);
            return;
          }

          // check if installments have been confirmed
          if (plInstConfirmed === "N") {
            setIsConfirmDialogOpen(false);
            setNotifyDialogTitle("Note!");
            setNotifyDialogText(
              `Please confirm installments before approving this ${plType}`
            );
            setIsNotifyDialogOpen(true);
            return;
          }
        }


        // show endorsement view
        if (objectToAction?.new_doc_status === "Endorsed") {
          // set default dates
          const formattedFmDate = moment(new Date(Date.now())).format("YYYY-MM-DD");
          const formattedToDate = moment(plToDate).format("YYYY-MM-DD");

          setEndorsementGlDate(formattedFmDate);
          setEndorsementFmDate(formattedFmDate);
          setEndorsementToDate(formattedToDate);

          fetchProductEnds();
          setSelectedProductEnd(null);
          setEndDialogOpen(true);
        } else {

          if (objectToAction?.new_doc_status === "Validated") {
            // console.log(".......Run Policy Validation Here...");
            const validateResponse = await newRequest.post("/uwPolicy/validate", { policy_docid: quoteData?._id });
            // console.log(`validateResponse.data  ${JSON.stringify(validateResponse.data, null, 2)}`);
            if (validateResponse.data?.result_status === "error") {
              // <ValidationMessages messageData={validateResponse.data} />
              setValidationMessagesResult(validateResponse.data);
              setIsConfirmDialogOpen(false);
              setValidationMsgDialog(true);
              return;
            }
          }

          if (objectToAction?.new_doc_status === "Approved" &&
            currentUser?.token_org_type === "insurance"
          ) {
            // console.log(".......Run Posting Validation Here...");
            const approveResponse = await newRequest.get(`/uwPolicy/approveAndPost/${quoteData?._id}`);
            // console.log(`approveResponse.data  ${JSON.stringify(approveResponse.data, null, 2)}`);
            if (approveResponse.data?.result_status === "error") {
              // <ValidationMessages messageData={validateResponse.data} />
              setValidationMessagesResult(approveResponse.data);
              setIsConfirmDialogOpen(false);
              setValidationMsgDialog(true);
              return;
            }
          }

          await newRequest.post(
            "/uwPolicy/status",
            {
              pl_status: objectToAction?.new_doc_status === "Approved" ? "Active" : objectToAction?.new_doc_status,
              total_fc_si: quoteData?.total_fc_si,
              total_lc_si: quoteData?.total_lc_si,
              total_fc_premium: quoteData?.total_fc_premium,
              total_lc_premium: quoteData?.total_lc_premium,
              commission_fc_amount: quoteData?.commission_fc_amount,
              commission_lc_amount: quoteData?.commission_lc_amount,
              commission_net_fc: quoteData?.commission_net_fc,
              commission_net_lc: quoteData?.commission_net_lc,
              policy_docid: quoteData._id,
            }
          );

          try {
            await newRequest.post(
              "/trace/add",
              {
                trc_action_on: "Document",
                trc_doc_type: plType,
                trc_doc_no: plRiskNoteNo,
                trc_aent_code: "",
                trc_ent_code: "",
                trc_action: "updated document status",
                trc_remarks: `updated ${quoteData?.pl_type} to ${objectToAction?.new_doc_status}`,
                trc_tags: ["added cover"],
                trc_doc_docid: quoteData._id
              }
            );
          } catch (error) {
            console.log(error);
          }

          // if new status us approved, insert into endorsements table
          // console.log(`new_doc_status is ${objectToAction?.new_doc_status} and plEndIndex is ${plEndIndex} and plNo is ${plNo}`);
          if (
            objectToAction?.new_doc_status === "Approved" &&
            plEndIndex === 0
          ) {
            try {
              await newRequest.post(
                "/uwPolicyEnd/add",
                {
                  pe_risk_note_no: plRiskNoteNo,
                  pe_policy_docid: quoteData._id,
                  pe_policy_no: plNo,
                  pe_end_no: plEndNo,
                  pe_end_index: plEndIndex,
                  pe_doc_type: plType,
                  pe_end_code: plEndCode,
                  pe_internal_end_code: plInternalEndCode,
                  pe_pr_code: quoteData?.pl_product_code,
                  pe_gl_date: quoteData?.pl_gl_date,
                  pe_fm_date: quoteData?.pl_fm_date,
                  pe_to_date: quoteData?.pl_to_date,
                  pe_original_docid: quoteId,
                  pe_primary_doc: plRiskNoteNo,
                  pe_status: "Approved",
                  pe_remarks: `new business endorsement ${quoteData?.pl_end_no}`
                }
              );
              // console.log(`end_res  ${JSON.stringify(end_res.data, null, 2)}`);
              // handleConfettiClick();
              setConfirmDialogAction("None");
              setNotifyDialogTitle("Success!");
              setNotifyDialogText(`${currentUser?.token_org_type === "insurance" ? quoteData?.pl_no : quoteData?.pl_risk_note_no} successfully updated to ${objectToAction?.new_doc_status}`);
            } catch (error) {
              console.log(error);
            }
          } else if (
            objectToAction?.new_doc_status === "Approved" &&
            quoteData?.pl_end_index > 0
          ) {

            const res = await newRequest.post("/uwPolicyEnd/upd", { current_end_docid: quoteData?.pl_current_end_docid, pe_status: "Approved" });

            // merge details from previous document
            await newRequest.post("/uwPolicy/merge", { policy_docid: quoteData._id });

            setConfirmDialogAction("None");
            setNotifyDialogTitle("Success!");
            setNotifyDialogText(
              `${currentUser?.token_org_type === "insurance" ? quoteData?.pl_no : quoteData?.pl_risk_note_no} successfully approved`
            );
          } else {
            setConfirmDialogAction("None");
            setNotifyDialogTitle("Success!");
            setNotifyDialogText(
              `${currentUser?.token_org_type === "insurance" ? quoteData?.pl_no : quoteData?.pl_risk_note_no} successfully updated to ${objectToAction?.new_doc_status}`
            );
          }

          fetchQuote();
          setIsNotifyDialogOpen(true);
        }
      } else if (confirmDialogAction === "removeReceipt") {
        // unmatch receipt
        try {
          await newRequest.delete(`/uwPolicyReceipt/del/${objectToAction.object_id}`);
          fetchQuote();
          showToast("Receipt Unmatched!", "success");
        } catch (error) {
          console.log(error);
        }

        setConfirmDialogAction("None");
      } else if (confirmDialogAction === "removeClaimBasis") {
        // console.log(`remove claim basis  ${objectToAction.object_id}`);
        // remove claim basis
        try {
          await newRequest.post("/uwPolicy/claimBasisDel", {
            policy_docid: quoteData._id,
            basis_docid: objectToAction.object_id
          });
          fetchQuote();
          showToast("Removed!", "success");
        } catch (error) {
          console.log(error);
        }

        setConfirmDialogAction("None");
      } else if (confirmDialogAction === "removeSpecialNote") {
        // console.log(`remove claim basis  ${objectToAction.object_id}`);
        // remove claim basis
        try {
          await newRequest.delete(`/allDocsNote/del/${objectToAction.object_id}`);
          fetchSpecialNotes(quoteData._id, "Special");
          showToast("Removed!", "success");
        } catch (error) {
          console.log(error);
        }

        setConfirmDialogAction("None");
      } else if (confirmDialogAction === "paidToUsReceipt") {
        // generate receipt no

        const res = await newRequest.post("/orgNumgen/gen", { gen_type: "Receipt" });
        const generatedReceiptNo = res.data;
        setReceiptNo(generatedReceiptNo);

        createReceipt(generatedReceiptNo);
        // reset receipt fields 
        setReceiptDate(null);
        setReceiptNo("");
        setReceiptCurrency(null);
        setReceiptAmountFc(null);
        setReceiptAmountLc(null);
        setReceiptOpen(false);
        refreshQuote();
      } else if (confirmDialogAction === "invalidatePolicy") {
        try {
          await newRequest.post(
            "/uwPolicy/status",
            {
              pl_status: objectToAction?.new_doc_status,
              pl_inst_confirmed: "N",
              policy_docid: quoteData._id,
            }
          );

          await newRequest.post(
            "/trace/add",
            {
              trc_action_on: "Document",
              trc_doc_type: quoteData?.pl_type,
              trc_doc_no: quoteData?.pl_risk_note_no,
              trc_aent_code: "",
              trc_ent_code: "",
              trc_action: "updated document status",
              trc_remarks: `updated ${quoteData?.pl_type} to ${objectToAction?.new_doc_status}`,
              trc_tags: ["updated document status"],
              trc_doc_docid: quoteData._id
            }
          );
        } catch (error) {
          console.log(error);
        }
        fetchQuote();
        showToast(`Status changed to ${objectToAction?.new_doc_status}`, "success");
      } else if (confirmDialogAction === "voidPolicy") {
        await newRequest.post(
          "/uwPolicy/status",
          {
            pl_status: objectToAction?.new_doc_status,
            pl_inst_confirmed: "N",
            policy_docid: quoteData._id,
          }
        );

        try {
          await newRequest.post(
            "/trace/add",
            {
              trc_action_on: "Document",
              trc_doc_type: quoteData?.pl_type,
              trc_doc_no: quoteData?.pl_risk_note_no,
              trc_aent_code: "",
              trc_ent_code: "",
              trc_action: "voided approval",
              trc_remarks: `updated ${quoteData?.pl_type} to ${objectToAction?.new_doc_status}`,
              trc_tags: ["voided approval"],
              trc_doc_docid: quoteData._id
            }
          );
        } catch (error) {
          console.log(error);
        }
        fetchQuote();
        showToast(`Document approval voided`, "success");
      } else if (confirmDialogAction === "confirmInstallments") {
        await newRequest.put(`/uwPolicy/upd/${quoteId}`, { pl_inst_confirmed: "Y" });
        setPlInstConfirmed("Y");
        try {
          await newRequest.post(
            "/trace/add",
            {
              trc_action_on: "Document",
              trc_doc_type: quoteData?.pl_type,
              trc_doc_no: quoteData?.pl_risk_note_no,
              trc_aent_code: "",
              trc_ent_code: "",
              trc_action: "confirmed installments",
              trc_remarks: `confirmed premium installments`,
              trc_tags: ["confirmed installments"],
              trc_doc_docid: quoteData._id
            }
          );
        } catch (error) {
          console.log(error);
        }
        await fetchQuote();
        showToast(`Installments confirmed!`, "success");
      } else if (confirmDialogAction === "publishQuoteRequest") {
        await newRequest.put(`/uwPolicy/upd/${quoteId}`, { pl_status: "Published" });
        setPlInstConfirmed("Y");
        try {
          await newRequest.post(
            "/trace/add",
            {
              trc_action_on: "Document",
              trc_doc_type: quoteData?.pl_type,
              trc_doc_no: quoteData?.pl_risk_note_no,
              trc_aent_code: "",
              trc_ent_code: "",
              trc_action: `Published ${plType}`,
              trc_remarks: `Published ${plType}`,
              trc_tags: ["Published ${plType}"],
              trc_doc_docid: quoteData._id
            }
          );
        } catch (error) {
          console.log(error);
        }
        await fetchQuote();
        showToast(`${plType} published!`, "success");
      } else if (confirmDialogAction === "setPolicyNo") {

        await newRequest.put(
          `/uwPolicy/upd/${quoteId}`,
          { pl_no: manualPolicyNo }
        );

        try {
          await newRequest.post(
            "/trace/add",
            {
              trc_action_on: "Document",
              trc_doc_type: quoteData?.pl_type,
              trc_doc_no: quoteData?.pl_risk_note_no,
              trc_aent_code: "",
              trc_ent_code: "",
              trc_action: `amended`,
              trc_remarks: `Set Policy no ${manualPolicyNo}`,
              trc_tags: [`Set Policy no ${manualPolicyNo}`],
              trc_doc_docid: quoteData._id
            }
          );
        } catch (error) {
          console.log(error);
        }
        await fetchQuote();
        setIsManualPolicyNo(false);
        showToast(`Policy No ${manualPolicyNo} set!`, "success");
        setManualPolicyNo("");
      } else if (confirmDialogAction === "voidDocument") {
        try {
          await newRequest.put(`/uwPolicy/upd/${quoteId}`, { pl_status: "Voided" });

          await newRequest.post(
            "/trace/add",
            {
              trc_action_on: "Document",
              trc_doc_type: quoteData?.pl_type,
              trc_doc_no: quoteData?.pl_risk_note_no,
              trc_aent_code: "",
              trc_ent_code: "",
              trc_action: "amended",
              trc_remarks: "Voided risk note",
              trc_tags: ["Voided risk note"],
              trc_doc_docid: quoteData._id
            }
          );
          await fetchQuote();
          showToast(`Risk Note ${plRiskNoteNo} VOIDED!`, "success");
        } catch (error) {
          console.log(error);
        }
      } else if (confirmDialogAction === "deletePolicy") {
        await newRequest.delete(`/uwPolicy/del/${quoteId}`);
        navigate(-1);
        showToast(`Risk Note ${plRiskNoteNo} DELETED!`, "success");
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };


  const handleButtonOne = async () => {
    try {
      setIsThreeButtonDialogOpen(false);
      if (objectToAction?.action === "opportunityAction") {
        if (!selectedInsured?.value) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Select client!`);
          setIsNotifyDialogOpen(true);
          return;
        }
        const res = await newRequest.post(
          "/uwPolicy/copy",
          {
            original_doc_id: quoteData?._id,
            copy_to_type: "Quote"
          });
        // console.log(`handleButtonOne  ${JSON.stringify(res.data, null, 2)}`);

        if (res.data?.msg === "copied") {
          await fetchQuote();
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`${quoteData?.pl_risk_note_no} converted to quote no ${res.data?.doc?.pl_risk_note_no}`);
          setIsNotifyDialogOpen(true);
        } else {
          setNotifyDialogTitle("Error!");
          setNotifyDialogText(res.data?.msg_text);
          setIsNotifyDialogOpen(true);
        }
      } else if (objectToAction?.action === "quoteAction") {

      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleButtonTwo = async () => {
    try {
      setIsThreeButtonDialogOpen(false);
      if (objectToAction?.action === "opportunityAction") {
        if (!selectedInsured?.value) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Select client!`);
          setIsNotifyDialogOpen(true);
          return;
        }
        const res = await newRequest.post("/uwPolicy/copy", {
          original_doc_id: quoteData?._id,
          copy_to_type: "QuoteRequest"
        });

        if (res.data?.msg === "copied") {
          await fetchQuote();
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`${quoteData?.pl_risk_note_no} converted to quote request no ${res.data?.doc?.pl_risk_note_no}`);
          setIsNotifyDialogOpen(true);
        } else {
          setNotifyDialogTitle("Error!");
          setNotifyDialogText(res.data?.msg_text);
          setIsNotifyDialogOpen(true);
        }
      } else if (objectToAction?.action === "quoteAction") {

      }
    } catch (error) {
      console.log(error);
    }
  };

  // check vehicle registration
  const handleVehicleCheck = async () => {
    try {

      if (!vehicleDialogRegnNo) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter registration number`);
        setIsNotifyDialogOpen(true);
        vehicleInputRef.current.focus();
        return;
      }


      // if (!validateMotorVehicleRegn(vehicleDialogRegnNo)) {
      //   setNotifyDialogTitle("Note!");
      //   setNotifyDialogText(`Invalid registration number <b>${vehicleDialogRegnNo.toUpperCase()}</b><br><br>Ensure you use pattern like AAA000A. E.g KDM100Q`);
      //   setIsNotifyDialogOpen(true);
      //   return;
      // }


      if (vehicleDialogRegnNo) {
        setVehicleResultView(t('note'));
        setVehicleProceedButton(false);

        // Simulate delay for 5 seconds
        // await new Promise((resolve) => setTimeout(resolve, 5000));

        const res = await newRequest.post("/uwPolicyRisk/checkVeh", { vehicle_regn: vehicleDialogRegnNo });

        logData("checkVeh response", res.data);

        if (res.data === "VehicleNotFound") {
          setVehicleResultView("NoVehicleFound");
          setVehicleProceedButton(true);
          if (expressSmis?.length > 0) {
            expressInsuredRef.current?.focus();
          }
        } else {
          setVehicleMatchingRisks(res.data);
          setVehicleResultView("VehicleFound");
          setVehicleProceedButton(false);
        }
        setVehicleCheckTitle(t('check'));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleVehicleCheckProceed = async () => {
    try {
      const changedExpressSmi = expressSmis?.filter((obj) => obj.changed_xx === "Y");

      if (changedExpressSmi.length > 0) {

        if (!seletedExpressInsured) {
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(`Please select or enter insured name`);
          setIsNotifyDialogOpen(true);
          expressInsuredRef.current.focus();
          return;
        }


        let insuredEntityName = "";
        let insuredEntityCode = "";
        let insuredAentCode = "";

        if (seletedExpressInsured?.isNew) {
          // create client
          const res = await newRequest.post(
            "/allEntity/add",
            {
              ent_aent_code: "Client",
              ent_type: "Unspecified",
              ent_status: "Active",
              ent_name: seletedExpressInsured?.value,
              ent_email: "",
              ent_phone_no: "",
            }
          );
          insuredEntityName = res.data?.ent_name;
          insuredEntityCode = res.data?.ent_code;
          insuredAentCode = res.data?.ent_aent_code;
        } else {
          insuredEntityName = seletedExpressInsured?.ent_name;
          insuredEntityCode = seletedExpressInsured?.ent_code;
          insuredAentCode = seletedExpressInsured?.ent_aent_code;
        }

        // generate document number
        await generateDocumentNo();

        // console.log(`insuredEntityName ... ${insuredEntityName}`);
        // console.log(`insuredEntityCode ... ${insuredEntityCode}`);
        // console.log(`insuredAentCode ... ${insuredAentCode}`);
        // console.log(`generatedDocNo ... ${generatedDocNo}`);

        // create document
        //prepare data
        const uwPolicy = {
          pl_risk_note_no: generatedDocNo,
          pl_primary_doc: generatedDocNo,
          pl_quote_no: generatedDocNo,
          pl_quote_version: 1,
          pl_quote_stage: plQuoteStage?.value,
          pl_no: "",
          pl_end_index: plEndIndex,
          pl_end_no: plEndNo,
          pl_end_code: plEndCode,
          pl_type: plType,
          pl_status: plStatus,
          pl_product_code: selectedProduct?.value,
          pl_biz_unit: selectedBranch?.value,
          pl_cur_code: plCurCode?.value,
          pl_cur_rate: plCurRate,
          pl_cur_rate_md: plCurRateMd,
          pl_gl_date: plGlDate,
          pl_fm_date: plFmDate,
          pl_to_date: plToDate,
          pl_onetime: "N",
          pl_assr_aent_code: insuredAentCode,
          pl_assr_ent_code: insuredEntityCode,
          pl_ins_aent_code: seletedExpressCarrier?.ent_aent_code,
          pl_ins_ent_code: seletedExpressCarrier?.ent_code,
          pl_remarks: plRemarks,
          pl_regn_no: vehicleDialogRegnNo?.toUpperCase(),

          pl_assr_entity_name: insuredEntityName,
          pl_int_entity_name: seletedExpressCarrier?.label?.props?.children[0],
          pl_term_code: plTermCode?.value,
          pl_term_payment_freq: plTermPaymentFreq?.value || "monthly",
          pl_pay_day: plPayDay || getFutureDay(5),
          pl_term_years: plTermYears,
          pl_inst_confirmed: plInstConfirmed,
          pl_payment_mode: plPaymentMode?.value,
          pl_bank: plBank?.value,
          pl_bank_branch: plBankBranch?.value,
          pl_bank_ac_name: plBankAcName || selectedInsured?.label?.props?.children[0],
          pl_bank_ac_no: plBankAcNo,
          pl_bank_swiftcode: plBankSwiftcode,
          pl_channel: plChannel?.value,
          pl_op_name: plOpName,
          pl_op_method: plOpMethod?.value,
          pl_op_priority: plOpPriority?.value,
          pl_op_source: plOpSource?.value,
          pl_op_email: plOpEmail,
          pl_op_phone_no: plOpPhoneNo,
          pl_win_probability: plWinProbability,
          pl_op_contacts: plOpContacts,
          pl_op_activities: plOpActivities,
          pl_op_team: plOpTeam,
          pl_participants: plParticipants,
          pl_tender_info: plTenderInfo,
          pl_project_info: plProjectInfo,

          pl_conveyance: plConveyance?.value || "Default",

          pl_interest_yn: quoteData?.pl_interest_yn,
          pl_interest_ent_code: selectedFinancier?.ent_code ? selectedFinancier?.ent_code : "",

          pl_jurisdiction: plJurisdiction?.value,
          pl_territory: plTerritory?.value,

          pl_subagent_ent_code: currentUser?.usr_entity_code || "",

        };

        const res = await newRequest.post("/uwPolicy/add", { ...uwPolicy, express_smis: expressSmis });
        navigate(`/uw/policy/${res.data?._id}`, { replace: true });
        setVehicleDialogOpen(false);
        setQuoteId(res.data?._id);
        setQuoteData(res.data);
        setPlQuoteNo(generatedDocNo);
        setNotifyDialogTitle("Success!");
        setNotifyDialogText(`${plType} successfully saved`);
        setIsProcessing(false);
        setIsNotifyDialogOpen(true);

      } else {
        setPlRegnNo(vehicleDialogRegnNo);
        setVehicleDialogRegnNo("");
        setVehicleResultView("None");
        setVehicleProceedButton(false);
        setVehicleCheckTitle("Check");
        setVehicleDialogOpen(false);
        if (insuredRef.current) {
          insuredRef.current.focus();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddClaimBasis = async () => {
    try {
      if (basisOfClaim) {
        try {
          await newRequest.post(
            "/uwPolicy/claimBasisAdd/",
            {
              policy_docid: quoteData._id,
              basis_text: basisOfClaim,
              userCode: currentUser.usr_id,
            }
          );
          // console.log(`claimBasis  ${JSON.stringify(res.data, null, 2)}`);

          // refresh list
          const getBasis = await newRequest.post(
            "/uwPolicy/claimBasisGet/",
            {
              policy_docid: quoteData._id,
            }
          );
          setPlClaimBasis(getBasis.data);
          showToast("Added!", "success");
        } catch (error) {
          console.log(error);
        }
      }
      setBasisOfClaim("");
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddSpecialNote = async () => {
    try {
      if (specialNote) {
        try {
          await newRequest.post(
            "/allDocsNote/add/",
            {
              note_doc_type: plType,
              note_docid: quoteData._id,
              note_text: specialNote,
              note_tags: [currentUser.usr_id],
              note_type: "Special"
            }
          );
          await fetchSpecialNotes(quoteData._id, "Special");
          if (specialNoteRef.current) {
            specialNoteRef.current.focus();
          }
          showToast("Added!", "success");
        } catch (error) {
          console.log(error);
        }
      }
      setSpecialNote("");
    } catch (error) {
      console.log(error);
    }
  };



  function getMenuTitle(menuKey) {
    switch (menuKey) {
      case 'details':
        return t('details');
      case 'wordings':
        if (["Opportunity", "QuoteRequest"].includes(plType)) {
          return t('team');
        } else {
          return t('wordings');
        }
      case 'attachments':
        return t('attachments');
      case 'claims':
        if (["Opportunity", "Quote", "QuoteRequest"].includes(plType)) {
          return t('tenderInfo');
        } else {
          return t('claims');
        }
      case 'correspondence':
        return t('correspondence');
      case 'comments':
        return t('comments');
      default:
        return '';
    }
  }

  const topMenus = [
    {
      menu_key: "details",
      menu_title: getMenuTitle("details"),
      menu_icon: <MdEditDocument />,
      menu_count: 0,
    },
    {
      menu_key: "wordings",
      menu_title: getMenuTitle("wordings"),
      menu_icon: ["Opportunity", "QuoteRequest"].includes(plType)
        ? <IoReceipt />
        : <BsTextParagraph />,
      menu_count: ["Opportunity", "QuoteRequest"].includes(plType) ? quoteData?.pl_op_team?.length : quoteData?.wordings_count_xx,
    },
    {
      menu_key: "attachments",
      menu_title: getMenuTitle("attachments"),
      menu_icon: <RiAttachment2 />,
      menu_count: attachmentsData.length,
    },
    {
      menu_key: "claims",
      menu_title: getMenuTitle("claims"),
      menu_icon: ["Opportunity", "Quote", "QuoteRequest"].includes(plType)
        ? <HiDocumentText />
        : <LocalFireDepartmentIcon />,
      menu_count: policyClaimsList.length,
    },
    {
      menu_key: "correspondence",
      menu_title: getMenuTitle("correspondence"),
      menu_icon: <MdSms />,
      menu_count: 0,
    },
    {
      menu_key: "comments",
      menu_title: getMenuTitle("comments"),
      menu_icon: <IoChatbubbles />,
      menu_count: 0,
    },
  ];


  useEffect(() => {
    const compute = () => {
      const el = pageShellRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      // how much “empty space” exists on the right side of the centered/max-width container
      const offset = Math.max(0, window.innerWidth - rect.right);
      setCollabRightOffset(offset);
    };

    compute();

    window.addEventListener("resize", compute);
    // optional: if your layout can shift on scroll due to sticky headers etc.
    window.addEventListener("scroll", compute, true);

    return () => {
      window.removeEventListener("resize", compute);
      window.removeEventListener("scroll", compute, true);
    };
  }, []);

  useEffect(() => {

    // set document type
    // console.log(`documentType is ... ${parts[parts.length - 2]}`);
    let docType = "Policy";
    switch (parts[parts.length - 2]) {
      case "policy":
        docType = "Policy";
        break;
      case "risknote":
        docType = "RiskNote";
        break;
      case "opportunity":
        docType = "Opportunity";
        break;
      case "quoterequest":
        docType = "QuoteRequest";
        break;
      case "quote":
        docType = "Quote";
        break;
      default:
        docType = "Policy";
    }

    // fetch number generation to check if its auto or manual
    setPlType(docType);
    fetchNumberGeneration(docType);
    fetchChannels();
    //if quote is selected, use quoteId to get quote details
    //if its new record, no fetch is necessary
    if (quoteId !== "new") {
      fetchQuote(true);
    } else {
      const currentDate = new Date();
      const oneYearLater = new Date(currentDate);
      oneYearLater.setFullYear(currentDate.getFullYear() + 1);
      // Subtract one day from the next year's date
      oneYearLater.setDate(oneYearLater.getDate() - 1);

      // Formatting date to match the input type "date" format (YYYY-MM-DD)
      const formattedCurrentDate = currentDate.toISOString().split("T")[0];
      const formattedOneYearLater = oneYearLater.toISOString().split("T")[0];

      setPlGlDate(formattedCurrentDate);
      setPlFmDate(formattedCurrentDate);
      setPlToDate(formattedOneYearLater);

      const fmDate = new Date(formattedCurrentDate);
      const toDate = new Date(formattedOneYearLater);
      calculateDateDifference(fmDate, toDate);

      setPlEndIndex(0);
      setPlEndNo("New");
      setPlEndCode("000");
      setPlEndName("New Business");
      setPlInternalEndCode("000");
      fetchProducts();
      fetchCurrencies();
      fetchBranches();
      fetchQuoteStages();
      fetchReceiptMode();
      fetchPaymentFreqs();
      fetchPaymentModes();
      fetchBanks();
      fetchQuoteMethods();
      fetchQuoteSources();
      fetchPriorityLevels();
      fetchAccountRoles();
      fetchActivityTypes();
      fetchTenderTypes();
      fetchSubmissionMethods();
      fetchConveyance();
      fetchJurisdictions();
      // set default quote stage
      setPlQuoteStage({
        value: "Introduction",
        label: "Introduction",
      });
      setPlOpPriority({
        value: "Normal",
        label: "Normal",
      });
      setPlOpSource({
        value: "Direct",
        label: "Direct",
      });
      // set focus to products field
      if (["Opportunity", "Quote", "QuoteRequest"].includes(plType)) {
        if (opportunityNameRef.current) {
          opportunityNameRef.current.focus();
        }
      } else {
        if (productRef.current) {
          productRef.current.focus();
        }
      }

    }

  }, [quoteId, docid]);


  const handleExpressSmis = (value, rowId, field) => {
    try {
      const updatedData = [...expressSmis];
      const index = updatedData.findIndex(smi => smi._id === rowId);
      if (index !== -1) {
        const numberFields = ["exp_default_si", "exp_rate", "exp_rate_per", "exp_premium", "exp_fcl_value", "exp_qty"];
        // console.log(`field is ${field} ... value is ... ${value}`);
        // if (numberFields.includes(field)) {
        //   updatedData[index][field] = formatStringToNumberV2(value);
        // } else {
        //   updatedData[index][field] = value;
        // }
        updatedData[index][field] = value;
        updatedData[index]["changed_xx"] = "Y";
        setExpressSmis(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleExpressSmisBlur = (id, field) => {
    try {
      const updatedData = [...expressSmis];
      const index = updatedData.findIndex(smi => smi._id === id);

      if (index !== -1) {
        const value = updatedData[index][field];
        const numberFields = ["exp_default_si", "exp_rate", "exp_rate_per", "exp_premium", "exp_fcl_value", "exp_qty"];

        // format numeric fields
        if (numberFields.includes(field)) {
          updatedData[index][field] = formatAmountsToDecimals(value, field === "exp_rate" ? 4 : 2);
        } else {
          updatedData[index][field] = value;
        }

        updatedData[index]["changed_xx"] = "Y";

        // STEP 1: Propagation logic
        if (field === "exp_default_si") {
          const propagateList = updatedData[index].exp_propagate_si || [];
          if (propagateList.length > 0) {
            propagateList.forEach(targetName => {
              const targetIndex = updatedData.findIndex(smi => smi.exp_smi_name === targetName);
              if (targetIndex !== -1) {
                updatedData[targetIndex][field] = updatedData[index][field];
                updatedData[targetIndex]["changed_xx"] = "Y";
              }
            });
          }
        }

        // STEP 2: You can extend this pattern for any other propagating field
        // e.g., if you want to propagate exp_fcl_value, exp_rate, etc.
        // just add more conditions like:
        // if (field === "exp_fcl_value") { ... }

        setExpressSmis(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (vehicleDialogOpen) {
      vehicleInputRef.current.focus();
    }
  }, [vehicleDialogOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      // for hiding options
      if (actionsRef.current && !actionsRef.current.contains(event.target)) {
        setOpenOptions(false);
      }

      if (expiringInRef.current && !expiringInRef.current.contains(event.target)) {
        setExpiringInMenuOpen(false);
      }

      // for hiding actions menu
      if (actionsMenuRef.current && !actionsMenuRef.current.contains(event.target)) {
        setOpenOptions(false);
      }

      // for hiding receipt
      // if (receiptRef.current && !receiptRef.current.contains(event.target)) {
      //   setReceiptOpen(false);
      // }
    }

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  return (
    <motion.div
      className="uw-policy"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="main-policy-wrapper">
          <div className="navbar">
            <div className="navbar-left">
              <div style={{ display: 'flex', flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "center" }}>
                <span className="page-title"> {selectedInsured?.ent_name?.toUpperCase() || plOpName?.toUpperCase() || t('new').toUpperCase()}  </span>
                {quoteId !== "new" &&
                  quoteData?.pl_renewal_status !== "Renew" &&
                  <span className="caution-title xrsmall" style={{ fontSize: "10px", fontWeight: "bold" }}>
                    {`${t('renewalStatusNotice', { param1: quoteData?.pl_renewal_status }).toUpperCase()}`}
                  </span>}
              </div>
              <div style={{ display: 'flex', flexDirection: "row", gap: "5px" }}>
                <span className="sub-title xrsmall" style={{ fontSize: "10px" }}>{`${selectedProduct?.label || ''} [${selectedProduct?.value || 'New'}]`}</span>
                {quoteData?.pl_subagent_ent_code &&
                  !currentUser?.usr_entity_code &&
                  <span className="sub-title xrsmall">{`${t('subAgent')} : ${quoteData?.sub_agent_name}`}</span>}
                {quoteData?.pl_status === "Active" && <span className="sub-title xrsmall" style={{ fontSize: "10px" }}>{quoteData?.pl_gl_doc}</span>}
              </div>
            </div>
            <div className="navbar-right">
              {Object.keys(quoteData).length > 0 && (
                <>
                  {documentEnabled === "Y" && (
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      endIcon={<LuRefreshCcw />}
                      borderRadiusType="both"
                      variant="tint"
                      color="#0f766e5d"
                      onClick={refreshQuote}
                    >
                      {t('refresh')}
                    </CustomLoadingButton>
                  )}
                  {documentEnabled === "N" && (
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      endIcon={<LuRefreshCcw />}
                      borderRadiusType="both"
                      variant="tint"
                      color="#0f766e5d"
                      onClick={fetchQuote}
                    >
                      {t('refresh')}
                    </CustomLoadingButton>
                  )}
                  {quoteData?.pl_latest === "Y" &&
                    nextAction !== "None" &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      endIcon={<DragIndicatorIcon />}
                      borderRadiusType="both"
                      variant="tint"
                      color="#fbbf24"
                      onClick={() => {
                        try {
                          let action_text = "";
                          let new_doc_status = quoteData?.pl_status;

                          if (["RiskNote", "Quote", "Policy"].includes(quoteData?.pl_type)) {
                            switch (quoteData?.pl_status) {
                              case "New":
                                action_text = `Do you want to Validate ${plRiskNoteNo}?`;
                                setInvokedAction("Validate");
                                new_doc_status = "Validated";
                                break;
                              case "Validated":
                                if (quoteData?.pl_end_index === 0) {
                                  action_text = `Do you want to Approve ${plRiskNoteNo}?`;
                                } else {
                                  action_text = `Do you want to Approve ${plEndName} endorsement for ${plRiskNoteNo}?`;
                                }
                                setInvokedAction("Approve");
                                new_doc_status = "Approved";
                                break;
                              case "Approved":
                                action_text = `Do you want to Endorse ${plRiskNoteNo}?`;
                                setInvokedAction("Endorse");
                                new_doc_status = "Endorsed";
                                break;
                              case "Active":
                                action_text = `Do you want to Endorse ${plRiskNoteNo}?`;
                                setInvokedAction("Endorse");
                                new_doc_status = "Endorsed";
                                break;
                              case "Expired":
                                action_text = `Do you want to Endorse ${plRiskNoteNo}?`;
                                setInvokedAction("Endorse");
                                new_doc_status = "Endorsed";
                                break;
                              case "Endorsed":
                                if (quoteData?.pl_end_index === 0) {
                                  action_text = `Do you want to Validate ${plRiskNoteNo}?`;
                                } else {
                                  action_text = `Do you want to Validate ${plEndName} endorsement for ${plRiskNoteNo}?`;
                                }
                                setInvokedAction("Validate");
                                new_doc_status = "Validated";
                                break;
                              default:
                                action_text = "";
                                new_doc_status = "";
                            }

                            // user cannot endorse a risk note without policy number
                            if (!quoteData?.pl_no && new_doc_status === "Endorsed" &&
                              ["RiskNote", "Policy"].includes(quoteData?.pl_type)
                            ) {
                              setNotifyDialogTitle("Note!");
                              setNotifyDialogText(`You cannot endorse until you specify the Policy Number`);
                              setIsNotifyDialogOpen(true);
                              return;
                            }

                            // UW1025 - User allowed complete document without commission
                            if (["agent", "broker"].includes(currentUser?.token_org_type)) {
                              if (getLimitValue("UW1025") === "N" && new_doc_status === "Validated" && parseFloat(quoteData?.commission_net_fc) === 0) {
                                setNotifyDialogTitle("Note!");
                                setNotifyDialogText(`UW1025 - You cannot complete this document without specifying commission`);
                                setIsNotifyDialogOpen(true);
                                return;
                              }
                            }

                            setObjectToAction({
                              object_id: quoteData._id,
                              action_text: action_text,
                              new_doc_status,
                            });
                            setConfirmDialogAction("policyAction");
                            setIsConfirmDialogOpen(true);

                          } else if (["Opportunity"].includes(quoteData?.pl_type)) {
                            switch (quoteData?.pl_status) {
                              case "Submit":
                                setObjectToAction({ object_id: quoteData._id, action_text: `What would you like to do?`, action: "opportunityAction" });
                                setInvokedAction("createQuote");
                                setButtonOneTitle("Create Quote");
                                setButtonTwoTitle("Create Quote Request");
                                break;
                              default:
                                setObjectToAction({ object_id: quoteData._id, action_text: `What would you like to do?`, action: "opportunityAction" });
                                setInvokedAction("createQuote");
                                setButtonOneTitle("Create Quote");
                                setButtonTwoTitle("Create Quote Request");
                            }
                            setConfirmDialogAction("opportunityAction");
                            setIsThreeButtonDialogOpen(true);
                          } else if (["QuoteRequest"].includes(quoteData?.pl_type)) {
                            if (plParticipants?.length === 0) {
                              setNotifyDialogTitle("Note!");
                              setNotifyDialogText(`You must select participants to proceed`);
                              setIsNotifyDialogOpen(true);
                              return;
                            }
                            switch (quoteData?.pl_status) {
                              case "New":
                                setObjectToAction({ object_id: quoteData._id, action_text: `Do you want to publish this quote request?. NOTE: Participants will be notified via email`, new_doc_status: "Published" });
                                setInvokedAction("publishQuoteRequest");
                                break;
                              default:
                                setObjectToAction({ object_id: quoteData._id, action_text: `Do you want to publish this quote request?. NOTE: Participants will be notified via email`, new_doc_status: "Published" });
                                setInvokedAction("publishQuoteRequest");
                            }
                            setConfirmDialogAction("publishQuoteRequest");
                            setIsConfirmDialogOpen(true);
                          }
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      {quoteData?.next_action_xx || nextAction}
                    </CustomLoadingButton>}
                  {quoteData?.pl_latest === "N" &&
                    <CustomLoadingButton
                      scurrentTheme={currentTheme}
                      iconPosition="end"
                      endIcon={<DragIndicatorIcon />}
                      borderRadiusType="both"
                      variant="EDE9FE"
                      color="#0f766e5d"
                      onClick={async () => {
                        try {
                          // setIsProcessing(true);
                          setQuoteId(quoteData?.latest_risk_note_docid);
                          setQuoteData({});
                          // setActiveTab(10);
                          // // Simulate delay for 2 seconds
                          // await new Promise((resolve) => setTimeout(resolve, 2000));
                          await fetchQuote();
                          navigate(`/uw/${plType?.toLowerCase()}/${quoteData?.latest_risk_note_docid}`, { replace: true });
                          // setActiveTab(0);
                          // setIsProcessing(false);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      {t("latestNoteNo", { noteNo: quoteData?.latest_risk_note_no })}
                    </CustomLoadingButton>
                  }
                </>
              )}
              {saveEnabled === "Y" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  endIcon={<FaSave />}
                  borderRadiusType="both"
                  variant="tint"
                  color="#00D37F"
                  tooltip="Save changes"
                  onClick={saveRecord}>
                  {t('save')}
                </CustomLoadingButton>
              )}
              {Object.keys(quoteData).length > 0 &&
                !["Deleted", "Voided"].includes(plStatus) &&
                (
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    endIcon={<IoDocumentTextSharp />}
                    borderRadiusType="both"
                    variant="tint"
                    color="#2563EB"
                    tooltip="Run reports for this document"
                    onClick={() => setReportsDialogOpen(true)}>
                    {t('reports')}
                  </CustomLoadingButton>
                )}
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                endIcon={<MdClose />}
                borderRadiusType="both"
                variant="tint"
                color="#f55656"
                tooltip="Close this document"
                onClick={() => navigate(-1)}>
                {t('close')}
              </CustomLoadingButton>
              {/* Additional Actions for priviledged users */}
              {(["Validated", "Active", "New", "Endorsed"].includes(plStatus) ||
                ["In Grace Period", "Expiring today"].includes(quoteData?.expiring_status)) &&
                <div className="icon-container"
                  ref={actionsMenuRef}
                  onClick={(e) => {
                    try {
                      e.stopPropagation();
                      setOpenOptions(!openOptions);
                    } catch (error) {
                      console.log(error)
                    }
                  }}>
                  <MdOutlineMenuOpen className="icon" />
                  {openOptions && (
                    <div className="dropdown">
                      {/* UW1012 User allowed to reset validation */}
                      {plStatus === "Validated" && getLimitValue("UW1012") === "Y" &&
                        <div className="dropdown-item"
                          onClick={() => {
                            try {
                              setObjectToAction({
                                object_id: quoteData._id,
                                action_text: `Do you want to reset DOCUMENT status back to <b>NEW</b>?<br><br>Please note the document will be opened for <b>AMENDMENTS</b>`,
                                new_doc_status: "New",
                              });
                              setOpenOptions(false);
                              setConfirmDialogAction("invalidatePolicy");
                              setIsConfirmDialogOpen(true);
                            } catch (error) {
                              console.log(error);
                            }
                          }}>{t('reset')}
                        </div>}
                      {plStatus === "Active" &&
                        <div className="dropdown-item"
                          onClick={async () => {
                            try {

                              // check if uw period is open
                              const uw = await newRequest.post(
                                "/glCp/periodStatus",
                                {
                                  cp_cy_type: "Underwriting",
                                  gl_date: moment(plGlDate).format("YYYY-MM-DD"),
                                }
                              );
                              // console.log(`glCp/periodStatus  ${JSON.stringify(res.data, null, 2)}`);
                              if (uw.data?.cp_status === "Closed") {
                                setIsConfirmDialogOpen(false);
                                setConfirmDialogAction("None");
                                setNotifyDialogTitle("Note!");
                                setNotifyDialogText(
                                  `${formatTypeName(plType)} date <b>${moment(plGlDate).format(
                                    "DD-MMM-YYYY"
                                  )}</b> is within Underwriting period <b>${uw.data?.cp_code
                                  }</b>. The period is <b>${uw.data?.cp_status
                                  }</b>. You cannot VOID when period is closed.`
                                );
                                setIsNotifyDialogOpen(true);
                                return;
                              }

                              // check if gl period is open
                              const gl = await newRequest.post(
                                "/glCp/periodStatus",
                                {
                                  cp_cy_type: "Financial",
                                  gl_date: moment(plGlDate).format("YYYY-MM-DD"),
                                }
                              );

                              // console.log(`glCp/periodStatus  ${JSON.stringify(res.data, null, 2)}`);
                              if (gl.data?.cp_status === "Closed") {
                                setIsConfirmDialogOpen(false);
                                setConfirmDialogAction("None");
                                setNotifyDialogTitle("Note!");
                                setNotifyDialogText(
                                  `${formatTypeName(plType)} date <b>${moment(plGlDate).format("DD-MMM-YYYY")}</b> is within Financial period <b>${gl.data?.cp_code
                                  }</b>. The period is <b>${gl.data?.cp_status}</b>. You cannot VOID when period is closed.`
                                );
                                setIsNotifyDialogOpen(true);
                                return;
                              }

                              setObjectToAction({
                                object_id: quoteData._id,
                                action_text: `Do you want to <strong>VOID APPROVAL</strong> this document?`,
                                new_doc_status: "New",
                              });
                              setOpenOptions(false);
                              setConfirmDialogAction("voidPolicy");
                              setIsConfirmDialogOpen(true);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >{t('voidApproval')}</div>}
                      {!plNo &&
                        <div className="dropdown-item"
                          onClick={() => setIsManualPolicyNo(true)}
                        >{t('setPolicyNo')}</div>}

                      {/* set renewal status of a document */}
                      {plStatus === "Active" && getLimitValue("UW1031") === "Y" &&
                        <div className="dropdown-item"
                          onClick={async () => {
                            try {
                              await fetchRenewalStatuses();
                              setSelectedRenStatus({
                                value: quoteData.pl_renewal_status || "Renew",
                                label: quoteData.pl_renewal_status || "Renew",
                              });
                              setRenStatusDialogOpened(true);
                            } catch (error) {
                              console.log(error);
                            }
                          }}>{t('renewalStatus')}
                        </div>}

                      {["New", "Endorsed"].includes(plStatus) &&
                        <div className="dropdown-item"
                          onClick={() => {
                            try {
                              setObjectToAction({
                                object_id: quoteData._id,
                                action_text: `Do you want to <b>VOID</b> this document?</br></br>Please NOTE this action is IRREVERSIBLE`,
                                new_doc_status: "Voided",
                              });
                              setOpenOptions(false);
                              setConfirmDialogAction("voidDocument");
                              setIsConfirmDialogOpen(true);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >{t('void')}</div>}
                      {plStatus === "New" &&
                        plEndNo === "New" &&
                        getLimitValue("UW1032") === "Y" &&
                        ["superadmin"].includes(currentUser.user_type_xx) &&
                        <div className="dropdown-item"
                          onClick={() => {
                            try {
                              setObjectToAction({
                                object_id: quoteData._id,
                                action_text: `DELETE THIS DOCUMENT?</br></br>Please NOTE this actions is IRREVERSIBLE`,
                                new_doc_status: "New",
                              });
                              setOpenOptions(false);
                              setConfirmDialogAction("deletePolicy");
                              setIsConfirmDialogOpen(true);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >{t('delete')}</div>}
                    </div>
                  )}
                </div>}
              {quoteId !== "new" && (
                <div className="collaborator-icon"
                  onClick={openCollab}>
                  <MdForum className="icon" />
                </div>
              )}
            </div>
          </div>
          <div className="document-details-wrapper">
            <div className="content-wrapper">
              <div className="tabs-container">
                <div className="tab-header">
                  {topMenus?.map((tab, index) => (
                    <div
                      key={index}
                      className={`${activeTab === index ? 'tab active' : 'tab'}`}
                      onClick={() => setActiveTab(index)}
                    >
                      <span className={`${activeTab === index ? 'tab-icon active' : 'tab-icon'}`}>
                        {tab.menu_icon}
                      </span>
                      <span className={`${activeTab === index ? 'tab-title active' : 'tab-title'}`}>{tab.menu_title}</span>
                      {tab.menu_count > 0 && <Badge badgeContent={tab.menu_count} showZero
                        className={activeTab === index ? "tab-badge active" : "tab-badge"} />}
                    </div>
                  ))}
                </div>
              </div>
              <div className="policy-content-details">
                {/* Summary Information */}
                {activeTab === 0 &&
                  <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                    {["Active", "Cancelled"].includes(quoteData?.pl_status) ?
                      <UwPolicyRead quoteData={quoteData} currentTheme={currentTheme} currentUser={currentUser} />
                      :
                      <div style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                        gap: "5px",
                        paddingBottom: "5px"
                      }}>
                        {documentEnabled === "Y" && plEndCode === "000" ?
                          <div className="content-details-row" style={{ gap: "5px" }}>

                            {/* FOR INSURANCE COMPANIES */}
                            {plType === "Policy" &&
                              <div className="input-item-with-label" style={{ display: "flex", flex: "1.5" }}>
                                <label htmlFor="pl_no" className="form-dropdown-label" style={{ width: "120px" }}>
                                  {t('policyNo').toUpperCase()}
                                </label>
                                {quoteId === "new" ?
                                  <input
                                    id="pl_no"
                                    name="pl_no"
                                    type="text"
                                    placeholder={t('policyNo').toUpperCase()}
                                    value={plNo}
                                    className="form-input-item"
                                    style={{ width: "100%" }}
                                    onChange={(e) => {
                                      try {
                                        setPlNo(e.target.value)
                                        setQuoteData(prevData => ({
                                          ...prevData,
                                          pl_no: e.target.value
                                        }));
                                      } catch (error) {
                                        console.log(error)
                                      }
                                    }}
                                    disabled={!enablePolicyNo}
                                  /> : <span className="normal-title">{plNo}</span>}
                              </div>}

                            {/* FOR INTERMEDIARIES */}
                            {["RiskNote", "Opportunity", "Quote", "QuoteRequest"].includes(plType) &&
                              <div className="input-item-with-label" style={{ display: "flex", flex: "1.5" }}>
                                {quoteId === "new" &&
                                  <label htmlFor="pl_risk_note_no" className="form-dropdown-label" style={{ width: "120px" }}>
                                    {formatTypeName(plType)}
                                  </label>}
                                {quoteId === "new" &&
                                  <input
                                    id="pl_risk_note_no"
                                    name="pl_risk_note_no"
                                    type="text"
                                    placeholder={t('noteNo').toUpperCase()}
                                    value={plRiskNoteNo}
                                    className="form-input-item"
                                    style={{ width: "100%" }}
                                    onChange={(e) => {
                                      try {
                                        setPlRiskNoteNo(e.target.value)
                                        setQuoteData(prevData => ({
                                          ...prevData,
                                          pl_risk_note_no: e.target.value
                                        }));
                                      } catch (error) {
                                        console.log(error)
                                      }
                                    }}
                                    disabled={!plRiskNoteNo}
                                  />}
                                {quoteId !== "new" && <h1 className="main-title">{`${formatTypeName(plType)}: ${plRiskNoteNo}`}</h1>}
                              </div>}
                            <div className="input-item-with-label" style={{ display: "flex", flex: "1.5" }}>
                              {/* <label htmlFor="pl_biz_unit">BIZ UNIT</label> */}
                              <Select
                                id="pl_biz_unit"
                                name="pl_biz_unit"
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="100%"
                                height="36px"
                                value={selectedBranch}
                                onChange={(selectedOption) => setSelectedBranch(selectedOption)}
                                options={branches}
                                isSearchable={true}
                                isDisabled={documentEnabled === "N"}
                                placeholder={t('bizUnit').toUpperCase()}
                              />
                            </div>
                            <div className={`status ${getCssValue(quoteData?.expiring_status)}`}
                              style={{ display: "flex", flex: "1", alignItems: "center", justifyContent: "center", height: "36px" }}>
                              <span>{`${t('status').toUpperCase()} ${quoteData?.expiring_status}`}</span>
                            </div>
                          </div>
                          :
                          <div className="content-details-row approved-doc">
                            {["RiskNote", "Opportunity", "Quote", "QuoteRequest"].includes(plType) && <span className="main-title">{`${formatTypeName(plType)}: ${plRiskNoteNo}`}</span>}
                            {["Policy", "Renewal"].includes(plType) && <span className="main-title" style={{ alignSelf: "flex-start" }}>{`${formatTypeName(plType)}: ${plNo}`}</span>}
                            <span className="main-title">{`${t('bizUnit').toUpperCase()}: ${selectedBranch?.label}`}</span>
                            <span className={`main-title status ${getCssValue(quoteData?.expiring_status)}`}>{quoteData?.expiring_status}</span>
                          </div>}
                        {/* this view shows when the policy is in Endorsed status to guide the user what can be changed */}
                        {plStatus === "Endorsed" &&
                          <ExpandableComponent
                            title={t('endorsementInstructions').toUpperCase()}
                            subtitle={""}
                            defaultExpanded={true}
                          >
                            <div className="content-details-row">
                              <h1 className="sub-title">{quoteData?.endorsement_instructions_xx?.instruction_title}</h1>
                            </div>
                            {quoteData?.endorsement_instructions_xx?.instructions?.length > 0 &&
                              <div className="basis-of-claim">
                                {quoteData?.endorsement_instructions_xx?.instructions?.map((row, index) => (
                                  <div key={index} className="single-basis-row">
                                    <span style={{ alignContent: "flex-start" }}>
                                      {index + 1}.
                                    </span>
                                    <h1 className="sub-title">{row?.ins_text}</h1>
                                  </div>
                                ))}
                              </div>}
                          </ExpandableComponent>}
                        {/* product details starts here */}
                        <ExpandableComponent
                          title={`${t('product').toUpperCase()} - [${selectedProduct?.value || t('unspecified').toUpperCase()}]`}
                          subtitle={["Opportunity", "Quote", "QuoteRequest"].includes(plType) ? plType : plEndName}
                          defaultExpanded={true}
                        >
                          {["Opportunity", "Quote", "QuoteRequest"].includes(plType) &&
                            <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", width: "100%", gap: "5px", paddingRight: "5px" }}>
                              <div className="input-item-with-label" style={{ display: "flex", width: "100%", gap: "5px" }}>
                                <label
                                  htmlFor="pl_op_name"
                                  className="form-dropdown-label"
                                  style={{ width: "110px" }}
                                >
                                  {t('name').toUpperCase()}
                                </label>
                                {documentEnabled === "Y" ?
                                  <input
                                    ref={opportunityNameRef}
                                    id="pl_op_name"
                                    name="pl_op_name"
                                    type="text"
                                    placeholder={t('name').toUpperCase()}
                                    value={plOpName}
                                    className="form-input-item"
                                    style={{ width: "100%" }}
                                    onChange={(e) => setPlOpName(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  /> : <span className='normal-title'>{plOpName || t('unspecified')}</span>}
                                {!selectedInsured &&
                                  plOpName &&
                                  (plOpPhoneNo || plOpEmail) &&
                                  <CustomButtonSmall
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    height="42px"
                                    width="200px"
                                    endIcon={<MdAdd />}
                                    onClick={async () => {
                                      try {
                                        const res = await newRequest.post(
                                          "/allEntity/add",
                                          {
                                            ent_aent_code: "Client",
                                            ent_type: "Unspecified",
                                            ent_status: "Active",
                                            ent_name: plOpName,
                                            ent_email: plOpEmail,
                                            ent_phone_no: plOpPhoneNo,
                                          }
                                        );

                                        setSelectedInsured({
                                          ent_docid: res.data?._id,
                                          ent_email: res.data?.ent_email,
                                          ent_phone_no: res.data?.ent_phone_no,
                                          ent_photo_url: "",
                                          ent_status: res.data?.ent_status,
                                          aent_name_xx: res.data?.ent_aent_code,
                                          ent_code: res.data?.ent_code,
                                          ent_aent_code: res.data?.ent_aent_code,
                                          ent_name: res.data?.ent_name,
                                          value: res.data?.ent_code,
                                          label: res.data?.ent_name,
                                        });

                                        await newRequest.put(
                                          `/uwPolicy/upd/${quoteId}`,
                                          {
                                            pl_assr_aent_code: res.data?.ent_aent_code,
                                            pl_assr_ent_code: res.data?.ent_code
                                          }
                                        );

                                        showToast(t('createAsClientResult', { param1: res.data?.ent_name }), "success");
                                      } catch (err) {
                                        let dialogText = "An error occurred.";
                                        if (err.response && err.response.status === 400) {
                                          const { message, errors } = err.response.data;
                                          if (errors && Array.isArray(errors)) {
                                            // Format validation errors for display
                                            const errorMessages = errors.map((e) => `• ${e.message}`).join("\n");
                                            dialogText = `${message}\n\n${errorMessages}`;
                                          } else if (message) {
                                            dialogText = message;
                                          }
                                        } else if (err.message) {
                                          // Handle generic errors
                                          dialogText = err.message;
                                        }
                                        // console.log(`dialogText  ${JSON.stringify(dialogText, null, 2)}`);
                                        // Set the dialog content
                                        setNotifyDialogTitle("Validation Error");
                                        setNotifyDialogText(dialogText);
                                        setIsNotifyDialogOpen(true);
                                      }
                                    }}
                                  >
                                    {t('createAsClient').toUpperCase()}
                                  </CustomButtonSmall>}
                              </div>
                              <div style={{
                                display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between"
                              }}>
                                <div className="input-item-with-label" style={{ flex: "1" }}>
                                  <label
                                    htmlFor="pl_op_phone_no"
                                    className="form-dropdown-label"
                                    style={{ width: "130px" }}
                                  >
                                    {t('phoneNo').toUpperCase()}
                                  </label>
                                  <input
                                    id="pl_op_phone_no"
                                    name="pl_op_phone_no"
                                    type="text"
                                    placeholder={t('phoneNo').toUpperCase()}
                                    value={plOpPhoneNo}
                                    className="form-input-item"
                                    style={{ width: "100%" }}
                                    onChange={(e) => setPlOpPhoneNo(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                                <div className="input-item-with-label" style={{ flex: "1" }}>
                                  <label
                                    htmlFor="pl_op_email"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                  >
                                    {t('email').toUpperCase()}
                                  </label>
                                  <input
                                    id="pl_op_email"
                                    name="pl_op_email"
                                    type="email"
                                    placeholder={t('email').toUpperCase()}
                                    value={plOpEmail}
                                    className="form-input-item"
                                    style={{ width: "100%" }}
                                    onChange={(e) => setPlOpEmail(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                              </div>
                              <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                <div className="input-item-with-label" style={{ flex: "1" }}>
                                  <label
                                    htmlFor="pl_quote_stage"
                                    className="form-dropdown-label"
                                    style={{ width: "130px" }}
                                  >
                                    {t('stage').toUpperCase()}
                                  </label>
                                  <Select
                                    id="pl_quote_stage"
                                    name="pl_quote_stage"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="100%"
                                    value={plQuoteStage}
                                    onChange={async (selectedOption) => setPlQuoteStage(selectedOption)}
                                    options={quoteStages}
                                    isSearchable={true}
                                    isDisabled={documentEnabled === "N"}
                                    placeholder={t('stage').toUpperCase()}
                                  />
                                </div>
                                <div className="input-item-with-label" style={{ flex: "1" }}>
                                  <label
                                    htmlFor="pl_op_method"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                  >
                                    {t('method').toUpperCase()}
                                  </label>
                                  <Select
                                    id="pl_op_method"
                                    name="pl_op_method"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="100%"
                                    value={plOpMethod}
                                    onChange={async (selectedOption) => setPlOpMethod(selectedOption)}
                                    options={quoteMethods}
                                    isSearchable={true}
                                    isDisabled={documentEnabled === "N"}
                                    placeholder={t('method').toUpperCase()}
                                  />
                                </div>
                              </div>
                              <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                <div className="input-item-with-label" style={{ flex: "1" }}>
                                  <label
                                    htmlFor="pl_op_source"
                                    className="form-dropdown-label"
                                    style={{ width: "130px" }}
                                  >
                                    {t('source').toUpperCase()}
                                  </label>
                                  <Select
                                    id="pl_op_source"
                                    name="pl_op_source"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="100%"
                                    value={plOpSource}
                                    onChange={async (selectedOption) => setPlOpSource(selectedOption)}
                                    options={quoteSources}
                                    isSearchable={true}
                                    isDisabled={documentEnabled === "N"}
                                    placeholder={t('source').toUpperCase()}
                                  />
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", flex: "1" }}>
                                  <div className="input-item-with-label" style={{ flex: "0.7" }}>
                                    <label
                                      htmlFor="pl_op_priority"
                                      className="form-dropdown-label"
                                      style={{ width: "110px" }}
                                    >
                                      {t('priority').toUpperCase()}
                                    </label>
                                    <Select
                                      id="pl_op_priority"
                                      name="pl_op_priority"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999,
                                        })
                                      }}
                                      width="100%"
                                      value={plOpPriority}
                                      onChange={async (selectedOption) => setPlOpPriority(selectedOption)}
                                      options={priorityLevels}
                                      isSearchable={true}
                                      isDisabled={documentEnabled === "N"}
                                      placeholder={t('priority').toUpperCase()}
                                    />
                                  </div>
                                  <div className="input-item-with-label" style={{ flex: "0.3", alignSelf: "flex-end" }}>
                                    <label
                                      htmlFor="pl_win_probability"
                                      className="form-dropdown-label"
                                      style={{ width: "100px" }}
                                    >
                                      {t('win').toUpperCase()}
                                    </label>
                                    <input
                                      id="pl_win_probability"
                                      name="pl_win_probability"
                                      type="number"
                                      placeholder={t('win').toUpperCase()}
                                      value={plWinProbability}
                                      className="form-input-item"
                                      style={{ width: "100%", textAlign: "right" }}
                                      onChange={(e) => setPlWinProbability(e.target.value)}
                                      disabled={documentEnabled === "N"}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>}
                          {["Quote", 'Opportunity'].includes(plType) && <hr className="separator-h" />}
                          {["Policy", "RiskNote", "Renewal"].includes(plType) &&
                            <div className={documentEnabled === "Y" ? "content-details-row" : "content-details-row disabled-state"}>
                              {/* FOR INSURANCE COMPANIES */}
                              {currentUser?.token_org_type === "insurance" &&
                                <div className="input-item-with-label">
                                  <label htmlFor="pl_channel" className="form-dropdown-label" style={{ width: "100px" }}>{t('channel').toUpperCase()}</label>
                                  <Select
                                    id="pl_channel"
                                    name="pl_channel"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="250px"
                                    value={plChannel}
                                    onChange={async (selectedOption) => setPlChannel(selectedOption)}
                                    options={channels}
                                    isSearchable={true}
                                    isDisabled={documentEnabled === "N"}
                                    placeholder={t('channel').toUpperCase()}
                                  />
                                </div>}
                              {/* FOR AGENTS AND BROKERS */}
                              {["agent", "broker"].includes(currentUser?.token_org_type) &&
                                <div className="input-item-with-label">
                                  <label htmlFor="pl_no" className="form-dropdown-label" style={{ width: "100px" }}>
                                    {t('policyNo').toUpperCase()}
                                  </label>
                                  {quoteId === "new" ?
                                    <input
                                      id="pl_no"
                                      name="pl_no"
                                      type="text"
                                      placeholder={t('policyNo').toUpperCase()}
                                      value={plNo}
                                      className="form-input-item"
                                      style={{ width: "250px" }}
                                      onChange={(e) => {
                                        try {
                                          setPlNo(e.target.value)
                                          setQuoteData(prevState => ({
                                            ...prevState,
                                            pl_no: e.target.value
                                          }));
                                        } catch (error) {
                                          console.log(error)
                                        }
                                      }}
                                      disabled={!enablePolicyNo}
                                    /> : <span className='normal-title' style={{ width: "250px" }}>{plNo}</span>}
                                </div>}
                              <div className="input-item-with-label">
                                <label htmlFor="pl_type" className="form-dropdown-label">
                                  {t('type').toUpperCase()}
                                </label>
                                <input
                                  id="pl_type"
                                  name="pl_type"
                                  type="text"
                                  placeholder={t('type').toUpperCase()}
                                  disabled
                                  value={plType}
                                  className="form-input-item"
                                  style={{ width: "250px" }}
                                  onChange={(e) => setPlType(e.target.value)}
                                />
                              </div>
                            </div>}
                          <div className={documentEnabled === "Y" ? "content-details-row" : "content-details-row disabled-state"}>
                            <div className="input-item-with-label">
                              <label htmlFor="pl_product_code" style={{ width: "100px" }}>{t('product').toUpperCase()}</label>
                              <Select
                                id="pl_product_code"
                                name="pl_product_code"
                                ref={productRef}
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="250px"
                                value={selectedProduct}
                                onChange={async (selectedOption) => {
                                  try {
                                    // console.log(`selectedOption ${JSON.stringify(selectedOption, null, 2)}`);
                                    if (["term life", "whole life"].includes(selectedOption?.product_type_xx)) {
                                      if (selectedOption?.product_terms_xx) {
                                        const termsOptions = selectedOption?.product_terms_xx.map((term) => ({
                                          term_years: term?.term_years,
                                          term_mc_code: term?.term_mc_code,
                                          term_sc_code: term?.term_sc_code,
                                          term_cc_code: term?.term_cc_code,
                                          value: term?.term_code,
                                          label: term?.term_name,
                                        }));
                                        setProductLifeTerms(termsOptions);
                                      }
                                    } else {
                                      setPlTermPaymentFreq({
                                        value: "lumpsum",
                                        label: "Lumpsum",
                                      });
                                    }

                                    setSelectedProduct(selectedOption);

                                    // get product express smis
                                    const express = await newRequest.post("/uwProduct/getExpressSmis", { exp_pr_code: selectedOption.pr_code });
                                    // logData("express", express);
                                    const formattedData = express.data?.map(row => ({
                                      ...row,
                                      exp_default_si: formatAmountsToDecimals(row?.exp_default_si, 2),
                                      exp_rate: formatAmountsToDecimals(row?.exp_rate, 4),
                                      exp_rate_per: formatAmountsToDecimals(row?.exp_rate_per, 2),
                                      exp_fcl_value: formatAmountsToDecimals(row?.exp_fcl_value, 2),
                                      exp_premium: formatAmountsToDecimals(row?.exp_premium, 2),
                                      exp_qty: formatAmountsToDecimals(row?.exp_qty, 2),
                                    }));
                                    // logData("expressSmis", formattedData);
                                    setExpressSmis(formattedData);

                                    // show motor validation screen if document is new and its motor
                                    if (selectedOption.pr_motor === "Y") {
                                      setVehicleDialogOpen(true);
                                    }

                                    setShowProjectInfo(selectedOption.pr_project_info);

                                    if (!plJurisdiction?.value && selectedOption?.pr_jurisdiction) {
                                      setPlJurisdiction({
                                        value: selectedOption?.pr_jurisdiction,
                                        label: selectedOption?.pr_jurisdiction,
                                      });
                                    }

                                    if (!plTerritory?.value && selectedOption?.pr_territory) {
                                      setPlTerritory({
                                        value: selectedOption?.pr_territory,
                                        label: selectedOption?.pr_territory,
                                      });
                                    }

                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                options={products}
                                isSearchable={true}
                                isDisabled={documentEnabled === "N" || quoteData?.policy_risks?.length > 0}
                                placeholder={t('product').toUpperCase()}
                              />
                            </div>
                            <div className="input-item-with-label" >
                              <label htmlFor="pl_cur_code">{t('currency').toUpperCase()}</label>
                              <Select
                                id="pl_cur_code"
                                name="pl_cur_code"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="250px"
                                value={plCurCode}
                                onChange={async (selectedOption) => {
                                  try {
                                    //get currency rate
                                    if (
                                      selectedOption.cur_code !==
                                      currentUser?.currency_code_xx
                                    ) {
                                      setPlCurCode(selectedOption);
                                      // pass endorsement
                                      const res = await newRequest.post(
                                        "/glCurrencyRate/find",
                                        {
                                          rate_cur_code_fm: selectedOption?.cur_code,
                                          rate_cur_code_to: currentUser?.currency_code_xx,
                                          rate_date: plGlDate,
                                        }
                                      );
                                      if (!res.data || !res.data?.rate) {
                                        setPlCurCode({
                                          value: currentUser?.currency_code_xx,
                                          label: currentUser?.currency_code_xx,
                                        });
                                        setPlCurRate(1);
                                        setPlCurRateMd("M");
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(
                                          `Conversion Rate from <b>${selectedOption.cur_code
                                          } to ${currentUser?.currency_code_xx
                                          } for date ${moment(plGlDate).format(
                                            "DD-MMM-YYYY"
                                          )}</b> NOT found. Currency will reset to <b>${currentUser?.currency_code_xx
                                          }</b>`
                                        );
                                        setIsNotifyDialogOpen(true);
                                      } else {
                                        setPlCurRate(res.data?.rate);
                                        setPlCurRateMd(res.data?.rate_md);
                                      }
                                    } else {
                                      setPlCurCode({
                                        value: currentUser?.currency_code_xx,
                                        label: currentUser?.currency_name_xx,
                                      });
                                      setPlCurRate(1);
                                      setPlCurRateMd("M");
                                    }
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                options={currencies}
                                isSearchable={true}
                                isDisabled={documentEnabled === "N" || plEndIndex > 0}
                                placeholder={t('currency').toUpperCase()}
                              />
                            </div>
                          </div>
                          {/* this view  is applicable in life insurance */}
                          {["term life", "whole life"].includes(selectedProduct?.product_type_xx) &&
                            <div className={documentEnabled === "Y" ? "content-details-row" : "content-details-row disabled-state"}>
                              <div className="input-item-with-label">
                                <label htmlFor="pl_term_code" style={{ width: "100px" }}>{t('term').toUpperCase()}</label>
                                <Select
                                  id="pl_term_code"
                                  name="pl_term_code"
                                  ref={termRef}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="250px"
                                  value={plTermCode}
                                  onChange={(selectedOption) => {
                                    try {
                                      setPlTermCode(selectedOption);
                                      setPlTermYears(selectedOption?.term_years);
                                      handleFromDateBlur(selectedOption?.term_years);
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  options={productlifeTerms}
                                  isSearchable={true}
                                  isDisabled={documentEnabled === "N" || quoteData?.policy_risks?.length > 0}
                                  placeholder={t('term').toUpperCase()}
                                />
                              </div>
                              <div className="input-item-with-label">
                                <label htmlFor="pl_term_payment_freq" style={{ width: "100px" }}>{t('freq').toUpperCase()}</label>
                                <Select
                                  id="pl_term_payment_freq"
                                  name="pl_term_payment_freq"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="250px"
                                  value={plTermPaymentFreq}
                                  onChange={(selectedOption) => setPlTermPaymentFreq(selectedOption)}
                                  options={paymentFreqs}
                                  isSearchable={true}
                                  isDisabled={documentEnabled === "N"}
                                  placeholder={t('freq').toUpperCase()}
                                />
                              </div>
                            </div>}
                          {/* This is applicable for none life */}
                          {["Policy", 'RiskNote'].includes(plType) &&
                            !["term life", "whole life"].includes(selectedProduct?.product_type_xx) &&
                            <div className={documentEnabled === "Y" ? "content-details-row" : "content-details-row disabled-state"}>
                              <div className="input-item-with-label">
                                <label htmlFor="pl_term_payment_freq" style={{ width: "100px" }}>{t('premFreq').toUpperCase()}</label>
                                <Select
                                  id="pl_term_payment_freq"
                                  name="pl_term_payment_freq"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="250px"
                                  value={plTermPaymentFreq}
                                  onChange={(selectedOption) => setPlTermPaymentFreq(selectedOption)}
                                  options={paymentFreqs}
                                  isSearchable={true}
                                  isDisabled={documentEnabled === "N"}
                                  placeholder={t('premFreq').toUpperCase()}
                                />
                              </div>
                              <div className="input-item-with-label">
                                <label
                                  htmlFor="pl_gl_date"
                                  className="form-dropdown-label"
                                  style={{ width: "85px" }}
                                >
                                  {t('glDate').toUpperCase()}
                                </label>
                                <input
                                  id="pl_gl_date"
                                  name="pl_gl_date"
                                  type="date"
                                  placeholder={t('glDate').toUpperCase()}
                                  value={plGlDate}
                                  className="form-input-item"
                                  style={{ width: "250px" }}
                                  onChange={handleGlDateChange}
                                  disabled={documentEnabled === "N"}
                                />
                              </div>
                            </div>}
                          {["Policy", 'RiskNote'].includes(plType) &&
                            <div className={documentEnabled === "Y" ? "content-details-row" : "content-details-row disabled-state"}>
                              <div className="input-item-with-label">
                                <label
                                  htmlFor="pl_jurisdiction"
                                  className="form-dropdown-label"
                                  style={{ width: "100px" }}
                                >{t('jurisdiction').toUpperCase()}</label>
                                <CreatableSelect
                                  id="pl_jurisdiction"
                                  name="pl_jurisdiction"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="250px"
                                  value={plJurisdiction}
                                  onChange={(option) => handleSelectedJurisdiction(option, "pl_jurisdiction")}
                                  options={jurisdictions}
                                  isSearchable={true}
                                  isDisabled={documentEnabled === "N"}
                                  placeholder={t('jurisdiction').toUpperCase()}
                                />
                              </div>
                              <div className="input-item-with-label">
                                <label
                                  htmlFor="pl_territory"
                                  className="form-dropdown-label"
                                  style={{ width: "100px" }}
                                >
                                  {t('territory').toUpperCase()}
                                </label>
                                <CreatableSelect
                                  id="pl_territory"
                                  name="pl_territory"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="250px"
                                  value={plTerritory}
                                  onChange={(option) => handleSelectedJurisdiction(option, "pl_territory")}
                                  options={jurisdictions}
                                  isSearchable={true}
                                  isDisabled={documentEnabled === "N"}
                                  placeholder={t('territory').toUpperCase()}
                                />
                              </div>
                            </div>}
                          {/* {["Policy", 'RiskNote'].includes(plType) && <hr className="separator-h" />} */}
                          {["Policy", 'RiskNote'].includes(plType) &&
                            <div className={documentEnabled === "Y" ? "content-details-row" : "content-details-row disabled-state"}>
                              {plTermCode?.value &&
                                ["term life", "whole life"].includes(quoteData?.product_type_xx) &&
                                <div className="input-item-with-label">
                                  <label htmlFor="pl_term_years" className="form-dropdown-label" style={{ width: "100px" }}>
                                    {t('years').toUpperCase()}
                                  </label>
                                  <input
                                    id="pl_term_years"
                                    name="pl_term_years"
                                    type="number"
                                    placeholder="10"
                                    value={plTermYears}
                                    className="form-input-item"
                                    style={{ width: "60px", textAlign: "right" }}
                                    min="1"
                                    max="100"
                                    onChange={(e) => {
                                      const value = parseInt(e.target.value, 10);
                                      if (value < 1 || value > 100) {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(
                                          `Please ener value <b>between 1 and 100</b>.`
                                        );
                                        setIsNotifyDialogOpen(true);
                                        e.target.value = plTermYears;
                                      } else {
                                        try {
                                          setPlTermYears(value);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }
                                    }}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>}
                              <div style={{
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "15px",
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between"
                              }}>
                                <div className="input-item-with-label">
                                  <label
                                    htmlFor="pl_fm_date"
                                    className="form-dropdown-label"
                                    style={{ width: "85px" }}
                                  >
                                    {t('from').toUpperCase()}
                                  </label>
                                  <input
                                    id="pl_fm_date"
                                    name="pl_fm_date"
                                    type="date"
                                    placeholder={t('from').toUpperCase()}
                                    value={plFmDate}
                                    className="form-input-item"
                                    style={{ width: plTermCode?.value ? "150px" : "250px" }}
                                    onChange={handleFromDateChange}
                                    onBlur={() => handleFromDateBlur(plTermYears)}
                                    disabled={documentEnabled === "N" || getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_start_date") === "N"}
                                  />
                                </div>
                                <span className={`status Active`} style={{ marginLeft: "10px", height: "36px", alignContent: "center", alignItems: "center" }}>{`${daysDifference} DAYS`}</span>
                                <div className="input-item-with-label" style={{ display: "flex", alignSelf: "flex-end", }}>
                                  <label
                                    htmlFor="pl_to_date"
                                    className="form-dropdown-label"
                                    style={{ display: "flex", width: "max-content" }}
                                  >
                                    {t('to').toUpperCase()}
                                  </label>
                                  <input
                                    id="pl_to_date"
                                    name="pl_to_date"
                                    type="date"
                                    placeholder={t('to').toUpperCase()}
                                    value={plToDate}
                                    className="form-input-item"
                                    style={{ width: plTermCode?.value ? "150px" : "250px" }}
                                    onChange={handleToDateChange}
                                    onBlur={handleToDateBlur}
                                    disabled={documentEnabled === "N" || getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_end_date") === "N"}
                                  />
                                </div>
                              </div>
                            </div>}
                          {/* {["Policy", 'RiskNote'].includes(plType) && <hr className="separator-h" />} */}
                          {["Policy", 'RiskNote'].includes(plType) &&
                            <div className={documentEnabled === "Y" ? "content-details-row" : "content-details-row disabled-state"}>
                              <div className="input-item-with-label">
                                <label htmlFor="pl_end_no" className="form-dropdown-label" style={{ width: "100px" }}>
                                  {t('endNo').toUpperCase()}
                                </label>
                                <input
                                  id="pl_end_no"
                                  name="pl_end_no"
                                  type="text"
                                  placeholder={t('endNo').toUpperCase()}
                                  disabled
                                  value={plEndNo}
                                  className="form-input-item"
                                  style={{ width: "250px" }}
                                  onChange={(e) => setPlEndNo(e.target.value)}
                                />
                                {/* <span className='normal-title' style={{ width: "250px" }}>{plEndNo}</span> */}
                              </div>

                              {/* SHOW Conveyance if product is mapped to marine */}
                              {quoteData?.product_behaviour_xx === "Marine" &&
                                <div className="input-item-with-label">
                                  <label htmlFor="pl_conveyance" className="form-dropdown-label" style={{ width: "100px" }}>
                                    {t('conveyance').toUpperCase()}
                                  </label>
                                  <Select
                                    id="pl_conveyance"
                                    name="pl_conveyance"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="250px"
                                    value={plConveyance}
                                    onChange={(selectedOption) => setPlConveyance(selectedOption)}
                                    options={conveyanceList}
                                    isSearchable={true}
                                    isDisabled={documentEnabled === "N"}
                                    placeholder={t('conveyance').toUpperCase()}
                                  />
                                </div>}
                              {["term life", "whole life"].includes(quoteData?.product_type_xx) &&
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                  <div className="input-item-with-label">
                                    <label htmlFor="pl_product_code">{t('mode').toUpperCase()}</label>
                                    <Select
                                      id="pl_payment_mode"
                                      name="pl_payment_mode"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999,
                                        })
                                      }}
                                      width="130px"
                                      value={plPaymentMode}
                                      onChange={(selectedOption) => setPlPaymentMode(selectedOption)}
                                      options={paymentModes}
                                      isSearchable={true}
                                      isDisabled={documentEnabled === "N"}
                                      placeholder={t('mode').toUpperCase()}
                                    />
                                  </div>
                                  <div className="input-item-with-label">
                                    <label htmlFor="pl_pay_day" className="form-dropdown-label" style={{ width: "max-content" }}>
                                      {t('onDay').toUpperCase()}
                                    </label>
                                    <input
                                      id="pl_pay_day"
                                      name="pl_pay_day"
                                      type="number"
                                      placeholder="10"
                                      value={plPayDay}
                                      className="form-input-item"
                                      style={{ width: "60px" }}
                                      min="1"
                                      max="31"
                                      onChange={(e) => {
                                        const value = parseInt(e.target.value, 10);
                                        if (value < 1 || value > 31) {
                                          setNotifyDialogTitle("Note!");
                                          setNotifyDialogText(
                                            `Please ener value <b>between 1 and 31</b>.`
                                          );
                                          setIsNotifyDialogOpen(true);
                                          e.target.value = plPayDay; // Revert to previous valid value
                                        } else {
                                          try {
                                            setPlPayDay(value);
                                            setQuoteData((prevState) => ({
                                              ...prevState,
                                              pl_pay_day: value
                                            }));
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }
                                      }}
                                      disabled={documentEnabled === "N"}
                                    />
                                  </div>
                                </div>}
                            </div>}
                          {/* <hr className="separator-h yellow" /> */}
                          {showProjectInfo === "Y" &&
                            <div className="project-info-wrapper">
                              <hr className="separator-h" />
                              <span className="main-title" style={{ paddingLeft: "8px" }} >{t('projectInformation').toUpperCase()}</span>
                              <div className="project-info-form">
                                <div className="project-form-left">
                                  <div className="input-item-with-label" style={{ display: "flex", width: "100%" }}>
                                    <label htmlFor="project_title"
                                      style={{ width: "110px" }}
                                      className="form-dropdown-label">
                                      {t('title').toUpperCase()}
                                    </label>
                                    <input
                                      id="project_title"
                                      name="project_title"
                                      type="text"
                                      placeholder={t('title').toUpperCase()}
                                      disabled={documentEnabled === "N"}
                                      className="form-input-item"
                                      style={{ width: "100%" }}
                                      value={plProjectInfo?.project_title}
                                      onChange={(e) => updateProjectField('project_title', e.target.value)}
                                    />
                                  </div>
                                  <div className="input-item-with-label" style={{ display: "flex", width: "100%" }}>
                                    <label htmlFor="principal_client"
                                      style={{ width: "110px" }}
                                      className="form-dropdown-label">
                                      {t('client').toUpperCase()}
                                    </label>
                                    <input
                                      id="principal_client"
                                      name="principal_client"
                                      type="text"
                                      placeholder={t('client').toUpperCase()}
                                      disabled={documentEnabled === "N"}
                                      className="form-input-item"
                                      style={{ width: "100%" }}
                                      value={plProjectInfo?.principal_client}
                                      onChange={(e) => updateProjectField('principal_client', e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="project-form-right">
                                  <div className="input-item-with-label" style={{ display: "flex", width: "100%" }}>
                                    <label htmlFor="project_no"
                                      style={{ width: "110px" }}
                                      className="form-dropdown-label">
                                      {t('no').toUpperCase()}
                                    </label>
                                    <input
                                      id="project_no"
                                      name="project_no"
                                      type="text"
                                      placeholder={t('no').toUpperCase()}
                                      disabled={documentEnabled === "N"}
                                      className="form-input-item"
                                      style={{ width: "100%" }}
                                      value={plProjectInfo?.project_no}
                                      onChange={(e) => updateProjectField('project_no', e.target.value)}
                                    />
                                  </div>
                                  <div className="input-item-with-label" style={{ display: "flex", width: "60%" }}>
                                    <label htmlFor="project_status"
                                      style={{ width: "110px" }}
                                      className="form-dropdown-label">
                                      {t('status').toUpperCase()}
                                    </label>
                                    <input
                                      id="project_status"
                                      name="project_status"
                                      type="text"
                                      placeholder={t('status').toUpperCase()}
                                      disabled={true}
                                      className="form-input-item"
                                      style={{ width: "170px" }}
                                      value={plProjectInfo?.project_status}
                                      onChange={(e) => updateProjectField('project_status', e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="project-info-form" style={{ display: "flex", width: "100%", marginTop: "10px" }}>
                                <div className="project-form-left" style={{ flex: "1" }}>
                                  <span className="sub-title" style={{ alignSelf: "center" }}>{t('projectPeriod')}</span>
                                  <div className="input-item-with-label">
                                    <label htmlFor="project_fm"
                                      style={{ width: "85px" }}
                                      className="form-dropdown-label">
                                      {t('from').toUpperCase()}
                                    </label>
                                    <input
                                      id="project_fm"
                                      name="project_fm"
                                      type="date"
                                      placeholder={t('from').toUpperCase()}
                                      disabled={documentEnabled === "N"}
                                      className="form-input-item"
                                      style={{ width: "170px" }}
                                      value={moment(plProjectInfo?.project_fm).format("YYYY-MM-DD")}
                                      onChange={(e) => updateProjectField('project_fm', e.target.value)}
                                    />
                                  </div>
                                  <div className="input-item-with-label">
                                    <label htmlFor="project_to"
                                      style={{ width: "85px" }}
                                      className="form-dropdown-label">
                                      {t('to').toUpperCase()}
                                    </label>
                                    <input
                                      id="project_to"
                                      name="project_to"
                                      type="date"
                                      placeholder={t('to').toUpperCase()}
                                      disabled={documentEnabled === "N"}
                                      className="form-input-item"
                                      style={{ width: "170px" }}
                                      value={moment(plProjectInfo?.project_to).format("YYYY-MM-DD")}
                                      onChange={(e) => updateProjectField('project_to', e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="project-form-left" style={{ flex: "1" }}>
                                  <span className="sub-title" style={{ alignSelf: "center" }}>{t('warrantyPeriod')}</span>
                                  <div className="input-item-with-label">
                                    <label htmlFor="warranty_fm"
                                      style={{ width: "85px" }}
                                      className="form-dropdown-label">
                                      {t('from').toUpperCase()}
                                    </label>
                                    <input
                                      id="warranty_fm"
                                      name="warranty_fm"
                                      type="date"
                                      placeholder={t('from').toUpperCase()}
                                      disabled={documentEnabled === "N"}
                                      className="form-input-item"
                                      style={{ width: "170px" }}
                                      value={moment(plProjectInfo?.warranty_fm).format("YYYY-MM-DD")}
                                      onChange={(e) => updateProjectField('warranty_fm', e.target.value)}
                                    />
                                  </div>
                                  <div className="input-item-with-label">
                                    <label htmlFor="warranty_to"
                                      style={{ width: "85px" }}
                                      className="form-dropdown-label">
                                      {t('to').toUpperCase()}
                                    </label>
                                    <input
                                      id="warranty_to"
                                      name="warranty_to"
                                      type="date"
                                      placeholder={t('to').toUpperCase()}
                                      disabled={documentEnabled === "N"}
                                      className="form-input-item"
                                      style={{ width: "170px" }}
                                      value={moment(plProjectInfo?.warranty_to).format("YYYY-MM-DD")}
                                      onChange={(e) => updateProjectField('warranty_to', e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="project-form-left" style={{ flex: "1", alignItems: "flex-end" }}>
                                  <span className="sub-title" style={{ alignSelf: "center" }}>{t('maintenancePeriod')}</span>
                                  <div className="input-item-with-label">
                                    <label htmlFor="maintenance_fm"
                                      style={{ width: "85px" }}
                                      className="form-dropdown-label">
                                      {t('from').toUpperCase()}
                                    </label>
                                    <input
                                      id="maintenance_fm"
                                      name="maintenance_fm"
                                      type="date"
                                      placeholder={t('from').toUpperCase()}
                                      disabled={documentEnabled === "N"}
                                      className="form-input-item"
                                      style={{ width: "170px" }}
                                      value={moment(plProjectInfo?.maintenance_fm).format("YYYY-MM-DD")}
                                      onChange={(e) => updateProjectField('maintenance_fm', e.target.value)}
                                    />
                                  </div>
                                  <div className="input-item-with-label">
                                    <label htmlFor="maintenance_to"
                                      style={{ width: "85px" }}
                                      className="form-dropdown-label">
                                      {t('to').toUpperCase()}
                                    </label>
                                    <input
                                      id="maintenance_to"
                                      name="maintenance_to"
                                      type="date"
                                      placeholder={t('to').toUpperCase()}
                                      disabled={documentEnabled === "N"}
                                      className="form-input-item"
                                      style={{ width: "170px" }}
                                      value={moment(plProjectInfo?.maintenance_to).format("YYYY-MM-DD")}
                                      onChange={(e) => updateProjectField('maintenance_to', e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          }

                          {["term life", "whole life"].includes(quoteData?.product_type_xx) &&
                            ["Policy", 'RiskNote'].includes(plType) && <hr className="separator-h" />}
                          {/* this field is applicable in life insurance */}
                          {["term life", "whole life"].includes(quoteData?.product_type_xx) &&
                            ["Policy", 'RiskNote'].includes(plType) &&
                            <h1 className="main-title" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "20px", height: "32px" }}>
                              {t('accountDetails').toUpperCase()}
                            </h1>
                          }
                          {["term life", "whole life"].includes(quoteData?.product_type_xx) &&
                            ["Policy", 'RiskNote'].includes(plType) &&
                            <div className="content-details-row">
                              <div className="input-item-with-label" >
                                <label htmlFor="pl_bank" className="form-dropdown-label" style={{ width: "100px" }}>{t('bank').toUpperCase()}</label>
                                <Select
                                  id="pl_bank"
                                  name="pl_bank"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="250px"
                                  value={plBank}
                                  onChange={async (selectedOption) => {
                                    try {
                                      setPlBank(selectedOption);
                                      // Find branches for the selected bank
                                      const branchOptions = selectedOption?.branches?.map((branch) => ({
                                        value: branch.branch_code,
                                        label: branch.branch_name,
                                      })) || [];
                                      // Set the branches for the selected bank
                                      setPlBankBranch(null); // Clear previously selected branch
                                      setBankBranches(branchOptions); // Update the branch options
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  options={banks}
                                  isSearchable={true}
                                  isDisabled={documentEnabled === "N"}
                                  placeholder={t('bank').toUpperCase()}
                                />
                              </div>
                              <div className="input-item-with-label">
                                <label htmlFor="pl_bank_ac_name" className="form-dropdown-label">
                                  {t('name').toUpperCase()}
                                </label>
                                <input
                                  id="pl_bank_ac_name"
                                  name="pl_bank_ac_name"
                                  type="text"
                                  placeholder={t('name').toUpperCase()}
                                  disabled={documentEnabled === "N"}
                                  value={plBankAcName}
                                  className="form-input-item"
                                  style={{ width: "250px" }}
                                  onChange={(e) => setPlBankAcName(e.target.value)}
                                />
                              </div>
                            </div>}
                          {["term life", "whole life"].includes(quoteData?.product_type_xx) &&
                            ["Policy", 'RiskNote'].includes(plType) &&
                            <div className="content-details-row">
                              <div className="input-item-with-label" >
                                <label htmlFor="pl_bank_branch" className="form-dropdown-label" style={{ width: "100px" }}>{t('branch').toUpperCase()}</label>
                                <Select
                                  id="pl_bank_branch"
                                  name="pl_bank_branch"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="250px"
                                  value={plBankBranch}
                                  onChange={async (selectedOption) => setPlBankBranch(selectedOption)}
                                  options={bankBranches}
                                  isSearchable={true}
                                  isDisabled={documentEnabled === "N"}
                                  placeholder={t('branch').toUpperCase()}
                                />
                              </div>
                              <div className="input-item-with-label">
                                <label htmlFor="pl_bank_ac_no" className="form-dropdown-label">
                                  {t('no').toUpperCase()}
                                </label>
                                <input
                                  id="pl_bank_ac_no"
                                  name="pl_bank_ac_no"
                                  type="text"
                                  placeholder={t('no').toUpperCase()}
                                  disabled={documentEnabled === "N"}
                                  value={plBankAcNo}
                                  className="form-input-item"
                                  style={{ width: "250px" }}
                                  onChange={(e) => setPlBankAcNo(e.target.value)}
                                />
                              </div>
                            </div>}
                        </ExpandableComponent>
                        {/* product details ends here */}
                        {/* Insured details start here */}
                        {["Policy", "Quote", 'RiskNote', 'QuoteRequest', "Opportunity"].includes(plType) &&
                          <ExpandableComponent
                            title={["Opportunity", "Quote", "QuoteRequest"].includes(plType) ? t('client').toUpperCase() : t('policyOwner').toUpperCase()}
                            subtitle={(documentEnabled === "Y" || quoteData?.pl_interest_yn === "Y") &&
                              <ToggleSwitch
                                id="pl_interest_yn"
                                name="pl_interest_yn"
                                value={quoteData?.pl_interest_yn}
                                onChange={(newValue) => handleDocumentChange("pl_interest_yn", newValue)}
                                label={t('financialInterestAppl').toUpperCase()}
                                labelPosition="end"
                                labelWidth="max-content"
                                border="N"
                                disabled={documentEnabled === "N"}
                              />}
                            defaultExpanded={selectedInsured || quoteId === "new"}
                          >
                            <div className="content-details-row insured" >
                              <motion.div
                                className="entity-details-container"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1, transition: { duration: 1 } }}
                                exit={{ opacity: 0, transition: { duration: 1 } }}>
                                <div className="entity-details-wrapper">
                                  <div className="entity-details-left">
                                    {selectedInsured?.ent_photo_url ? (
                                      <img
                                        src={selectedInsured.ent_photo_url}
                                        alt=""
                                        className="img"
                                      />
                                    ) : (
                                      <InitialsAvatar
                                        name={selectedInsured?.ent_name}
                                        size={60}
                                        currentTheme={currentTheme}
                                      />
                                    )}
                                  </div>

                                  <div className="entity-details-right">
                                    <div className="name-row">
                                      {documentEnabled === "Y" &&
                                        getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_owner") === "Y" ?
                                        <div className="input-item-with-label">
                                          {/* <label htmlFor="pl_assr_ent_code">INSURED</label> */}
                                          <AsyncSelect
                                            ref={insuredRef}
                                            id="pl_assr_ent_code"
                                            name="pl_assr_ent_code"
                                            menuPortalTarget={document.body}
                                            styles={{
                                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                              menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                              })
                                            }}
                                            width="400px"
                                            isClearable
                                            value={selectedInsured}
                                            onChange={(selectedOption) => {
                                              try {
                                                setSelectedInsured(selectedOption);
                                                setPlBankAcName(selectedOption?.label?.props?.children[0]);
                                              } catch (error) {
                                                console.log(error);
                                              }
                                            }}
                                            loadOptions={fetchEntityBySearch}
                                            isSearchable={true}
                                            placeholder={["Opportunity", "Quote", "QuoteRequest"].includes(plType) ? t('client') : t('policyOwner')}
                                            noOptionsMessage={() =>
                                              customNoOptionsMessage(
                                                "Type Minimum 3 Letter to Search",
                                                "create",
                                                getLimitValue("UW1005")
                                              )
                                            }
                                          />
                                        </div>
                                        : <h1 className="main-title"> {selectedInsured?.ent_name}</h1>
                                      }
                                      <h1 className="sub-title"> {selectedInsured?.ent_status}  </h1>
                                    </div>
                                    <div className="email-phone-row" style={{ display: "flex", alignCenter: "center", flexDirection: "row", width: "100%" }}>
                                      <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1.8" }}
                                        onClick={() => {
                                          try {
                                            setEmailData({
                                              to: selectedInsured?.ent_email,
                                              cc: '',
                                              bcc: '',
                                              subject: `${t('riskNoteNo').toUpperCase} ${plRiskNoteNo}`,
                                              show_attach: "Y",
                                              attached_urls: [],
                                              binary_docs: [],
                                              doc_no: plRiskNoteNo,
                                              doc_type: plType,
                                              doc_id: quoteId,
                                              entity_codes: [selectedInsured?.value, selectedCarrier?.value],
                                              search_string: selectedInsured?.label?.props?.children[0] + "," + selectedCarrier?.label?.props?.children[0] + "," + plNo,
                                              carrierName: selectedCarrier?.label?.props?.children[0],
                                              productName: selectedProduct?.label?.props?.children[0],
                                              clientName: selectedInsured?.label?.props?.children[0],
                                              riskNoteNo: plRiskNoteNo,
                                              daysToRenewal: quoteData?.expiring_in_days,
                                              expiryDate: quoteData?.fmt_to_date,
                                              insuredName: selectedInsured?.label?.props?.children[0],
                                              outstandingPremium: quoteData?.outstandingPremium,
                                              policyCurrency: plCurCode?.value,
                                              policyNumber: plNo,
                                              policyPremium: quoteData?.fmt_policy_fc_prem,
                                              policyPremiumTotal: quoteData?.fmt_total_fc_prem,
                                              policySumInsured: quoteData?.fmt_total_fc_si,
                                              policyFromDate: quoteData?.fmt_fm_date,
                                              policyToDate: quoteData?.fmt_to_date,

                                              requestedAction: `${t('issueParam', { param1: quoteData?.end_name_xx })}`,
                                              jurisdiction: quoteData?.pl_jurisdiction,
                                              financialInterestDetails: selectedFinancier?.ent_name || "None",
                                              handlerName: currentUser?.usr_full_name,
                                              handlerTitle: currentUser?.usr_title,
                                              handlerPhone: currentUser?.usr_phone_no,
                                              handlerEmail: currentUser?.usr_email,
                                              todaysDate: moment().format("Do MMM YYYY HH:mm"),

                                              tpt_category: []
                                            });
                                            setEmailDialogOpen(true);
                                          } catch (error) {
                                            console.log(error)
                                          }
                                        }}>
                                        <MdAlternateEmail className="icon" /> <span className="sub-title">{selectedInsured?.ent_email || t('unspecified')}</span>
                                      </span>
                                      <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                        <LocalPhoneIcon className="icon" /> <span className="sub-title">{selectedInsured?.ent_phone_no || t('unspecified')}</span>
                                      </span>
                                      <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                        <TbCertificate className="icon" /> <span className="sub-title">{selectedInsured?.aent_name_xx || t('unspecified')}</span>
                                      </span>
                                      <span className="email-phone-details"
                                        style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1" }}
                                        onClick={() => navigate(`/entity/${selectedInsured?.ent_docid}`)}>
                                        <MdOutlineNumbers className="icon" /> <span className="sub-title">{selectedInsured?.ent_code}</span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </motion.div>
                            </div>
                          </ExpandableComponent>}

                        {/* intermediary details starts here */}
                        {!["Opportunity", "QuoteRequest"].includes(plType) &&
                          <ExpandableComponent
                            title={`${["agent", "broker"].includes(currentUser?.token_org_type) ? `${t('carrier').toUpperCase()}` : `${t('intermediary').toUpperCase()}`}`}
                            subtitle={<span className="sub-title">{quoteData?.carrier_details_xx?.ent_occupation_xx} </span>}
                            defaultExpanded={selectedCarrier || quoteId === "new"}
                          >
                            <div className="content-details-row carrier">
                              <motion.div
                                className="entity-details-container"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1, transition: { duration: 1 } }}
                                exit={{ opacity: 0, transition: { duration: 1 } }}>
                                <div className="entity-details-wrapper">
                                  <div className="entity-details-left">
                                    {selectedCarrier?.ent_photo_url ?
                                      <img
                                        src={selectedCarrier?.ent_photo_url}
                                        alt=""
                                        className="img" />
                                      :
                                      <InitialsAvatar
                                        name={selectedCarrier?.ent_name}
                                        size={60}
                                        currentTheme={currentTheme}
                                      />}
                                  </div>
                                  <div className="entity-details-right">
                                    <div className="name-row">
                                      {documentEnabled === "Y" &&
                                        getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_carrier") === "Y" ?
                                        <div className="input-item-with-label" style={{ marginRight: "10px" }}>
                                          {/* <label htmlFor="pl_assr_ent_code">INSURED</label> */}
                                          <AsyncSelect
                                            id="pl_ins_ent_code"
                                            name="pl_ins_ent_code"
                                            menuPortalTarget={document.body}
                                            styles={{
                                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                              menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                              })
                                            }}
                                            isClearable
                                            width="400px"
                                            value={selectedCarrier}
                                            onChange={(selectedOption) => setSelectedCarrier(selectedOption)}
                                            loadOptions={fetchEntityBySearch}
                                            isSearchable={true}
                                            placeholder={`${["agent", "broker"].includes(currentUser?.token_org_type) ? `${t('carrier')}` : `${t('intermediary')}`}`}
                                            noOptionsMessage={() =>
                                              customNoOptionsMessage(
                                                "Type Minimum 3 Letter to Search",
                                                "create",
                                                getLimitValue("UW1005")
                                              )
                                            }
                                          />
                                        </div>
                                        : <span className="main-title">{selectedCarrier?.ent_name} </span>}
                                      <span className="sub-title">{selectedCarrier?.ent_status} </span>
                                    </div>
                                    <div className="email-phone-row" style={{ display: "flex", alignCenter: "center", flexDirection: "row", width: "100%" }}>
                                      <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1.8" }}
                                        onClick={() => {
                                          try {
                                            setEmailData({
                                              to: selectedCarrier?.ent_email,
                                              cc: '',
                                              bcc: '',
                                              subject: `${t('riskNoteNo').toUpperCase} ${plRiskNoteNo}`,
                                              show_attach: "Y",
                                              attached_urls: [],
                                              binary_docs: [],
                                              doc_no: plRiskNoteNo,
                                              doc_type: plType,
                                              doc_id: quoteId,
                                              entity_codes: [selectedInsured?.value, selectedCarrier?.value],
                                              search_string: selectedInsured?.label?.props?.children[0] + "," + selectedCarrier?.label?.props?.children[0] + "," + plNo,
                                              carrierName: selectedCarrier?.label?.props?.children[0],
                                              productName: selectedProduct?.label?.props?.children[0],
                                              clientName: selectedInsured?.label?.props?.children[0],
                                              riskNoteNo: plRiskNoteNo,
                                              daysToRenewal: quoteData?.expiring_in_days,
                                              expiryDate: quoteData?.fmt_to_date,
                                              insuredName: selectedInsured?.label?.props?.children[0],
                                              outstandingPremium: quoteData?.outstandingPremium,
                                              policyCurrency: plCurCode?.value,
                                              policyNumber: plNo,
                                              policyPremium: quoteData?.fmt_policy_fc_prem,
                                              policyPremiumTotal: quoteData?.fmt_total_fc_prem,
                                              policySumInsured: quoteData?.fmt_total_fc_si,
                                              policyFromDate: quoteData?.fmt_fm_date,
                                              policyToDate: quoteData?.fmt_to_date,

                                              requestedAction: `${t('issueParam', { param1: quoteData?.end_name_xx })}`,
                                              jurisdiction: "Kenya Only",
                                              financialInterestDetails: selectedFinancier?.ent_name || "None",
                                              handlerName: currentUser?.usr_full_name,
                                              handlerTitle: currentUser?.usr_title,
                                              handlerPhone: currentUser?.usr_phone_no,
                                              handlerEmail: currentUser?.usr_email,
                                              todaysDate: moment().format("Do MMM YYYY HH:mm"),

                                              tpt_category: []
                                            });
                                            setEmailDialogOpen(true);
                                          } catch (error) {
                                            console.log(error)
                                          }
                                        }}>
                                        <MdAlternateEmail className="icon" /> <span className="sub-title">{selectedCarrier?.ent_email || t('unspecified')}</span>
                                      </span>
                                      <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                        <MdPhone className="icon" /> <span className="sub-title">{selectedCarrier?.ent_phone_no || t('unspecified')}</span>
                                      </span>
                                      <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                        <TbCertificate className="icon" /> <span className="sub-title">{selectedCarrier?.aent_name_xx || t('unspecified')}</span>
                                      </span>
                                      <span className="email-phone-details"
                                        style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1" }}
                                        onClick={() => navigate(`/entity/${quoteData?.carrier_details_xx?._id}`)}>
                                        <MdOutlineNumbers className="icon" /> <span className="sub-title">{selectedCarrier?.ent_code || ""}</span>
                                      </span>
                                    </div>
                                    {/* <div className="email-phone-row" style={{ flexDirection: "row", gap: "5px", justifyContent: "flex-end" }}>
                                           GMO
                                         </div> */}
                                  </div>
                                </div>
                              </motion.div>
                            </div>
                          </ExpandableComponent>}
                        {quoteData?.pl_interest_yn === "Y" &&
                          <ExpandableComponent
                            title={t('financialInterest').toUpperCase()}
                            subtitle={<span className="sub-title">{quoteData?.financier_details_xx?.ent_occupation_xx} </span>}
                            defaultExpanded={selectedFinancier || quoteId === "new"}
                          >
                            <div className="content-details-row carrier">
                              <motion.div
                                className="entity-details-container"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1, transition: { duration: 1 } }}
                                exit={{ opacity: 0, transition: { duration: 1 } }}>
                                <div className="entity-details-wrapper">
                                  <div className="entity-details-left">
                                    {selectedFinancier?.ent_photo_url ?
                                      <img src={selectedFinancier?.ent_photo_url} alt="" className="img" />
                                      :
                                      <InitialsAvatar
                                        name={selectedFinancier?.ent_name}
                                        size={60}
                                        currentTheme={currentTheme}
                                      />}
                                  </div>
                                  <div className="entity-details-right">
                                    <div className="name-row">
                                      {documentEnabled === "Y" &&
                                        getKeyInArray(quoteData?.endorsement_behavior_xx, "allow_amend_financier") === "Y" ?
                                        <div className="input-item-with-label" style={{ marginRight: "10px" }}>
                                          {/* <label htmlFor="pl_assr_ent_code">INSURED</label> */}
                                          <AsyncSelect
                                            id="pl_interest_ent_code"
                                            name="pl_interest_ent_code"
                                            menuPortalTarget={document.body}
                                            styles={{
                                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                              menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                              })
                                            }}
                                            isClearable
                                            width="400px"
                                            value={selectedFinancier}
                                            onChange={(selectedOption) => setSelectedFinancier(selectedOption)}
                                            loadOptions={fetchEntityBySearch}
                                            isSearchable={true}
                                            placeholder={t('financialInterest')}
                                            noOptionsMessage={() =>
                                              customNoOptionsMessage(
                                                "Type Minimum 3 Letter to Search",
                                                "create",
                                                getLimitValue("UW1005")
                                              )
                                            }
                                          />
                                        </div>
                                        : <span className="sub-title"> {selectedFinancier?.ent_name} </span>}
                                      <span className="sub-title"> {selectedFinancier?.ent_status} </span>
                                    </div>
                                    <div className="email-phone-row" style={{ display: "flex", alignCenter: "center", flexDirection: "row", width: "100%" }}>
                                      <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1.8" }}
                                        onClick={() => {
                                          try {
                                            setEmailData({
                                              to: selectedFinancier?.ent_email,
                                              cc: '',
                                              bcc: '',
                                              subject: `${t('noteNo').toUpperCase()} ${plRiskNoteNo}`,
                                              show_attach: "Y",
                                              attached_urls: [],
                                              binary_docs: [],
                                              doc_no: plRiskNoteNo,
                                              doc_type: plType,
                                              doc_id: quoteId,
                                              entity_codes: [selectedInsured?.value, selectedFinancier?.value],
                                              search_string: selectedInsured?.label?.props?.children[0] + "," + selectedFinancier?.label?.props?.children[0] + "," + plNo,
                                              carrierName: selectedFinancier?.label?.props?.children[0],
                                              productName: selectedProduct?.label?.props?.children[0],
                                              clientName: selectedInsured?.label?.props?.children[0],
                                              riskNoteNo: plRiskNoteNo,
                                              daysToRenewal: quoteData?.expiring_in_days,
                                              expiryDate: quoteData?.fmt_to_date,
                                              insuredName: selectedInsured?.label?.props?.children[0],
                                              outstandingPremium: quoteData?.outstandingPremium,
                                              policyCurrency: plCurCode?.value,
                                              policyNumber: plNo,
                                              policyPremium: quoteData?.fmt_policy_fc_prem,
                                              policyPremiumTotal: quoteData?.fmt_total_fc_prem,
                                              policySumInsured: quoteData?.fmt_total_fc_si,
                                              policyFromDate: quoteData?.fmt_fm_date,
                                              policyToDate: quoteData?.fmt_to_date,

                                              requestedAction: `${t('issueParam', { param1: quoteData?.end_name_xx })}`,
                                              jurisdiction: "Kenya Only",
                                              financialInterestDetails: selectedFinancier?.ent_name || "None",
                                              handlerName: currentUser?.usr_full_name,
                                              handlerTitle: currentUser?.usr_title,
                                              handlerPhone: currentUser?.usr_phone_no,
                                              handlerEmail: currentUser?.usr_email,
                                              todaysDate: moment().format("Do MMM YYYY HH:mm"),

                                              tpt_category: []
                                            });
                                            setEmailDialogOpen(true);
                                          } catch (error) {
                                            console.log(error)
                                          }
                                        }}>
                                        <EmailIcon className="icon" /> <span className="sub-title">{selectedFinancier?.ent_email || t('unspecified')}</span>
                                      </span>
                                      <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                        <LocalPhoneIcon className="icon" /> <span className="sub-title">{selectedFinancier?.ent_phone_no || t('unspecified')}</span>
                                      </span>
                                      <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                        <TbCertificate className="icon" /> <span className="sub-title">{selectedFinancier?.aent_name_xx || t('unspecified')}</span>
                                      </span>
                                      <span className="email-phone-details"
                                        style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1" }}
                                        onClick={() => navigate(`/entity/${quoteData?.financier_details_xx?._id}`)}>
                                        <MdOutlineNumbers className="icon" /> <span className="sub-title">{selectedFinancier?.ent_code || ""}</span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </motion.div>
                            </div>
                          </ExpandableComponent>}

                        {["QuoteRequest"].includes(plType) &&
                          <ExpandableComponent
                            title={`${plParticipants?.length} ${plParticipants?.length === 1 ? t('participant').toUpperCase() : t('participants').toUpperCase()}`}
                            subtitle={
                              documentEnabled === "Y" &&
                              <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                                <AsyncSelect
                                  ref={participantRef}
                                  id="participant"
                                  name="participant"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  isClearable
                                  width="375px"
                                  value={selectedParticipant}
                                  onChange={(selectedOption) => setSelectedParticipant(selectedOption)}
                                  loadOptions={fetchEntityBySearch}
                                  isSearchable={true}
                                  placeholder={t('participant')}
                                  noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                />
                                <CircularButton
                                  currentTheme={currentTheme}
                                  onClick={async (e) => {
                                    try {

                                      if (!selectedParticipant) {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select participant`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }

                                      const res = await newRequest.post(
                                        "/uwPolicy/addParticipant",
                                        {
                                          policy_docid: quoteData?._id,
                                          participant_ent_code: selectedParticipant?.ent_code,
                                          participant_ent_docid: selectedParticipant?.ent_docid,
                                          participant_status: "Pending",
                                        }
                                      );

                                      if (res.data?.msg === "added") {
                                        setPlParticipants((prevParams) => [...prevParams, res.data?.doc]);
                                        setSelectedParticipant(null);
                                        if (participantRef.current) {
                                          participantRef.current?.focus();
                                        }
                                        showToast(t('added'), "success");
                                      } else if (res.data?.msg === "exists") {
                                        showToast(`${selectedParticipant?.label?.props?.children[0]} is already a participant`, "warning");
                                        setSelectedParticipant(null);
                                        if (participantRef.current) {
                                          participantRef.current?.focus();
                                        }
                                      } else {
                                        showToast(t('error'), "error");
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                              </span>}
                            defaultExpanded={plParticipants?.length > 0}
                          >
                            <div className="team-content">
                              {plParticipants?.length > 0 &&
                                <div className="team-wrapper">
                                  {plParticipants?.map((row, index) => (
                                    <div key={row._id} className='single-member'>
                                      <div className="single-member-left">
                                        {row?.ent_photo_url ?
                                          <img src={row?.ent_photo_url} alt="" className="img" />
                                          : <InitialsAvatar
                                            name={row?.ent_name}
                                            size={60}
                                            currentTheme={currentTheme}
                                          />}
                                      </div>
                                      <div className="single-member-right">
                                        <div className="single-member-header">
                                          <span className='member-name'>{row?.ent_name}</span>
                                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "3px" }}>
                                              <span className="relationship-type">{row?.participant_status}</span>
                                              <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.sent_on_xx}</span>
                                            </div>
                                            {documentEnabled === "Y" &&
                                              <CircularButton
                                                currentTheme={currentTheme}
                                                color="#F44336"
                                                onClick={async () => {
                                                  try {
                                                    setIsProcessing(true);
                                                    const res = await newRequest.post("/uwPolicy/deleteParticipant", {
                                                      policy_docid: quoteData?._id,
                                                      participant_docid: row?._id,
                                                      participant_name: row?.ent_name
                                                    });
                                                    setIsProcessing(false);
                                                    if (res.data?.msg === "removed") {
                                                      setPlParticipants((prev) => prev.filter(mm => mm?._id !== row?._id));
                                                      showToast(t('removed'), "success");
                                                    } else {
                                                      showToast("Error removing!", "error");
                                                    }
                                                  } catch (error) {
                                                    console.log(error);
                                                  }
                                                }} icon={<MdDelete />} width={"30px"} height={"30px"} />}
                                          </div>
                                        </div>
                                        <div className="member-phone-row">
                                          <span className="member-phone-details" style={{ flex: "1.5" }}> <MdAlternateEmail className="icon" />{row?.ent_email}</span>
                                          <span className="member-phone-details" style={{ flex: "1" }}> <MdPhone className="icon" />{row?.ent_phone_no}</span>
                                          <span className="member-phone-details" style={{ flex: "0.7" }}><LuClipboardType className="icon" /> {row?.ent_type}</span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>}
                            </div>
                          </ExpandableComponent>}
                        {["Policy", 'RiskNote'].includes(plType) &&
                          <ExpandableComponent
                            title={t('commissions').toUpperCase()}
                            subtitle={`${t('total').toUpperCase()} ${plCurCode?.value} ${numeral(quoteData?.commission_total_fc).format("0,0.00")}`}
                            onSubtitleClick={() => { }}
                            defaultExpanded={false}
                          >
                            <UwPolicyCommissions
                              key={policyRiskKey}
                              ref={policyChargesRef}
                              policyDocid={quoteData._id}
                              plCurCode={plCurCode?.value}
                              productCode={selectedProduct?.value}
                              endorsementCode={plEndCode}
                              documentEnabled={documentEnabled}
                              profileLimitValues={profileLimitValues} />
                          </ExpandableComponent>}
                        {["Policy", 'RiskNote'].includes(plType) &&
                          <ExpandableComponent
                            title={t('charges').toUpperCase()}
                            subtitle={`${t('total').toUpperCase()} ${plCurCode?.value} ${numeral(quoteData?.total_charges_fc_amount).format("0,0.00")}`}
                            onSubtitleClick={() => { }}
                            defaultExpanded={false}
                          >
                            <UwPolicyCharges
                              key={policyRiskKey}
                              ref={policyChargesRef}
                              policyDocid={quoteData._id}
                              plCurCode={plCurCode?.value}
                              riskNoteNo={plRiskNoteNo}
                              endIndex={plEndIndex}
                              chargeLevel="Policy"
                              productCode={selectedProduct?.value}
                              endorsementCode={plEndCode}
                              documentEnabled={documentEnabled}
                              profileLimitValues={profileLimitValues} />
                          </ExpandableComponent>}
                        {/* premium installments for term life and whole life products */}
                        {["Policy", "Quote", 'RiskNote'].includes(plType) &&
                          <ExpandableComponent
                            // key={quoteData?.policy_fc_premium}
                            key={policyRiskKey}
                            title={t('premiumInstallments').toUpperCase()}
                            subtitle={
                              <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                                {documentEnabled === "Y" &&
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={async () => {
                                      try {
                                        setIsProcessing(true);
                                        await newRequest.get(`/uwPolicyInstallment/genPolicyInstallments/${quoteData?._id}`);
                                        setIsProcessing(false);
                                        setPolicyRiskKey(prevKey => prevKey + 1);
                                        showToast(t('refreshed'), "success");
                                      } catch (error) {
                                        console.log(error)
                                      }
                                    }} icon={<GrSync />} width={"30px"} height={"30px"} />}
                                <h2 className="sub-title">{`${t('expectedPremium').toUpperCase()} ${plCurCode?.value} ${numeral(quoteData?.installment_expected_fc_xx).format("0,0.00")}`}</h2>
                                {quoteData?.pl_status === "Validated" &&
                                  quoteData?.pl_inst_confirmed !== "Y" &&
                                  <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    height={"36px"}
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#7CB342"
                                    tooltip={"Confirm premium payment installments"}
                                    endIcon={<DoneAllIcon />}
                                    onClick={async () => {
                                      try {
                                        setObjectToAction({
                                          object_id: quoteData._id,
                                          action_text: `Do you want to <b>CONFIRM PREMIUM INSTALLMENTS</b> this document?`,
                                          new_doc_status: "New",
                                        });
                                        setConfirmDialogAction("confirmInstallments");
                                        setIsConfirmDialogOpen(true);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                  >
                                    {t('confirm').toUpperCase()}
                                  </CustomLoadingButton>}
                              </div>
                            }
                            onSubtitleClick={() => { }}
                            defaultExpanded={false}
                          >
                            <UwPolicyInstallments policyDocid={quoteData._id} policyFcPremium={quoteData?.total_fc_premium} plCurCode={plCurCode?.value} installmentConfirmed={plInstConfirmed} />
                          </ExpandableComponent>}
                        {/* end of premium installments */}
                        {/* intermediary details ends here */}
                        {["Policy", 'RiskNote'].includes(plType) &&
                          <ExpandableComponent
                            title={t('additionalInformation').toUpperCase()}
                            subtitle={""}
                            onSubtitleClick={() => { }}
                            defaultExpanded={quoteId === "new" || plRemarks ? true : false}
                          >
                            {documentEnabled === "Y" &&
                              <div className="input-item-with-label" style={{ display: "flex", width: "100%", flexDirection: "column", gap: "10px" }}>
                                <label htmlFor="pl_remarks" style={{ width: "max-content", alignSelf: "flex-start" }}>
                                  {t('underwriterRemarks').toUpperCase()}
                                </label>
                                <textarea
                                  id="pl_remarks"
                                  name="pl_remarks"
                                  type="text"
                                  placeholder={t('remarks').toUpperCase()}
                                  value={plRemarks}
                                  className="form-input-item"
                                  style={{ width: "100%" }}
                                  rows={3}
                                  onChange={(e) => setPlRemarks(e.target.value)}
                                  disabled={documentEnabled === "N"}
                                />
                              </div>}
                            {documentEnabled === "N" && plRemarks &&
                              <div className="content-details-row">
                                <span className="sub-title">{`${t('underwriterRemarks').toUpperCase()}: ${plRemarks}`}</span>
                              </div>}
                            <div className="content-details-row">
                              <div className="content-details-left">
                                <div style={{
                                  display: "flex",
                                  width: "100%",
                                  flexDirection: "row",
                                  alignItems: "flex-start",
                                  justifyContent: "space-between"
                                }}>
                                </div>
                              </div>
                            </div>
                            {/* basis of claim settlement */}
                            <hr className="separator-h" />
                            <div className="content-details-row">
                              <span className="sub-title">{`${t('basisOfClaimSettlement').toUpperCase()} ${plClaimBasis?.length === 0 ? t('notSpecified').toUpperCase() : ""}`}</span>
                            </div>
                            {documentEnabled === "Y" && (
                              <div className="content-details-row" style={{
                                justifyContent: "flex-start",
                                gap: "5px",
                                paddingLeft: "0px"
                              }}>
                                <div
                                  className="input-item-with-label"
                                  style={{ width: "100%" }}
                                >
                                  <input
                                    type="text"
                                    value={basisOfClaim}
                                    className="form-input-item"
                                    placeholder={t('enterBasisText')}
                                    style={{ width: "100%" }}
                                    onChange={(e) => setBasisOfClaim(e.target.value)}
                                  />
                                </div>
                                {quoteId !== "new" &&
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={handleAddClaimBasis}
                                    icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                }
                              </div>
                            )}
                            <div className="content-details-row" style={{ marginTop: "0px" }}>
                              <div className="basis-of-claim">
                                {/* basis of claim text */}
                                {plClaimBasis?.length > 0 && (
                                  <div>
                                    {plClaimBasis?.map((claim, index) => (
                                      <div key={claim._id}>
                                        <div className="single-basis-row">
                                          <span
                                            style={{
                                              alignContent: "flex-start",
                                            }}
                                          >
                                            {index + 1}.
                                          </span>
                                          <span
                                            style={{
                                              fontWeight: "500",
                                              fontSize: "16px",
                                            }}
                                          >{`${claim.basis_text}`}</span>
                                          {documentEnabled === "Y" && (
                                            <Tooltip
                                              title={`${t('remove')} ${claim?.basis_text}`}
                                              placement="right"
                                            >
                                              <MdClose
                                                size={24}
                                                style={{
                                                  borderRadius: "5px",
                                                  padding: "3px",
                                                  cursor: "pointer",
                                                  color: "rgba(172, 33, 9)",
                                                  backgroundColor: "rgba(172, 33, 9, 0.5)",
                                                }}
                                                onClick={() => {
                                                  try {
                                                    // console.log(`claim is ${claim}`);
                                                    const action_text = `Do remove ${claim.basis_text} from this document?`;
                                                    setObjectToAction({
                                                      object_id: claim._id,
                                                      action_text: action_text,
                                                    });

                                                    setConfirmDialogAction("removeClaimBasis");
                                                    setIsConfirmDialogOpen(true);
                                                  } catch (error) {
                                                    console.log(error);
                                                  }
                                                }}
                                              />
                                            </Tooltip>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                            {/* end of basis of claim settlement */}
                            <hr className='separator-h' />
                            <div className="content-details-row">
                              <h1 className="main-title">{t('specialNotes')}</h1>
                            </div>
                            {documentEnabled === "Y" && (
                              <div className="content-details-row" style={{
                                display: "flex",
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                gap: "5px",
                                paddingLeft: "0px"
                              }}>
                                <div
                                  className="input-item-with-label"
                                  style={{ width: "100%" }}
                                >
                                  <input
                                    ref={specialNoteRef}
                                    type="text"
                                    value={specialNote}
                                    className="form-input-item"
                                    placeholder={t('note')}
                                    style={{ width: "100%" }}
                                    onChange={(e) => setSpecialNote(e.target.value)}
                                    disabled={quoteId === "new"}
                                  />
                                </div>
                                {quoteId !== "new" &&
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={handleAddSpecialNote}
                                    icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                }
                              </div>
                            )}
                            <div className="content-details-row" style={{ marginTop: "0px" }}>
                              <div className="basis-of-claim">
                                {specialNotes?.length > 0 && (
                                  <div>
                                    {specialNotes?.map((row, index) => (
                                      <div key={row._id}>
                                        <div className="single-basis-row">
                                          <span
                                            style={{
                                              alignContent: "flex-start",
                                            }}
                                          >
                                            {index + 1}.
                                          </span>
                                          <span
                                            style={{
                                              fontWeight: "500",
                                              fontSize: "16px",
                                            }}
                                          >{`${row.note_text}`}</span>
                                          {documentEnabled === "Y" && (
                                            <Tooltip
                                              title={`Remove ${row.note_text}`}
                                              placement="right"
                                            >
                                              <MdClose
                                                size={24}
                                                style={{
                                                  borderRadius: "5px",
                                                  padding: "3px",
                                                  cursor: "pointer",
                                                  color: "rgba(172, 33, 9)",
                                                  backgroundColor: "rgba(172, 33, 9, 0.5)",
                                                }}
                                                onClick={() => {
                                                  try {
                                                    // console.log(`claim is ${claim}`);
                                                    const action_text = `Do remove ${row.note_text} from this document?`;
                                                    setObjectToAction({
                                                      object_id: row._id,
                                                      action_text: action_text,
                                                    });
                                                    setConfirmDialogAction("removeSpecialNote");
                                                    setIsConfirmDialogOpen(true);
                                                  } catch (error) {
                                                    console.log(error);
                                                  }
                                                }}
                                              />
                                            </Tooltip>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </ExpandableComponent>}
                        <ExpandableComponent
                          title={`${plOpActivities?.length} ${plOpActivities?.length === 1 ? t('activity').toUpperCase() : t('activities').toUpperCase()}`}
                          subtitle={
                            documentEnabled === "Y" &&
                            <CircularButton
                              currentTheme={currentTheme}
                              onClick={() => {
                                if (activityTypeRef.current) {
                                  activityTypeRef.current?.focus();
                                }
                                setActivityType({
                                  value: "Task",
                                  label: "Task",
                                });
                                setActivityDate(moment().format("YYYY-MM-DD"));
                                setActivityDone("N");
                                setIsAddTaskDialogOpen(true);
                              }}
                              icon={<MdAdd color="green" />} width={"30px"} height={"30px"} />
                          }
                          defaultExpanded={plOpActivities?.length > 0}
                        >
                          {plOpActivities?.length > 0 &&
                            <div className="activities-wrapper">
                              {plOpActivities?.map((row, index) => (
                                <div key={row._id} className='single-activity'>
                                  <div className="left">
                                    <span className='sub-title'>{index + 1}</span>
                                  </div>
                                  <div className="right" style={{ width: "100%" }}>
                                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                      <span className="sub-title" style={{ flex: "1" }}>{row?.activity_name}</span>
                                      <span className={`status ${row?.status_color_xx}`} style={{ width: "100px", textAlign: "center" }}>{row?.activity_type}</span>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                      <span className="sub-title xrsmall soft">{`${t('due')} ${moment(row?.activity_date).format("DD-MMM-YYYY")}`}</span>
                                      {row?.activity_venue && <span className="sub-title xrsmall soft">{`${t('venue')} ${row?.activity_venue}`}</span>}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>}
                        </ExpandableComponent>
                        {/* Limits of liability section */}
                        {["Policy", 'RiskNote'].includes(plType) &&
                          quoteData?.project_limit_yn_xx === "Y" &&
                          <div className="limits-section">
                            <ExpandableComponent
                              title={t('limitsOfLiability').toUpperCase()}
                              subtitle={documentEnabled === "Y" && <div className="limits-toolbar">
                                <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                  <input
                                    ref={limitTextRef}
                                    id="limit_text"
                                    name="limit_text"
                                    type="text"
                                    value={addLimitText}
                                    placeholder={t('text').toUpperCase()}
                                    style={{ width: "300px" }}
                                    className="form-input-item table"
                                    onChange={(e) => setAddLimitText(e.target.value)}
                                  />
                                  <input
                                    ref={limitAmountRef}
                                    id="limit_amount"
                                    name="limit_amount"
                                    type="text"
                                    value={addLimitAmount}
                                    placeholder={t('amount').toUpperCase()}
                                    style={{ width: "150px", textAlign: "end" }}
                                    className="form-input-item table"
                                    onChange={(e) => setAddLimitAmount(e.target.value)}
                                  />
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={async (e) => {
                                      try {

                                        if (!addLimitText) {
                                          setNotifyDialogTitle("Note!");
                                          setNotifyDialogText(`Please enter limit text`);
                                          setIsNotifyDialogOpen(true);
                                          return;
                                        }

                                        const res = await newRequest.post(
                                          "/uwPolicy/addLimit",
                                          {
                                            policy_docid: quoteId,
                                            limit_text: addLimitText,
                                            limit_amount: addLimitAmount || "",
                                          }
                                        );

                                        if (res.data?.msg === "added") {
                                          setPlLimits((prevParams) => [...prevParams, res.data?.doc]);
                                          setAddLimitText("");
                                          setAddLimitAmount("");
                                          showToast(t('added'), "success");
                                          if (limitTextRef.current) {
                                            limitTextRef.current?.focus();
                                          }
                                        } else {
                                          showToast("Error adding limit!", "error");
                                        }
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    icon={<MdAdd />}
                                    width={"30px"}
                                    height={"30px"} />
                                </div>
                              </div>
                              }
                              defaultExpanded={plLimits?.length > 0}
                            >
                              <div className="deductibles-wrapper">
                                <div className="table-content">
                                  <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                    <Table sx={{ width: "max-content", border: 'none' }}>
                                      <TableHead className="tablehead">
                                        <TableRow className="tablerow">
                                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            #
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            <span>{t('text').toUpperCase()}</span>
                                          </TableCell>
                                          <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                            <span>{t('limit').toUpperCase()}</span>
                                          </TableCell>
                                          {documentEnabled === "Y" &&
                                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                              <span>{t('action').toUpperCase()}</span>
                                            </TableCell>}
                                        </TableRow>
                                      </TableHead>
                                      <TableBody className="tablebody">
                                        {plLimits?.map((row, index) => (
                                          <TableRow
                                            key={row?._id}
                                            className={`${selectedLimit?._id === row._id ? "tablerow current" : "tablerow"}`}
                                            onClick={async () => setSelectedLimit(row)}
                                          >
                                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                              <span className="normal-title">{index + 1}</span>
                                            </TableCell>
                                            <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                                              <div className="input-item-with-label" style={{ width: "100%" }}>
                                                <input
                                                  id="limit_text"
                                                  name="limit_text"
                                                  type="text"
                                                  value={row?.limit_text}
                                                  placeholder={t('limit').toUpperCase()}
                                                  style={{ width: "100%" }}
                                                  className="form-input-item table"
                                                  onChange={(e) => handleDocumentLimitChange(e.target.value, row._id, "limit_text")}
                                                  disabled={documentEnabled === "N"}
                                                />
                                              </div>
                                            </TableCell>
                                            <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                              <div className="input-item-with-label" style={{ width: "100%" }}>
                                                <input
                                                  id="limit_amount"
                                                  name="limit_amount"
                                                  type="text"
                                                  value={row?.limit_amount}
                                                  placeholder={t('amount').toUpperCase()}
                                                  style={{ width: "100%", textAlign: "right" }}
                                                  className="form-input-item table"
                                                  onChange={(e) => handleDocumentLimitChange(e.target.value, row._id, "limit_amount")}
                                                  disabled={documentEnabled === "N"}
                                                />
                                              </div>
                                            </TableCell>
                                            {documentEnabled === "Y" &&
                                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                <CircularButton
                                                  currentTheme={currentTheme}
                                                  onClick={async () => {
                                                    try {
                                                      const res = await newRequest.post("/uwPolicy/deleteLimit", {
                                                        policy_docid: quoteId,
                                                        limit_docid: row?._id
                                                      });
                                                      if (res.data === "removed") {
                                                        setPlLimits((prevData) =>
                                                          prevData.filter(param => param._id !== row?._id)
                                                        );
                                                        showToast(t('removed'), "success");
                                                      } else {
                                                        showToast("Error removing limit!", "error");
                                                      }
                                                    } catch (error) {
                                                      console.log(error);
                                                    }
                                                  }}
                                                  color="#E53935" icon={<MdDelete />} width={"35px"} height={"35px"} />
                                              </TableCell>}
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </div>
                              </div>
                            </ExpandableComponent>
                          </div>}
                        {/* Benefits section */}
                        {["Policy", 'RiskNote'].includes(plType) &&
                          quoteData?.project_benefit_yn_xx === "Y" &&
                          <div className="limits-section">
                            <ExpandableComponent
                              title={t('applicableBenefits').toUpperCase()}
                              subtitle={documentEnabled === "Y" &&
                                <div className="limits-toolbar">
                                  <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                    <input
                                      ref={benefitTextRef}
                                      id="benefit_text"
                                      name="benefit_text"
                                      type="text"
                                      value={addBenefitText}
                                      placeholder={t('text').toUpperCase()}
                                      style={{ width: "300px" }}
                                      className="form-input-item table"
                                      onChange={(e) => setAddBenefitText(e.target.value)}
                                    />
                                    <input
                                      ref={benefitAmountRef}
                                      id="benefit_amount"
                                      name="benefit_amount"
                                      type="text"
                                      value={addBenefitAmount}
                                      placeholder={t('amount').toUpperCase()}
                                      style={{ width: "150px", textAlign: "end" }}
                                      className="form-input-item table"
                                      onChange={(e) => setAddBenefitAmount(e.target.value)}
                                    />
                                    <CircularButton
                                      currentTheme={currentTheme}
                                      onClick={async (e) => {
                                        try {

                                          if (!addBenefitText) {
                                            setNotifyDialogTitle("Note!");
                                            setNotifyDialogText(`Please enter benefit text`);
                                            setIsNotifyDialogOpen(true);
                                            return;
                                          }

                                          const formattedBenefitAmount = ((benefitAmount) => {
                                            let formattedAmount;
                                            if (!isNaN(benefitAmount) && benefitAmount !== null && benefitAmount !== "") {
                                              // It's numeric (string or number) → format it
                                              formattedAmount = formatAmountsToDecimals(benefitAmount, 2);
                                            } else {
                                              // It's non-numeric (like "Unlimited") → leave as-is
                                              formattedAmount = benefitAmount;
                                            }
                                            return formattedAmount;
                                          });


                                          const res = await newRequest.post(
                                            "/uwPolicy/addBenefit",
                                            {
                                              policy_docid: quoteId,
                                              benefit_text: addBenefitText,
                                              benefit_amount: formattedBenefitAmount(addBenefitAmount) || "",
                                            }
                                          );

                                          if (res.data?.msg === "added") {
                                            setPlBenefits((prevParams) => [...prevParams, res.data?.doc]);
                                            setAddBenefitText("");
                                            setAddBenefitAmount("");
                                            showToast(t('added'), "success");
                                            if (benefitTextRef.current) {
                                              benefitTextRef.current?.focus();
                                            }
                                          } else {
                                            showToast("Error adding benefit!", "error");
                                          }
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                      icon={<MdAdd />}
                                      width={"30px"}
                                      height={"30px"} />
                                  </div>
                                </div>
                              }
                              defaultExpanded={plBenefits?.length > 0}
                            >
                              <div className="deductibles-wrapper">
                                <div className="table-content">
                                  <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                    <Table sx={{ width: "max-content", border: 'none' }}>
                                      <TableHead className="tablehead">
                                        <TableRow className="tablerow">
                                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            #
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            <span>{t('text').toUpperCase()}</span>
                                          </TableCell>
                                          <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                            <span>{`${t('limit').toUpperCase()} [${plCurCode?.value}]`}</span>
                                          </TableCell>
                                          {documentEnabled === "Y" &&
                                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                              <span>{t('action').toUpperCase()}</span>
                                            </TableCell>}
                                        </TableRow>
                                      </TableHead>
                                      <TableBody className="tablebody">
                                        {plBenefits?.map((row, index) => (
                                          <TableRow
                                            key={row?._id}
                                            className={`${selectedBenefit?._id === row._id ? "tablerow current" : "tablerow"}`}
                                            onClick={async () => setSelectedBenefit(row)}
                                          >
                                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                              <h1 className="normal-title">{index + 1}</h1>
                                            </TableCell>
                                            <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                                              <div className="input-item-with-label" style={{ width: "100%" }}>
                                                {documentEnabled === "Y" ?
                                                  <input
                                                    id="benefit_text"
                                                    name="benefit_text"
                                                    type="text"
                                                    value={row?.benefit_text}
                                                    placeholder={t('benefit').toUpperCase()}
                                                    style={{ width: "100%" }}
                                                    className="form-input-item table"
                                                    onChange={(e) => handleDocumentBenefitChange(e.target.value, row._id, "benefit_text")}
                                                    disabled={documentEnabled === "N"}
                                                  /> :
                                                  <span className='normal-title' style={{ width: "100%" }}>{row?.benefit_text}</span>}
                                              </div>
                                            </TableCell>
                                            <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                              <div className="input-item-with-label" style={{ width: "100%" }}>
                                                {documentEnabled === "Y" ?
                                                  <input
                                                    id="benefit_amount1"
                                                    name="benefit_amount1"
                                                    type="text"
                                                    value={row?.benefit_amount}
                                                    placeholder={t('amount').toUpperCase()}
                                                    style={{ width: "100%", textAlign: "right" }}
                                                    className="form-input-item table"
                                                    onChange={(e) => handleDocumentBenefitChange(e.target.value, row._id, "benefit_amount")}
                                                    onBlur={() => handleBenefitBlur(row?._id, "benefit_amount")}
                                                    disabled={documentEnabled === "N"}
                                                  /> :
                                                  <span className='normal-title' style={{ width: "100%", textAlign: "right" }}>{numeral(row?.benefit_amount).format("0,0.00")}</span>}
                                              </div>
                                            </TableCell>
                                            {documentEnabled === "Y" &&
                                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                <CircularButton
                                                  currentTheme={currentTheme}
                                                  onClick={async () => {
                                                    try {
                                                      const res = await newRequest.post("/uwPolicy/deleteBenefit", {
                                                        policy_docid: quoteId,
                                                        benefit_docid: row?._id
                                                      });
                                                      if (res.data === "removed") {
                                                        setPlBenefits((prevData) =>
                                                          prevData.filter(param => param._id !== row?._id)
                                                        );
                                                        showToast(t('removed'), "success");
                                                      } else {
                                                        showToast("Error removing benefit!", "error");
                                                      }
                                                    } catch (error) {
                                                      console.log(error);
                                                    }
                                                  }}
                                                  color="#E53935" icon={<MdDelete />} width={"30px"} height={"30px"} />
                                              </TableCell>}
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </div>
                              </div>
                            </ExpandableComponent>
                          </div>}
                        {quoteId === "new" && <span style={{ display: "flex", width: "100%", height: "50px" }} />}
                        {/* <hr className='separator-h' /> */}
                        <div className="content-details-row"
                          style={{
                            display: "flex",
                            width: "100%",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "5px",
                            paddingLeft: "0px"
                          }}>
                          {Object.keys(quoteData).length === 0 && (
                            <div className="quote-not-saved">
                              SAVE TO VIEW MORE INFORMATION
                            </div>
                          )}
                          {Object.keys(quoteData).length > 0 && (
                            <div style={{
                              display: "flex",
                              width: "100%",
                              flexDirection: "column",
                              marginBottom: "30px"
                            }}>
                              <UwPolicyRisk
                                key={policyRiskKey}
                                ref={policyRiskRef}
                                quoteData={quoteData}
                                refreshQuote={refreshQuote}
                                profileLimitValues={profileLimitValues}
                                setPolicyNo={() => setIsManualPolicyNo(true)}
                              />
                            </div>
                          )}
                        </div>
                      </div>}
                  </div>}
                {/* WORDINGS FOR POLICY, RISK NOTES,QUOTES AND RENEWALS */}
                {activeTab === 1 &&
                  ["Policy", "RiskNote", "Quote", "Renewal"].includes(plType) &&
                  <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "10px" }}>
                    <div className="content-details-row" >
                      {Object.keys(quoteData).length > 0 && (
                        <div className="scrolling-view">
                          <UwPolicyCond
                            quoteData={quoteData}
                            refreshQuote={refreshQuote}
                            ref={policyCondRef}
                            profileLimitValues={profileLimitValues}
                            mcCode={plType}
                            scCode={plType}
                            scEndorsed={documentEnabled}
                          />
                        </div>
                      )}
                    </div>
                    {documentEnabled === "Y" && <hr className='separator-h' />}
                    {/* Excess */}
                    <div className="content-details-row" style={{ marginBottom: "20px" }}>
                      {Object.keys(quoteData).length > 0 && (
                        <div className="scrolling-view">
                          <UwPolicyExcess
                            quoteData={quoteData}
                            refreshQuote={refreshQuote}
                            ref={policyExcessRef}
                            profileLimitValues={profileLimitValues}
                            mcCode={plType}
                            scCode={plType}
                            scEndorsed={documentEnabled}
                            excessLevel="Policy"
                            excessRiskDocid=""
                          />
                        </div>
                      )}
                    </div>
                  </div>}
                {/* QUOTE REQUESTS AND OPPORTUNITIES */}
                {activeTab === 1 &&
                  ["QuoteRequest", "Opportunity"].includes(plType) &&
                  <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "10px" }}>
                    {/* FOR OPPORTUNITIES AND QUOTES */}
                    <ExpandableComponent
                      title={`${plOpTeam?.length} ${plOpTeam?.length === 1 ? t('teamMember').toUpperCase() : t('teamMembers').toUpperCase()}`}
                      subtitle={
                        documentEnabled === "Y" &&
                        <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                          <AsyncSelect
                            id="member"
                            name="member"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="250px"
                            value={selectedMember}
                            onChange={(selectedOption) => setSelectedMember(selectedOption)}
                            loadOptions={(inputValue, callback) => fetchUsersBySearch(inputValue, callback, ["Internal"])}
                            isSearchable={true}
                            placeholder={t('team')}
                            noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                          />
                          <div className="input-item-with-label">
                            <Select
                              id="account_role"
                              name="account_role"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="120px"
                              value={selectedRole}
                              onChange={(selectedOption) => setSelectedRole(selectedOption)}
                              options={accountRoles}
                              placeholder={t('role').toUpperCase()}
                            />
                          </div>
                          <CircularButton
                            currentTheme={currentTheme}
                            onClick={async (e) => {
                              try {

                                if (!selectedMember) {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Please select team member`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }

                                if (!selectedRole) {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Please select role`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }

                                if (selectedMember && selectedRole) {
                                  const res = await newRequest.post(
                                    "/uwPolicy/addTeamMember",
                                    {
                                      policy_docid: quoteData?._id,
                                      user_docid: selectedMember?.value,
                                      user_role: selectedRole?.value,
                                    }
                                  );

                                  if (res.data?.msg === "added") {
                                    setPlOpTeam((prevParams) => [...prevParams, res.data?.doc]);
                                    setSelectedMember(null);
                                    setSelectedRole(null);
                                    showToast(`Added`, "success");
                                  } else if (res.data?.msg === "exists") {
                                    showToast(`${selectedMember?.label?.props?.children[0]} is already part of the team`, "warning");
                                  } else {
                                    showToast("Error adding member!", "error");
                                  }
                                } else {
                                  setNotifyDialogTitle("Note!");
                                  setNotifyDialogText(`Please select member`);
                                  setIsNotifyDialogOpen(true);
                                  return;
                                }
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                        </span>}
                      defaultExpanded={plOpTeam?.length > 0}
                    >
                      <div className="team-content">
                        {plOpTeam?.length > 0 &&
                          <div className="team-wrapper">
                            {plOpTeam?.map((row, index) => (
                              <div key={row._id} className='single-member'>
                                <div className="single-member-left">
                                  {row?.usr_photo_url ?
                                    <img src={row?.usr_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "60px", height: "60px" }} />}
                                </div>
                                <div className="single-member-right">
                                  <div className="single-member-header">
                                    <span className='member-name'>{row?.usr_full_name}</span>
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                      <span className="relationship-type">{row?.user_role}</span>
                                      {documentEnabled === "Y" &&
                                        <CircularButton
                                          currentTheme={currentTheme}
                                          onClick={async () => {
                                            try {
                                              setIsProcessing(true);
                                              const res = await newRequest.post("/uwPolicy/removeMember", {
                                                policy_docid: quoteData?._id,
                                                member_docid: row?._id,
                                                member_name: row?.usr_full_name
                                              });
                                              setIsProcessing(false);
                                              if (res.data?.msg === "removed") {
                                                setPlOpTeam((prev) => prev.filter(mm => mm?._id !== row?._id));
                                                showToast("Removed!", "success");
                                              } else {
                                                showToast("Error removing!", "error");
                                              }
                                            } catch (error) {
                                              console.log(error);
                                            }
                                          }} color="#E53935" icon={<MdDelete />} width={"35px"} height={"35px"} />}
                                    </div>
                                  </div>
                                  <div className="member-phone-row">
                                    <span className="member-phone-details" style={{ flex: "1.5" }}> <MdAlternateEmail className="icon" />{row?.usr_email}</span>
                                    <span className="member-phone-details" style={{ flex: "1" }}> <MdPhone className="icon" />{row?.usr_phone_no}</span>
                                    <span className="member-phone-details" style={{ flex: "0.7" }}><RiBuilding2Fill className="icon" /> {row?.bizunit_name_xx}</span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>}
                      </div>
                    </ExpandableComponent>
                  </div>}
                {/* Attachments */}
                {activeTab === 2 &&
                  <div className="attachment">
                    {!["Cancelled", 'Voided'].includes(plStatus) &&
                      <FileUploadComponent
                        documentNo={quoteData?.pl_risk_note_no}
                        documentId={quoteData._id}
                        documentType={quoteData?.pl_type}
                        fetchDocumentAttachments={fetchDocumentAttachments}
                        uploadFolder={`uw-${removeSpacesAndTabs(quoteData?.pl_type)?.toLowerCase()}/${quoteData._id}`}
                      />}
                    <div className="attachment-files">
                      <AllFiles filesList={attachmentsData} whatsappAllowed={quoteData?.insured_details_xx?.ent_whatsapp} phoneNo={quoteData?.insured_details_xx?.ent_whatsapp_no} />
                    </div>
                  </div>}
                {/* Claims */}
                {activeTab === 3 &&
                  <>
                    {["Opportunity", "QuoteRequest", "Quote"].includes(plType) &&
                      <div className="tender-wrapper">
                        <div className="tender-row-details">
                          <ToggleSwitch
                            id="is_tender"
                            value={plTenderInfo.is_tender}
                            onChange={(newValue) => updateTenderField("is_tender", newValue)}
                            label={t('isTender').toUpperCase()}
                            labelWidth="max-content"
                            disabled={false}
                            border="N"
                            style={{
                              width: "250px",
                            }}
                          />
                          <div className="input-item-with-label" style={{ display: "flex", width: "80%" }}>
                            <label htmlFor="tender_no"
                              style={{ width: "max-content" }}
                              className="form-dropdown-label">
                              {t('no').toUpperCase()}
                            </label>
                            <input
                              id="tender_no"
                              name="tender_no"
                              type="text"
                              placeholder={t('no').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "100%" }}
                              value={plTenderInfo?.tender_no}
                              onChange={(e) => updateTenderField('tender_no', e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="tender-row-details">
                          <div className="input-item-with-label" style={{ display: "flex", width: "100%" }}>
                            <label htmlFor="title"
                              style={{ width: "100px" }}
                              className="form-dropdown-label">
                              {t('title').toUpperCase()}
                            </label>
                            <input
                              id="title"
                              name="title"
                              type="text"
                              placeholder={t('title').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "90%" }}
                              value={plTenderInfo?.title}
                              onChange={(e) => updateTenderField('title', e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="tender-row-details">
                          <div className="input-item-with-label" style={{ flex: "1" }}>
                            <label htmlFor="tender_type"
                              style={{ width: "130px" }}
                              className="form-dropdown-label">
                              {t('type').toUpperCase()}
                            </label>
                            <Select
                              id="tender_type"
                              name="tender_type"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="100%"
                              value={tenderTypes.find(option => option.value === plTenderInfo?.tender_type) || null}
                              onChange={(selectedOption) => updateTenderField('tender_type', selectedOption?.value)}
                              options={tenderTypes}
                              isSearchable={true}
                              placeholder={t('type').toUpperCase()}
                            />
                          </div>
                          <div className="input-item-with-label" style={{ flex: "1" }}>
                            <label htmlFor="submission_method"
                              style={{ width: "100px" }}
                              className="form-dropdown-label">
                              {t('method').toUpperCase()}
                            </label>
                            <Select
                              id="submission_method"
                              name="submission_method"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="100%"
                              value={submissionMethods.find(option => option.value === plTenderInfo?.submission_method) || null}
                              onChange={(selectedOption) => updateTenderField('submission_method', selectedOption?.value)}
                              options={submissionMethods}
                              isSearchable={true}
                              placeholder={t('method').toUpperCase()}
                            />
                          </div>
                        </div>
                        <div className="tender-row-details">
                          <div className="input-item-with-label" style={{ flex: "1" }}>
                            <label htmlFor="issuing_authority"
                              style={{ width: "120px" }}
                              className="form-dropdown-label">
                              {t('issuer').toUpperCase()}
                            </label>
                            <input
                              id="issuing_authority"
                              name="issuing_authority"
                              type="text"
                              placeholder={t('issuer').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "90%" }}
                              value={plTenderInfo?.issuing_authority}
                              onChange={(e) => updateTenderField('issuing_authority', e.target.value)}
                            />
                          </div>
                          <div className="input-item-with-label" style={{ flex: "1" }}>
                            <label htmlFor="issuing_country"
                              style={{ width: "100px" }}
                              className="form-dropdown-label">
                              {t('country').toUpperCase()}
                            </label>
                            <input
                              id="issuing_country"
                              name="issuing_country"
                              type="text"
                              placeholder={t('country').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "100%" }}
                              value={plTenderInfo?.issuing_country}
                              onChange={(e) => updateTenderField('issuing_country', e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="tender-row-details">
                          <div className="input-item-with-label" style={{ display: "flex", width: "100%" }}>
                            <label htmlFor="description"
                              style={{ width: "100px", textAlign: "flex-start" }}
                              className="form-dropdown-label">
                              {t('desc').toUpperCase()}
                            </label>
                            <textarea
                              id="description"
                              name="description"
                              type="text"
                              rows={3}
                              placeholder={t('description').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "90%" }}
                              value={plTenderInfo?.description}
                              onChange={(e) => updateTenderField('description', e.target.value)}
                            />
                          </div>
                        </div>
                        <hr className="separator-h" />
                        <span className="main-title">{t('dates')}</span>
                        <div className="tender-row-details">
                          <div className="input-item-with-label">
                            <label htmlFor="publication_date"
                              style={{ width: "100px", textAlign: "flex-start" }}
                              className="form-dropdown-label">
                              {t('published').toUpperCase()}
                            </label>
                            <input
                              id="publication_date"
                              name="publication_date"
                              type="date"
                              placeholder={t('published').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "150px" }}
                              value={moment(plTenderInfo?.publication_date).format("YYYY-MM-DD")}
                              onChange={(e) => updateTenderField('publication_date', e.target.value)}
                            />
                          </div>

                          <div className="input-item-with-label">
                            <label htmlFor="submission_deadline"
                              style={{ width: "max-content", textAlign: "flex-start" }}
                              className="form-dropdown-label">
                              {t('submission').toUpperCase()}
                            </label>
                            <input
                              id="submission_deadline"
                              name="submission_deadline"
                              type="date"
                              placeholder={t('submission').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "150px" }}
                              value={moment(plTenderInfo?.submission_deadline).format("YYYY-MM-DD")}
                              onChange={(e) => updateTenderField('submission_deadline', e.target.value)}
                            />
                          </div>

                          <div className="input-item-with-label">
                            <label htmlFor="opening_date"
                              style={{ width: "max-content", textAlign: "flex-start" }}
                              className="form-dropdown-label">
                              {t('opening').toUpperCase()}
                            </label>
                            <input
                              id="opening_date"
                              name="opening_date"
                              type="date"
                              placeholder={t('opening').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "150px" }}
                              value={moment(plTenderInfo?.opening_date).format("YYYY-MM-DD")}
                              onChange={(e) => updateTenderField('opening_date', e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="tender-row-details">
                          <div className="input-item-with-label" style={{ display: "flex", width: "100%" }}>
                            <label htmlFor="eligibility_criteria"
                              style={{ width: "100px" }}
                              className="form-dropdown-label">
                              {t('eligibility').toUpperCase()}
                            </label>
                            <input
                              id="eligibility_criteria"
                              name="eligibility_criteria"
                              type="text"
                              placeholder={t('eligibility').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "90%" }}
                              value={plTenderInfo?.eligibility_criteria}
                              onChange={(e) => updateTenderField('eligibility_criteria', e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="tender-row-details">
                          <div className="input-item-with-label" style={{ display: "flex", width: "100%" }}>
                            <label htmlFor="evaluation_criteria"
                              style={{ width: "100px" }}
                              className="form-dropdown-label">
                              {t('evaluation').toUpperCase()}
                            </label>
                            <input
                              id="evaluation_criteria"
                              name="evaluation_criteria"
                              type="text"
                              placeholder={t('evaluation').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "90%" }}
                              value={plTenderInfo?.evaluation_criteria}
                              onChange={(e) => updateTenderField('evaluation_criteria', e.target.value)}
                            />
                          </div>
                        </div>
                        <hr className="separator-h" />
                        <span className="main-title">{t('award')}</span>
                        <div className="tender-row-details">
                          <div className="input-item-with-label" style={{ flex: "1" }}>
                            <label htmlFor="awarded_to"
                              style={{ width: "120px" }}
                              className="form-dropdown-label">
                              {t('winner').toUpperCase()}
                            </label>
                            <input
                              id="awarded_to"
                              name="awarded_to"
                              type="text"
                              placeholder={t('winner').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "90%" }}
                              value={plTenderInfo?.awarded_to}
                              onChange={(e) => updateTenderField('awarded_to', e.target.value)}
                            />
                          </div>
                          <div className="input-item-with-label" style={{ flex: "1" }}>
                            <label htmlFor="award_date"
                              style={{ width: "100px" }}
                              className="form-dropdown-label">
                              {t('date').toUpperCase()}
                            </label>
                            <input
                              id="award_date"
                              name="award_date"
                              type="date"
                              placeholder={t('date').toUpperCase()}
                              disabled={documentEnabled === "N"}
                              className="form-input-item"
                              style={{ width: "100%" }}
                              value={moment(plTenderInfo?.award_date).format("YYYY-MM-DD")}
                              onChange={(e) => updateTenderField('award_date', e.target.value)}
                            />
                          </div>
                        </div>
                      </div>}
                    {["RiskNote", "Renewal", "Policy"].includes(plType) &&
                      <div className="content-details-row">
                        <div className="claims-wrapper">
                          {policyClaimsList?.length === 0 && <div className="no-claim">
                            <h1 className="main-title">{`NO CLAIM REGISTERED FOR POLICY NUMBER ${plNo}`}</h1>
                          </div>}
                          {policyClaimsList?.length > 0 && <div className="claims-content">
                            {policyClaimsList?.map((row, index) => (
                              <div key={row?._id} className="single-claim"
                                onClick={() => {
                                  navigate(`/cm/${row?._id}`, {
                                    state: row,
                                  });
                                }}>
                                <h1 className="claim-no">{`CLAIM NO : ${row?.cm_claim_no}`}</h1>
                                <h3 className="claim-details">{`INTIMATED : ${moment(row?.cm_intimation_date).format("DD-MMM-YYYY")}`}</h3>
                                <h3 className="claim-details">{`LOSS DATE : ${moment(row?.cm_loss_date).format("DD-MMM-YYYY")}`}</h3>
                                <h3 className="claim-details">{`REGISTERED : ${row?.time_ago_xx}`}</h3>
                              </div>
                            ))}
                          </div>}
                        </div>
                      </div>}
                  </>}
                {activeTab === 4 &&
                  <motion.div
                    className="content-details-row"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                  >
                    <Correspondence
                      correspondenceParams={{ fetch_type: "document", doc_id: quoteData._id, doc_no: plRiskNoteNo, doc_type: plType, entity_codes: [selectedInsured?.value, selectedCarrier?.value] }}
                      passedEmailData={{
                        to: quoteData?.insured_details_xx?.ent_email,
                        cc: `${quoteData?.carrier_details_xx?.ent_email},${currentUser?.usr_email}`,
                        bcc: '',
                        subject: ``,
                        show_attach: "Y",
                        attached_urls: [],
                        binary_docs: [],
                        doc_no: plRiskNoteNo,
                        doc_type: plType,
                        doc_id: quoteId,
                        entity_codes: [selectedInsured?.value, selectedCarrier?.value],
                        search_string: selectedInsured?.label?.props?.children[0] + "," + selectedCarrier?.label?.props?.children[0] + "," + plRiskNoteNo,
                        carrierName: selectedCarrier?.label?.props?.children[0],
                        productName: selectedProduct?.label?.props?.children[0],
                        clientName: selectedInsured?.label?.props?.children[0],
                        riskNoteNo: plRiskNoteNo,
                        daysToRenewal: quoteData?.expiring_in_days,
                        expiryDate: quoteData?.fmt_to_date,
                        insuredName: selectedInsured?.label?.props?.children[0],
                        outstandingPremium: quoteData?.outstandingPremium,
                        policyCurrency: plCurCode?.value,
                        policyNumber: plNo,
                        policyPremium: quoteData?.fmt_policy_fc_prem,
                        policyPremiumTotal: quoteData?.fmt_total_fc_prem,
                        policySumInsured: quoteData?.fmt_total_fc_si,
                        policyFromDate: quoteData?.fmt_fm_date,
                        policyToDate: quoteData?.fmt_to_date,

                        requestedAction: `${t('issueParam', { param1: quoteData?.end_name_xx })}`,
                        jurisdiction: "Kenya Only",
                        financialInterestDetails: selectedFinancier?.ent_name || "None",
                        handlerName: currentUser?.usr_full_name,
                        handlerTitle: currentUser?.usr_title,
                        handlerPhone: currentUser?.usr_phone_no,
                        handlerEmail: currentUser?.usr_email,
                        todaysDate: moment().format("Do MMM YYYY HH:mm"),

                        tpt_category: ["Policy Renewal", "Birthday"]
                      }} />
                  </motion.div>
                }
                {activeTab === 5 &&
                  <AllDocsNote
                    docId={quoteData._id}
                    docType="Policy"
                    noteType={"Normal"}
                  />
                }
              </div>
            </div>
            <div className="document-summary-wrapper">
              <div className="worked-on-by-container">
                <div className="panel-card" style={{ padding: "10px" }}>
                  <WorkedOnBy
                    name={quoteData?.updated_by_name_xx}
                    photoUrl={quoteData?.updated_by_photo_url_xx}
                    time_ago_xx={quoteData?.time_ago_xx}
                  />
                </div>
              </div>
              {quoteData?.expiring_show_xx === "Y" &&
                <div className="summary-view">
                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("importantInfo").toUpperCase()}</h1>
                      </div>
                      <div className="panel-card__divider" />
                    </div>
                    <div className="panel-card__body">
                      <div className="kv-row">
                        {/* <span className="kv-text">{quoteData?.expiring_text} </span> */}
                        <span className="kv-text" dangerouslySetInnerHTML={{ __html: quoteData?.expiring_text }} />
                      </div>
                    </div>
                  </div>
                </div>}
              <div className="document-summary-content">
                {plCurCode?.value !== currentUser?.currency_code_xx && (
                  <div
                    className="input-item-with-label"
                    style={{ alignSelf: "flex-end", margin: "0px 5px 5px 0px" }}
                  >
                    <label
                      htmlFor="pl_cur_rate"
                      className="form-dropdown-label"
                    >
                      {t('rate').toUpperCase()}
                    </label>
                    <input
                      id="pl_cur_rate"
                      name="pl_cur_rate"
                      type="number"
                      placeholder="0.00"
                      value={plCurRate}
                      className="form-input-item"
                      style={{
                        width: "100px",
                        margin: "5px 0px",
                        textAlign: "right",
                      }}
                      onChange={(e) => setPlCurRate(e.target.value)}
                      disabled={documentEnabled === "N" || getLimitValue("UW1021") === "N"} // Disable if documentEnabled is "N" or user not allowed to override exchange rate
                    />
                  </div>
                )}
                <div className="summary-view" >
                  {/* ===================== SUMMARY CARD ===================== */}
                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("summary").toUpperCase()}</h1>

                        {currentUser?.currency_code_xx !== plCurCode?.value && (
                          <CustomButtonSmall
                            style={{ display: "flex" }}
                            onClick={() => setFiguresToShow((p) => (p === "org" ? "base" : "org"))}
                          >
                            {figuresToShow === "org"
                              ? `view ${currentUser?.currency_code_xx}`
                              : `view ${plCurCode?.value}`}
                          </CustomButtonSmall>
                        )}

                        <span className="panel-card__currency">
                          {figuresToShow === "org" ? plCurCode?.value : currentUser?.currency_code_xx}
                        </span>
                      </div>
                      <div className="panel-card__divider" />
                    </div>

                    <div className="panel-card__body">
                      <div className="kv-row">
                        <span className="kv-key">{t("sumInsured").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org" ? quoteData?.total_fc_si : quoteData?.total_lc_si
                          ).format("0,0.00")}
                        </span>
                      </div>

                      <div className="kv-row">
                        <span className="kv-key">{t("premium").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? quoteData?.policy_fc_premium
                              : quoteData?.policy_lc_premium
                          ).format("0,0.00")}
                        </span>
                      </div>

                      {quoteData?.policy_charges?.length > 0 && (
                        <div className="kv-group">
                          {quoteData.policy_charges.map((charge) => (
                            <div className="kv-row" key={charge._id}>
                              <span className="kv-key">{charge.charge_name}</span>
                              <span className="kv-val">
                                {numeral(
                                  figuresToShow === "org"
                                    ? charge.charge_fc_amount
                                    : charge.charge_lc_amount
                                ).format("0,0.00")}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* TOTAL PREMIUM pill (moved from inline styles to SCSS) */}
                      <div className="pill-row pill-row--success">
                        <span className="pill-label">{t("totalPremium").toUpperCase()}</span>
                        <span className="pill-value">
                          {numeral(
                            figuresToShow === "org"
                              ? quoteData?.total_fc_premium
                              : quoteData?.total_lc_premium
                          ).format("0,0.00")}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* ===================== RECEIPTS CARD ===================== */}
                  {!["Cancelled", "Voided"].includes(plStatus) && quoteData?.drcr_flag_xx === "D" && (
                    <div className="panel-card">
                      <div className="panel-card__header">
                        <div className="panel-card__titleRow">
                          <h1 className="panel-card__title">{t("receipts").toUpperCase()}</h1>

                          {getLimitValue("UW1010") === "Y" &&
                            parseFloat(formatStringToNumberV2(quoteData.total_os_fc_amount, 2)) > 0 &&
                            !["Deleted", "Voided", "Cancelled"].includes(plStatus) && (
                              <CustomButtonSmall
                                currentTheme={currentTheme}
                                iconPosition="end"
                                endIcon={<MdAdd />}
                                onClick={async () => {
                                  try {
                                    setReceiptCurrency(plCurCode?.value);
                                    await fetchPolicyInstallments();
                                    setReceiptOpen(!receiptOpen);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                              >
                                {t("addReceipt").toUpperCase()}
                              </CustomButtonSmall>
                            )}
                        </div>
                        <div className="panel-card__divider" />
                      </div>

                      <div className="panel-card__body">
                        {/* NOTE 1: If no receipts, show "None" then show outstanding premium */}
                        {quoteData?.paid_installments?.length > 0 && quoteData?.drcr_flag_xx === "D" ? (
                          <div className="kv-group">
                            {quoteData.paid_installments.map((receipt) => (
                              <div className="kv-row" key={receipt?._id}>
                                <span className="kv-key">
                                  <span className="receipt-mode">{receipt?.receipt_mode}</span>{" "}
                                  <span
                                    className="receipt-link"
                                    onClick={() => {
                                      try {
                                        if (receipt.receipt_paid_to === "ToCarrier") {
                                          setNotifyDialogTitle("Note!");
                                          setNotifyDialogText(
                                            `This receipt ${receipt?.ln_hd_no} was receipted by carrier!`
                                          );
                                          setIsNotifyDialogOpen(true);
                                          return;
                                        } else {
                                          navigate(`/receipt/${receipt?.ln_hd_no_docid}`);
                                        }
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                  >
                                    {receipt?.ln_hd_no}
                                  </span>
                                </span>

                                <span className="kv-val">
                                  {numeral(receipt?.ln_fc_amount).format("0,0.00")}
                                </span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="kv-row kv-row--muted">
                            <span className="kv-key">{t("receipts").toUpperCase()}</span>
                            <span className="kv-val">None</span>
                          </div>
                        )}

                        {/* O/S PREMIUM pill (moved from inline styles to SCSS) */}
                        {quoteData?.drcr_flag_xx === "D" && (
                          <div
                            className={`pill-row ${quoteData?.total_os_fc_amount > 0
                              ? "pill-row--danger"
                              : "pill-row--success"
                              }`}
                          >
                            <span className="pill-label">{t("osPremium").toUpperCase()}</span>
                            <span className="pill-value">
                              {numeral(
                                figuresToShow === "org"
                                  ? quoteData?.total_os_fc_amount
                                  : quoteData?.total_os_lc_amount
                              ).format("0,0.00")}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* ===================== COMMISSION CARD ===================== */}
                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("commission").toUpperCase()}</h1>
                        <span className="panel-card__currency">
                          {figuresToShow === "org" ? plCurCode?.value : currentUser?.currency_code_xx}
                        </span>
                      </div>
                      <div className="panel-card__divider" />
                    </div>

                    <div className="panel-card__body">
                      <div className="kv-row">
                        <span className="kv-key">{t("commission").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? quoteData?.commission_fc_amount
                              : quoteData?.commission_lc_amount
                          ).format("0,0.00")}
                        </span>
                      </div>

                      {quoteData?.commission_vat_fc > 0 && (
                        <>
                          <div className="kv-row">
                            <span className="kv-key">{t("vat").toUpperCase()}</span>
                            <span className="kv-val">
                              {numeral(
                                figuresToShow === "org"
                                  ? quoteData?.commission_vat_fc
                                  : quoteData?.commission_vat_lc
                              ).format("0,0.00")}
                            </span>
                          </div>

                          <div className="kv-row">
                            <span className="kv-key">{t("totalComm").toUpperCase()}</span>
                            <span className="kv-val">
                              {numeral(
                                figuresToShow === "org"
                                  ? quoteData?.commission_total_fc
                                  : quoteData?.commission_total_lc
                              ).format("0,0.00")}
                            </span>
                          </div>
                        </>
                      )}

                      <div className="kv-row">
                        <span className="kv-key">{t("withholding").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? quoteData?.commission_tax_fc_amount
                              : quoteData?.commission_tax_lc_amount
                          ).format("0,0.00")}
                        </span>
                      </div>

                      <div className="kv-row kv-row--last">
                        <span className="kv-key">{t("ourComm").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? quoteData?.commission_net_fc
                              : quoteData?.commission_net_lc
                          ).format("0,0.00")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* RELATED DOCUMENTS */}
                {relatedDocuments?.length > 0 &&
                  <motion.div
                    className="related-docs"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                  >
                    <div className="panel-card">
                      <div className="panel-card__header">
                        <span className="sub-title">{t('endorsements').toUpperCase()}</span>
                        <div className="panel-card__divider" />
                      </div>
                      <div className="panel-card__body">
                        <div className="timeline-root">
                          {relatedDocuments?.map((item) => (
                            <div key={item?._id} className="timeline-item">
                              <div className="timeline-separator">
                                <div className="timeline-dot"></div>
                                <div className="timeline-connector" />
                              </div>
                              <div className="timeline-content">
                                <div className="timeline-navbar">
                                  <div className="avatar-container">
                                    {item?.updated_by_photo_url_xx ?
                                      <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" /> : <CiImageOn style={{ width: "25px", height: "25px" }} />}
                                    <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
                                      <span className="username">{item?.updated_by_name_xx}</span>
                                      <span className="time-ago">{item?.time_ago_xx}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="details-wrapper">
                                  <div style={{ display: "flex", width: "100%", flexDirection: "row", marginBottom: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                    <span className="sub-title">{item?.pl_risk_note_no}</span>
                                    <span className={`status ${item?.pl_status}`} style={{ fontSize: "12px" }}>{item?.pl_status}</span>
                                  </div>
                                  <div style={{ display: "flex", width: "100%", flexDirection: "row", marginBottom: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                    <span className="sub-title">{item?.end_name_xx}</span>
                                    {item?.pl_latest === "Y" && <span className="sub-title xsmall soft">{t('latest')}</span>}
                                  </div>
                                  {/* <span className="sub-title">{item?._id}</span> */}
                                  <div className="doc-details-row">
                                    <span className="sub-title">{t('premium').toUpperCase()}</span>
                                    <span>{numeral(item?.total_fc_premium).format("0,0.00")}  </span>
                                  </div>
                                  <div className="doc-details-row">
                                    <span className="sub-title">{t('netComm').toUpperCase()}</span>
                                    <span>{numeral(item?.commission_net_fc).format("0,0.00")}  </span>
                                  </div>
                                  <span className="view" onClick={() => {
                                    try {
                                      setIsProcessing(true);
                                      navigate(`/uw/${item?.pl_type?.toLowerCase()}/${item?._id}`, { replace: true });
                                      setIsProcessing(false);
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}>
                                    {t('view')}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </motion.div>}
              </div>
            </div>
          </div>
          <Collaborator
            open={isCollabOpen}
            docType={plType}
            docNo={plNo}
            docId={docid}
            currentTheme={currentTheme}
            onClose={closeCollab}
            rightOffset={collabRightOffset}
            currentUser={currentUser}
          />
        </div>)}
      {/* progress dialog for file upload  */}
      < UploadDialog
        open={isUploadDialogOpen}
        handleClose={() => setIsUploadDialogOpen(false)}
        uploadProgress={uploadProgress}
      />
      {/* Dialog to user about changes being saved */}
      < Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notifyDialogText) }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      < ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation').toUpperCase()}
        dialogContent={
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(objectToAction.action_text) }} />
        }
      />
      {/* three options dialog */}
      < ConfirmDialogThree
        isOpen={isThreeButtonDialogOpen}
        onClose={() => { setIsThreeButtonDialogOpen(false); }}
        onButtonOne={handleButtonOne}
        onButtonTwo={handleButtonTwo}
        // onButtonThree={handleButtonThree}
        buttonOneTitle={buttonOneTitle}
        buttonTwoTitle={buttonTwoTitle}
        buttonThreeTitle={buttonThreeTitle}
        closeButtonTitle={t('cancel')}
        dialogTitle={t('confirmation').toUpperCase()}
        dialogContent={
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(objectToAction.action_text) }} />
        }
      />
      {/* check vehicle registration if already on cover */}
      {vehicleDialogOpen && (
        <motion.div
          className="vehicle-check-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="vehicle-check-wrapper">
            <div className="vehicle-check-navbar">
              <span>{t('vehicleCheck').toUpperCase()}</span>
              <CircularButton currentTheme={currentTheme} onClick={() => navigate(-1)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="vehicle-check-content">
              <div className="input-item-with-label">
                <input
                  ref={vehicleInputRef}
                  type="text"
                  value={vehicleDialogRegnNo}
                  placeholder={t('regnNo')}
                  style={{ textTransform: "uppercase", width: "200px" }}
                  className="form-input-item"
                  onChange={(e) => setVehicleDialogRegnNo(e.target.value)}
                  disabled={vehicleCheckTitle === "Checking..."}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleVehicleCheck();
                  }}
                />
                <div style={{ display: "flex", flexDirection: "row", gap: "5px", width: "100%", justifyContent: "flex-end" }}>
                  {vehicleProceedButton &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#FFA726"
                      tooltip={t('byPassChecks')}
                      endIcon={<RiSkipRightLine />}
                      onClick={handleVehicleCheckProceed}
                    >
                      {t('byPass')}
                    </CustomLoadingButton>}
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="both"
                    variant="tint"
                    color="#0097A7"
                    tooltip={t('performChecks')}
                    endIcon={<IoCheckmarkDoneOutline />}
                    onClick={handleVehicleCheck}
                  >
                    {vehicleCheckTitle}
                  </CustomLoadingButton>
                </div>
              </div>
            </div>
            {vehicleResultView === "NoVehicleFound" && (
              <div className="no-vehicle-found">
                {(
                  (
                    (["RiskNote", "Quote", "Policy"].includes(plType) &&
                      selectedProduct?.pr_express_quote === "Y")
                  ) &&
                  expressSmis?.length > 0
                ) ?
                  <div className="express-smi-wrapper">
                    <div className="input-item-with-label">
                      <label htmlFor="seletedExpressInsured" style={{ width: "100px" }}>{t('insured').toUpperCase()}</label>
                      <AsyncCreatableSelect
                        ref={expressInsuredRef}
                        id="seletedExpressInsured"
                        name="seletedExpressInsured"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        width="450px"
                        value={seletedExpressInsured}
                        onChange={(selectedOption) => {
                          try {
                            if (selectedOption?.__isNew__) {
                              // User typed a name not found in fetched options
                              setSeletedExpressInsured({
                                value: selectedOption.value,
                                label: selectedOption.label || selectedOption.value,
                                isNew: true, // custom flag to know it's not yet created
                              });
                            } else {
                              setSeletedExpressInsured({
                                ...selectedOption,
                                isNew: false,
                              });
                            }
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                        isSearchable={true}
                        placeholder={t('insured')}
                        noOptionsMessage={() => "Type Minimum 3 Letters to Search"}
                      />
                      {seletedExpressInsured?.isNew && <span className="sub-title status Expired" style={{ marginLeft: "10px" }}>{t('newClient')}</span>}
                    </div>
                    <div className="input-item-with-label">
                      <label htmlFor="seletedExpressCarrier" style={{ width: "100px" }}>{currentUser?.token_org_type === "insurance" ? t('intermediary').toUpperCase() : t('carrier').toUpperCase()}</label>
                      <AsyncSelect
                        ref={expressCarrierRef}
                        id="seletedExpressCarrier"
                        name="seletedExpressCarrier"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        width="450px"
                        value={seletedExpressCarrier}
                        onChange={(selectedOption) => setSeletedExpressCarrier(selectedOption)}
                        loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                        isSearchable={true}
                        placeholder={currentUser?.token_org_type === "insurance" ? t('intermediary') : t('carrier')}
                        noOptionsMessage={() => "Type Minimum 3 Letters to Search"}
                      />
                    </div>
                    <div className="table-content">
                      <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                        <Table sx={{ width: "max-content", border: 'none' }}>
                          <TableHead className="tablehead">
                            <TableRow className="tablerow">
                              <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                                #
                              </TableCell>
                              <TableCell className="table-cell left" style={{ width: "auto", gap: "5px" }}>
                                <span>{t('name').toUpperCase()}</span>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                <span>{t('rate').toUpperCase()}</span>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                <span>{t('ratePer').toUpperCase()}</span>
                              </TableCell>

                              <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                <span>{t('si').toUpperCase()}</span>
                              </TableCell>
                              <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                <span>{t('fcl').toUpperCase()}</span>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody className="tablebody">
                            {expressSmis?.map((row) => (
                              <TableRow
                                key={row?._id}
                                className={`${seletedExpressSmi?._id === row._id ? "tablerow current" : "tablerow"}`}
                                onClick={async () => setSeletedExpressSmi(row)}
                              >
                                <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                                  <span>{row?.exp_order}</span>
                                </TableCell>
                                <TableCell className="table-cell left" style={{ maxWidth: "300px", gap: "5px" }}>
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`exp_smi_name_${row?._id}`}
                                      name={`exp_smi_name_${row?._id}`}
                                      type="text"
                                      value={row?.exp_smi_name}
                                      placeholder={t('name')}
                                      style={{ width: "100%" }}
                                      className="form-input-item table"
                                      onChange={(e) => handleExpressSmis(e.target.value, row._id, "exp_smi_name")}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="table-cell right" style={{ maxWidth: "100px", gap: "3px" }}>
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`exp_rate_${row?._id}`}
                                      name={`exp_rate_${row?._id}`}
                                      type="text"
                                      value={row?.exp_rate}
                                      onChange={(e) => handleExpressSmis(e.target.value, row?._id, 'exp_rate')}
                                      onBlur={() => handleExpressSmisBlur(row?._id, "exp_rate")}
                                      style={{ width: "100%", textAlign: "right" }}
                                      className="form-input-item table"
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`exp_rate_per_${row?._id}`}
                                      name={`exp_rate_per_${row?._id}`}
                                      type="text"
                                      value={row?.exp_rate_per}
                                      onChange={(e) => handleExpressSmis(e.target.value, row?._id, 'exp_rate_per')}
                                      onBlur={() => handleExpressSmisBlur(row?._id, "exp_rate_per")}
                                      style={{ width: "100%", textAlign: "right" }}
                                      className="form-input-item table"
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`exp_default_si_${row?._id}`}
                                      name={`exp_default_si_${row?._id}`}
                                      type="text"
                                      value={row?.exp_default_si}
                                      onChange={(e) => handleExpressSmis(e.target.value, row?._id, 'exp_default_si')}
                                      onBlur={() => handleExpressSmisBlur(row?._id, "exp_default_si")}
                                      style={{ width: "100%", textAlign: "right" }}
                                      className="form-input-item table"
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                  <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <input
                                      id={`exp_fcl_${row?._id}`}
                                      name={`exp_fcl_${row?._id}`}
                                      type="text"
                                      value={row?.exp_fcl_value}
                                      onChange={(e) => handleExpressSmis(e.target.value, row?._id, 'exp_fcl_value')}
                                      onBlur={() => handleExpressSmisBlur(row?._id, "exp_fcl_value")}
                                      style={{ width: "100%", textAlign: "right" }}
                                      className="form-input-item table"
                                    />
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                  :
                  <span style={{ textTransform: "uppercase" }} >{t('noVehicleFound', { param1: vehicleDialogRegnNo })}</span>
                }
              </div>
            )}
            {vehicleResultView === "VehicleFound" && (
              <motion.div
                className="vehicle-found"
                initial={{ opacity: 0, scale: 0, originX: 0.5, originY: 0.5 }}
                animate={{
                  opacity: 1,
                  scale: 1,
                  transition: { duration: 0.5 },
                }}
                exit={{ opacity: 0, scale: 0, transition: { duration: 0.5 } }}
                transition={{ type: "tween", duration: 0.5 }}
              >
                <span style={{ width: "500px" }}>
                  <p style={{ textTransform: "uppercase" }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`This vehicle <b>${vehicleDialogRegnNo}</b>  was Issued under below risk notes that are still active. You  cannot Proceed`) }} />
                </span>
                <div className="table-content">
                  <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                    <Table sx={{ width: "max-content", border: 'none' }}>
                      <TableHead className="tablehead">
                        <TableRow className="tablerow">
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            #
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "120px" }}  >
                            {t('noteNo')}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "350px" }}  >
                            {t('carrier')}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "100px" }}  >
                            {t('policyNo')}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "150px" }}  >
                            {t('expiryDate')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="tablebody">
                        {slicedVehicles.map((risk, index) => (
                          <TableRow key={risk._id} className="tablerow" >
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              <span>{index + 1}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "120px" }}  >
                              <span>{risk.risk_note_no_xx}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "350px" }}  >
                              <span>{risk.carrier_name_xx}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "100px" }}  >
                              <span>{risk.policy_no_xx}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "150px" }}  >
                              <span>{moment(risk.pr_to_date).format("DD-MMM-YYYY")}</span>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    {vehicleMatchingRisks?.length > rowsPerPageVehicles &&
                      <TablePagination
                        rowsPerPageOptions={[5]}
                        rowsPerPage={rowsPerPageVehicles}
                        onRowsPerPageChange={handleVehiclesRowsPerPage}
                        component="div"
                        count={vehicleMatchingRisks?.length}
                        rows={vehicleMatchingRisks}
                        page={currentVehiclesPage}
                        onPageChange={handleVehiclesPageChange}
                      />}
                  </TableContainer>
                </div>
              </motion.div>
            )}
            <div className="vehicle-check-action">
              {vehicleProceedButton && (
                <CustomLoadingButton currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="304FFE"
                  tooltip={t('continueWithUnderwriting')}
                  endIcon={<RiArrowRightDoubleFill />}
                  onClick={handleVehicleCheckProceed}>
                  {t('proceed')}
                </CustomLoadingButton>
              )}
            </div>
          </div>
        </motion.div>
      )
      }
      {/* endorsement view */}
      {endDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('endorsement').toUpperCase()}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setSelectedProductEnd(null);
                    setEndDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <span className="current-cover">CURRENT COVER PERIOD FROM {moment(plFmDate).format("DD-MMM-YYYY")} TO {moment(plToDate).format("DD-MMM-YYYY")}</span>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <label htmlFor="pe_end_code" style={{ width: "130px" }}>
                  {t('type').toUpperCase()}
                </label>
                <Select
                  id="pe_end_code"
                  name="pe_end_code"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="300px"
                  value={selectedProductEnd}
                  onChange={(selectedOption) => {
                    try {
                      // console.log(`selectedOption ${JSON.stringify(selectedOption, null, 2)}`);
                      setSelectedProductEnd(selectedOption);
                      setEndorsementDesc(selectedOption.pe_desc);

                      // internal code that determines the behaviour of the endorsement
                      // 000 New Business

                      if (["100", "200", "300"].includes(selectedOption.pe_internal_code)) {
                        // 100 Additional Premium
                        // 200 Refund
                        // 300 General Endorsement


                        const formattedFmDate = moment(new Date(Date.now())).format("YYYY-MM-DD");
                        const formattedToDate = moment(plToDate).format("YYYY-MM-DD");

                        setEndorsementFmDate(formattedFmDate);
                        setEndorsementToDate(formattedToDate);
                        setToggleEndorsementFmDate(false);
                        setToggleEndorsementToDate(true);

                        setEndorsementFmTitle(`${selectedOption.pe_name} EFFECTIVE FROM`);
                        setEndorsementToTitle(`UNTIL END OF COVER PERIOD`);

                        calculateDateDifferenceEnd(endorsementFmDate, endorsementToDate);

                      } else if (["400"].includes(selectedOption.pe_internal_code)) {
                        // 400 Period Extension


                        let formattedFmDate = moment(plToDate).format(
                          "YYYY-MM-DD"
                        );
                        formattedFmDate = addDaysToMongoDate(formattedFmDate, 1);
                        const formattedToDate = addDaysToMongoDate(formattedFmDate, 30);

                        setEndorsementFmDate(formattedFmDate);
                        setEndorsementToDate(formattedToDate);
                        setToggleEndorsementFmDate(true);
                        setToggleEndorsementToDate(false);

                        setEndorsementFmTitle(`${selectedOption.pe_name} STARTS FROM`);
                        setEndorsementToTitle(`${selectedOption.pe_name} TILL`);

                        calculateDateDifferenceEnd(endorsementFmDate, endorsementToDate);

                      } else if (["500"].includes(selectedOption.pe_internal_code)) {
                        // 500 Period Reduction

                        // set dates
                        const formattedFmDate = moment(new Date(Date.now())).format(
                          "YYYY-MM-DD"
                        );
                        const formattedToDate = addDaysToMongoDate(plToDate, 30, "s");

                        setEndorsementFmDate(formattedFmDate);
                        setEndorsementToDate(formattedToDate);
                        setToggleEndorsementFmDate(true);
                        setToggleEndorsementToDate(false);

                        setEndorsementFmTitle(`EFFECTIVE DATE OF ${selectedOption.pe_name}`);
                        setEndorsementToTitle(`COVER NOW ENDS ON`);

                        calculateDateDifferenceEnd(endorsementFmDate, endorsementToDate);

                      } else if (["600"].includes(selectedOption.pe_internal_code)) {
                        // 600 Renewal

                        // set dates
                        let formattedFmDate = moment(plToDate).format(
                          "YYYY-MM-DD"
                        );
                        formattedFmDate = addDaysToMongoDate(formattedFmDate, 1);
                        const formattedToDate = addMonthsToMongoDate(formattedFmDate, 12);

                        setEndorsementFmDate(formattedFmDate);
                        setEndorsementToDate(formattedToDate);
                        setToggleEndorsementFmDate(true);
                        setToggleEndorsementToDate(false);

                        setEndorsementFmTitle(`${selectedOption.pe_name} STARTS FROM`);
                        setEndorsementToTitle(`TILL`);

                        calculateDateDifferenceEnd(endorsementFmDate, endorsementToDate);

                      } else if (["700"].includes(selectedOption.pe_internal_code)) {
                        // 700 Cancellation

                        const formattedFmDate = moment(plToDate).format("YYYY-MM-DD");
                        const formattedToDate = moment(new Date(Date.now())).format("YYYY-MM-DD");
                        setEndorsementFmDate(formattedFmDate);
                        setEndorsementToDate(formattedToDate);
                        setToggleEndorsementFmDate(true);
                        setToggleEndorsementToDate(false);

                        setEndorsementFmTitle(`COVER WAS TO END ON`);
                        setEndorsementToTitle(`EFFECT ${selectedOption.pe_name} AS OF`);

                        calculateDateDifferenceEnd(endorsementFmDate, endorsementToDate);

                      } else if (["800"].includes(selectedOption.pe_internal_code)) {
                        // 800 Reinstatement

                        const formattedFmDate = moment(new Date(Date.now())).format("YYYY-MM-DD");
                        const formattedToDate = addDaysToMongoDate(formattedFmDate, 30);
                        setEndorsementFmDate(formattedFmDate);
                        setEndorsementToDate(formattedToDate);
                        setToggleEndorsementFmDate(true);
                        setToggleEndorsementToDate(false);

                        setEndorsementFmTitle(`${selectedOption.pe_name} STARTS FROM`);
                        setEndorsementToTitle(`TILL`);

                        calculateDateDifferenceEnd(endorsementFmDate, endorsementToDate);

                      } else if (["900"].includes(selectedOption.pe_internal_code)) {
                        // 900 Lapse
                        let formattedFmDate = moment(plToDate).format("YYYY-MM-DD");
                        formattedFmDate = addDaysToMongoDate(formattedFmDate, 1);
                        const formattedToDate = moment(plToDate).format("YYYY-MM-DD");
                        setEndorsementFmDate(formattedFmDate);
                        setEndorsementToDate(formattedToDate);
                        setToggleEndorsementFmDate(true);
                        setToggleEndorsementToDate(true);

                        setEndorsementFmTitle(`${selectedOption.pe_name} FROM`);
                        setEndorsementToTitle(`END OF COVER`);
                        calculateDateDifferenceEnd(endorsementFmDate, endorsementToDate);
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  options={productEnds}
                  isSearchable={true}
                  placeholder={t('type').toUpperCase()}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <div className="input-item-with-label">
                  <label htmlFor="pe_fm_date" style={{ width: "max-content", textTransform: "uppercase" }}>
                    {endorsementFmTitle}
                  </label>
                  <input
                    id="pe_fm_date"
                    name="pe_fm_date"
                    type="date"
                    placeholder={endorsementFmTitle}
                    value={endorsementFmDate}
                    className="form-input-item"
                    style={{ width: "150px" }}
                    onChange={handleEndFmDateChange}
                    disabled={toggleEndorsementFmDate}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <div className="input-item-with-label">
                  <label htmlFor="pe_to_date" style={{ width: "max-content", textTransform: "uppercase" }}>
                    {endorsementToTitle}
                  </label>
                  <input
                    id="pe_to_date"
                    name="pe_to_date"
                    type="date"
                    placeholder={endorsementToTitle}
                    value={endorsementToDate}
                    className="form-input-item"
                    style={{ width: "150px" }}
                    onChange={handleEndToDateChange}
                    disabled={toggleEndorsementToDate}
                  />
                </div>
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="pe_end_desc"
                  className="form-dropdown-label"
                  style={{ width: "130px", alignSelf: "flex-start" }}
                >
                  {t('remarks').toUpperCase()}
                </label>
                <textarea
                  id="pe_end_desc"
                  name="pe_end_desc"
                  type="text"
                  placeholder="DESCRIPTION"
                  value={endorsementDesc}
                  row={10}
                  className="form-input-item"
                  style={{ width: "300px" }}
                  onChange={(e) => setEndorsementDesc(e.target.value)}
                />
              </div>
            </div>
            <div className="overlay-actions">
              {selectedProductEnd?.pe_internal_code !== null &&
                !["300"].includes(selectedProductEnd?.pe_internal_code) &&
                <div className="input-item-with-label" style={{ display: "flex", width: "100%", alignSelf: "flex-start" }}>
                  <label htmlFor="pe_gl_date" style={{ width: "130px" }}>
                    {t('glDate').toUpperCase()} {selectedProductEnd?.pe_internal_code}
                  </label>
                  <input
                    id="pe_gl_date"
                    name="pe_gl_date"
                    type="date"
                    placeholder="DATE"
                    value={endorsementGlDate}
                    className="form-input-item"
                    style={{ width: "150px" }}
                    onChange={handleEndGlDateChange}
                    disabled={toggleEndorsementGlDate}
                  />
                </div>}
              <CustomLoadingButton currentTheme={currentTheme} onClick={handlePassEndorsement} disabled={!selectedProductEnd}>
                {t('proceed')}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {validationMsgDialog && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-content">
              <ValidationMessages
                messageData={validationMessagesResult}
                onClose={() => setValidationMsgDialog(false)}
                onFix={(row) => {/* focus field / navigate */ }}
                onRemind={() => setValidationMsgDialog(false)}
                onSupport={() => navigate("/support")}
              />
            </div>
          </div>
        </motion.div>
      )}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        </motion.div>)}
      {/* email component */}
      {emailDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span>{t('email').toUpperCase()}</span>
              <CircularButton currentTheme={currentTheme} onClick={() => setEmailDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} />
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={[]}
                documentData={{
                  docNo: plRiskNoteNo,
                  docType: plType,
                  docId: quoteId,
                  policy_docid: quoteId,
                  clientEmail: selectedInsured?.ent_email,
                  clientEntCode: selectedInsured?.value,
                  clientEntName: selectedInsured?.label?.props?.children[0],
                  clientPhoneNo: selectedInsured?.ent_phone_no || selectedCarrier?.ent_phone_no,

                  carrierEmail: selectedCarrier?.ent_email,
                  carrierEntCode: selectedCarrier?.value,
                  carrierEntName: selectedCarrier?.label?.props?.children[0],

                  to: selectedInsured?.insured_email_xx,
                  cc: `${selectedCarrier?.ent_email},${currentUser?.usr_email}`,
                  bcc: '',
                  subject: `${plRiskNoteNo}`,
                  doc_no: plRiskNoteNo,
                  doc_type: plType,
                  doc_id: quoteId,
                  entity_codes: [selectedInsured?.value, selectedCarrier?.value],
                  search_string: selectedInsured?.label + "," + selectedCarrier?.label + "," + plRiskNoteNo,
                  carrierName: selectedCarrier?.label,
                  productName: selectedProduct?.label,
                  clientName: selectedInsured?.label,
                  riskNoteNo: plRiskNoteNo,
                  daysToRenewal: quoteData?.expiring_in_days,
                  expiryDate: quoteData?.fmt_to_date,
                  insuredName: selectedInsured?.label,
                  outstandingPremium: quoteData?.outstandingPremium,
                  policyCurrency: plCurCode?.value,
                  policyNumber: plNo,
                  policyPremium: quoteData?.fmt_policy_fc_prem,
                  policyPremiumTotal: quoteData?.fmt_total_fc_prem,
                  policySumInsured: quoteData?.fmt_total_fc_si,
                  policyFromDate: quoteData?.fmt_fm_date,
                  policyToDate: quoteData?.fmt_to_date,

                  requestedAction: `${t('issueParam', { param1: quoteData?.end_name_xx })}`,
                  jurisdiction: plJurisdiction?.value,
                  financialInterestDetails: selectedFinancier?.ent_name || "None",
                  handlerName: currentUser?.usr_full_name,
                  handlerTitle: currentUser?.usr_title,
                  handlerPhone: currentUser?.usr_phone_no,
                  handlerEmail: currentUser?.usr_email,
                  todaysDate: moment().format("Do MMM YYYY HH:mm"),
                  defaultTemplate: quoteData?.end_email_template_xx,

                }}
                reportsList={quoteData?.product_reports_xx} />
            </div>
          </div>
        </motion.div>
      )}
      {isAddTaskDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{`${t('add').toUpperCase()} ${activityType?.label}`}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setActivityName("");
                    setActivityType({
                      value: "Task",
                      label: "Task",
                    });
                    setActivityDate(moment().format("YYYY-MM-DD"));
                    setActivityVenue("");
                    setActivityReminderDays(0);
                    setActivityDone("N");
                    setActivityUsers([]);
                    setIsAddTaskDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                {/* <label
                                  htmlFor="activity_type"
                                  className="form-dropdown-label"
                                  style={{ width: "100px" }}
                                >
                                  {t('type').toUpperCase()}
                                </label> */}
                <Select
                  ref={activityTypeRef}
                  id="activityType"
                  name="activityType"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="350px"
                  value={activityType}
                  onChange={(selectedOption) => setActivityType(selectedOption)}
                  options={activityTypes}
                  placeholder={t('type').toUpperCase()}
                />
              </div>
              <div className="input-item-with-label">
                {/* <label
                                  htmlFor="activityName"
                                  className="form-dropdown-label"
                                  style={{ width: "130px" }}
                                >
                                  {t('title').toUpperCase()}
                                </label> */}
                <input
                  id="activityName"
                  name="activityName"
                  type="text"
                  placeholder={t('title').toUpperCase()}
                  value={activityName}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  onChange={(e) => setActivityName(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                {/* <label htmlFor="activityDate" className="form-input-label" style={{ width: "max-content" }}>
                                  {t('dueDate').toUpperCase()}
                                </label> */}
                <input
                  id="activityDate"
                  name="activityDate"
                  type="date"
                  placeholder={t('dueDate').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={activityDate}
                  onChange={(e) => {
                    try {
                      const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                      setActivityDate(formattedDate);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                />
              </div>
              {activityType?.value !== "Task" &&
                <div className="input-item-with-label">
                  {/* <label
                                  htmlFor="activityName"
                                  className="form-dropdown-label"
                                  style={{ width: "130px" }}
                                >
                                  {t('title').toUpperCase()}
                                </label> */}
                  <input
                    id="activityVenue"
                    name="activityVenue"
                    type="text"
                    placeholder={t('venue').toUpperCase()}
                    value={activityVenue}
                    className="form-input-item"
                    style={{ width: "350px" }}
                    onChange={(e) => setActivityVenue(e.target.value)}
                  />
                </div>}
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                onClick={async (e) => {
                  try {
                    if (!activityType) {
                      setNotifyDialogTitle("Note!");
                      setNotifyDialogText(`Please select type`);
                      setIsNotifyDialogOpen(true);
                      return;
                    }

                    if (!activityName) {
                      setNotifyDialogTitle("Note!");
                      setNotifyDialogText(`Please enter title`);
                      setIsNotifyDialogOpen(true);
                      return;
                    }

                    if (!activityDate) {
                      setNotifyDialogTitle("Note!");
                      setNotifyDialogText(`Please select date`);
                      setIsNotifyDialogOpen(true);
                      return;
                    }

                    if (activityType?.value !== "Task" && !activityVenue) {
                      setNotifyDialogTitle("Note!");
                      setNotifyDialogText(`Please enter venue`);
                      setIsNotifyDialogOpen(true);
                      return;
                    }

                    const res = await newRequest.post(
                      "/uwPolicy/addActivity",
                      {
                        policy_docid: quoteData?._id,
                        activity_name: activityName,
                        activity_type: activityType?.value,
                        activity_date: activityDate,
                        activity_venue: activityVenue,
                        activity_reminder_days: activityReminderDays,
                        activity_users: activityUsers,
                        activity_done: activityDone
                      }
                    );

                    if (res.data?.msg === "added") {
                      setPlOpActivities((prevParams) => [...prevParams, res.data?.doc]);
                      setActivityType({
                        value: "Task",
                        label: "Task",
                      });
                      setActivityName("");
                      setActivityDate(moment().format("YYYY-MM-DD"));
                      setActivityVenue("");
                      setActivityReminderDays("");
                      setActivityUsers([]);
                      setActivityDone("N");
                      showToast(`Added`, "success");
                    } else {
                      showToast("Error adding task!", "error");
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >{t('add').toUpperCase()}</CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}

      {isManualPolicyNo && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('setPolicyNo').toUpperCase()}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setManualPolicyNo("");
                    setIsManualPolicyNo(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content" style={{ maxWidth: "500px" }}>
              <div className="input-item-with-label">
                <label
                  htmlFor="manualPolicyNo"
                  className="form-dropdown-label"
                  style={{ width: "80px" }}
                >
                  {t('policyNo').toUpperCase()}
                </label>
                <input
                  id="manualPolicyNo"
                  name="manualPolicyNo"
                  type="text"
                  placeholder={t('policyNo').toUpperCase()}
                  value={manualPolicyNo}
                  className="form-input-item"
                  style={{ width: "400px" }}
                  onChange={(e) => setManualPolicyNo(e.target.value)}
                />
              </div>
              <p className="caution-title">{t('policySetCaution')}</p>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                color="#66BB6A"
                endIcon={<FaArrowRight />}
                onClick={() => {
                  try {
                    if (!manualPolicyNo) {
                      setNotifyDialogTitle("Note!");
                      setNotifyDialogText(`Please enter the policy number`);
                      setIsNotifyDialogOpen(true);
                      return;
                    }
                    setObjectToAction({
                      object_id: quoteData._id,
                      action_text: `Proceed to set ${manualPolicyNo} as the policy number for this document?`,
                      new_doc_status: manualPolicyNo,
                    });
                    setOpenOptions(false);
                    setConfirmDialogAction("setPolicyNo");
                    setIsConfirmDialogOpen(true);
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >{t('set').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {receiptOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h3 className="sub-title">{t('allFieldsMandatory')}</h3>
              <CircularButton currentTheme={currentTheme} onClick={() => setReceiptOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content receipt">
              <Select
                id="receipt_paidto"
                name="receipt_paidto"
                menuPortalTarget={document.body}
                styles={{
                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                  menuPortal: base => ({
                    ...base,
                    zIndex: 9999,
                  })
                }}
                width="100%"
                value={selectedReceiptPaidTo}
                onChange={(selectedOption) => setSelectedReceiptPaidTo(selectedOption)}
                options={receiptPaidToOptions}
                isSearchable={false}
                placeholder="Paid To"
              />
              <div className="input-item-with-label">
                <label
                  htmlFor="receipt_mode"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('mode').toUpperCase()}
                </label>
                <Select
                  id="receipt_mode"
                  name="receipt_mode"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="170px"
                  value={selectedReceiptMode}
                  onChange={(selectedOption) => setSelectedReceiptMode(selectedOption)}
                  options={receiptModeOptions}
                  isSearchable={true}
                  placeholder={t('mode').toUpperCase()}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="receipt_cur"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('currency').toUpperCase()}
                </label>
                <input
                  id="receipt_cur"
                  name="receipt_cur"
                  type="text"
                  value={receiptCurrency}
                  className="form-input-item"
                  style={{ width: "170px" }}
                  disabled={true}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="receipt_no"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('receiptNo').toUpperCase()}
                </label>
                <input
                  id="receipt_no"
                  name="receipt_no"
                  type="text"
                  placeholder={
                    selectedReceiptPaidTo.value === "ToUs"
                      ? "AUTO GEN"
                      : "ENTER NO"
                  }
                  value={receiptNo}
                  className="form-input-item"
                  style={{ width: "170px" }}
                  disabled={selectedReceiptPaidTo.value === "ToUs"}
                  onChange={(e) => setReceiptNo(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="receipt_date"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('date').toUpperCase()}
                </label>
                <input
                  id="receipt_date"
                  name="receipt_date"
                  type="date"
                  value={receiptDate}
                  className="form-input-item"
                  style={{ width: "170px" }}
                  onChange={handleReceiptDateChange}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="ins"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('ins').toUpperCase()}
                </label>
                <Select
                  id="ins"
                  name="ins"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="170px"
                  dropdownHeight={4 * 42}
                  value={selectedInstallment}
                  onChange={(selectedOption) => {
                    try {
                      // console.log(`selectedOption  ${JSON.stringify(selectedOption, null, 2)}`);
                      setSelectedInstallment(selectedOption);

                      if (selectedOption?.os_fc_amount_xx > quoteData.total_os_fc_amount) {
                        setReceiptAmountFc(formatAmountsToDecimals(quoteData.total_os_fc_amount || 0, 2));
                        setReceiptAmountLc(formatAmountsToDecimals(quoteData.total_os_lc_amount || 0, 2));
                        // maximum amount that can be matched
                        setMaxMatchFcAmount(quoteData.total_os_fc_amount);
                        setMaxMatchLcAmount(quoteData.total_os_lc_amount);
                      } else {
                        setReceiptAmountFc(formatAmountsToDecimals(selectedOption?.os_fc_amount_xx || 0, 2));
                        setReceiptAmountLc(formatAmountsToDecimals(selectedOption?.os_lc_amount_xx || 0, 2));
                        // maximum amount that can be matched
                        setMaxMatchFcAmount(selectedOption?.os_fc_amount_xx);
                        setMaxMatchLcAmount(selectedOption?.os_lc_amount_xx);
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  options={installments}
                  isSearchable={true}
                  placeholder={t('ins').toUpperCase()}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="receipt_amount_fc"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('amount').toUpperCase()}
                </label>
                <input
                  id="receipt_amount_fc"
                  name="receipt_amount_fc"
                  type="text"
                  placeholder="0.00"
                  value={receiptAmountFc}
                  className="form-input-item"
                  style={{ width: "170px", textAlign: "right" }}
                  onChange={(e) =>
                    setReceiptAmountFc(e.target.value)
                  }
                  onBlur={(e) => {
                    try {
                      if (e.target.value) {
                        const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                        if (isNaN(strippedValue)) {
                          setNotifyDialogTitle("Error!");
                          setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                          setIsNotifyDialogOpen(true);
                          return;
                        }

                        // console.log(`strippedValue ... ${strippedValue}`);
                        // console.log(`maxMatchFcAmount ... ${parseFloat(formatStringToNumberV2(maxMatchFcAmount || 0, 2))}`);

                        if (strippedValue > parseFloat(formatStringToNumberV2(maxMatchFcAmount || 0, 2))) {
                          setNotifyDialogTitle("Error!");
                          setNotifyDialogText(`You cannot match more than <strong>${formatAmountsToDecimals(maxMatchFcAmount || 0, 2)}</strong>`);
                          setIsNotifyDialogOpen(true);
                          return;
                        }
                        const rate = parseFloat(quoteData?.pl_cur_rate || 1);
                        const lcAmount = parseFloat((strippedValue * rate).toFixed(4));
                        setReceiptAmountLc(lcAmount);
                      }
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                />
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                borderRadiusType="right"
                iconPosition="end"
                endIcon={<MdAdd />}
                onClick={handleAddReceipt}
              >
                {t('add').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {renStatusDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span className="sub-title">{t('renewalStatus')}</span>
              <CircularButton currentTheme={currentTheme} onClick={() => setRenStatusDialogOpened(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <span className='caution-title' style={{ maxWidth: "500px", marginBottom: "10px" }}>{t('renewalStatusDesc')}</span>
              <Select
                id="renewal_status"
                name="renewal_status"
                menuPortalTarget={document.body}
                styles={{
                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                  menuPortal: base => ({
                    ...base,
                    zIndex: 9999,
                  })
                }}
                width="100%"
                value={selectedRenStatus}
                onChange={(selectedOption) => setSelectedRenStatus(selectedOption)}
                options={renewalStatuses}
                placeholder={t('status')}
              />
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                borderRadiusType="right"
                color="#66BB6A"
                iconPosition="end"
                endIcon={<FaArrowRight />}
                onClick={async () => {
                  try {
                    if (!selectedRenStatus?.value) {
                      setNotifyDialogTitle(t('error'));
                      setNotifyDialogText("Please select status");
                      setIsNotifyDialogOpen(true);
                      return;
                    }
                    setRenStatusDialogOpened(false);
                    setIsProcessing(true);
                    await newRequest.put(
                      `/uwPolicy/upd/${quoteId}`,
                      {
                        pl_renewal_status: selectedRenStatus?.value,
                        policy_docid: quoteData._id,
                      }
                    );
                    handleDocumentChange("pl_renewal_status", selectedRenStatus?.value);
                    setIsProcessing(false);
                    showToast(t('renewalStatusResult', { param1: selectedRenStatus?.value }), "success");
                  } catch (error) {
                    setIsProcessing(false);
                    console.log(error);
                  }
                }}
              >
                {t('set').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {isConfettiActive && <Confetti />}
    </motion.div >
  );
};


export default UwPolicy;
